(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
    /**
     * Retrieves a data attribute from the element with the specified name.
     * If the attribute is not present, the provided default value is returned.
     *
     * @protected
     * @param {string} name - The name of the data attribute (without the `data-tk-` prefix).
     * @param {string} defaultValue - The default value to return if the attribute is not found.
     * @returns {string} - The value of the data attribute or the default value.
     */ getDataAttribute(name, defaultValue) {
        return this.getAttribute(`data-tk-${name}`) || defaultValue;
    }
}


var $588d148f2c9ac202$export$4120f82005ec4b2d = /*#__PURE__*/ function(TrackerPushTypes) {
    TrackerPushTypes["BASKET_UPDATE"] = "basket-update";
    TrackerPushTypes["FAVORITE_UPDATE"] = "favorite-update";
    return TrackerPushTypes;
}({});
class $588d148f2c9ac202$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.registry = {};
    }
    constructor(){
        super(), this.trackers = [];
        this.ready = new CustomEvent('tk-tracker-ready');
    }
    static registerTracker(name, factory) {
        this.registry[name] = factory;
    }
    async connectedCallback() {
        this.getTrackingIds();
        if (!this.trackerIds || this.trackerIds.length === 0) throw new Error('Trackier is not defined');
        await this.initTrackers();
        this.registerTrackingListener();
        this.dispatchEvent(this.ready);
    }
    registerTrackingListener() {
        const onTracking = this.handleTracking.bind(this);
        this.pushListener({
            event: 'tk-tracking-push',
            element: this,
            action: onTracking
        });
    }
    getTrackingIds() {
        try {
            this.trackerIds = JSON.parse(this.getAttribute('data-tk-trackers') || '[]');
        } catch (error) {
            console.error('Error parsing json', error);
        }
    }
    async initTrackers() {
        if (!this.trackerIds) return;
        for (const item of this.trackerIds)try {
            const createTracker = $588d148f2c9ac202$export$2e2bcd8739ae039.registry[item.name];
            if (createTracker) {
                const instance = await createTracker(item.key, {
                    endpoint: item.endpoint
                });
                await instance.init();
                this.trackers.push({
                    name: item.name,
                    instance: instance
                });
            } else console.warn(`Tracker "${item.name}" nicht gefunden.`);
        } catch (error) {
            console.error(`This tracker ${item.name} could not be initialized:` + error);
        }
    }
    handleTracking(event) {
        const { trackerType: trackerType, type: type, item: item } = event.detail;
        this.trackers.filter((trackerItem)=>!trackerType || trackerItem.name.toLowerCase() === trackerType.toLowerCase()).forEach((trackerItem)=>{
            if (type === "basket-update") trackerItem.instance.pushBasket(item);
            else if (type === "favorite-update") trackerItem.instance.pushFavorite(item);
            else trackerItem.instance.push(item);
        });
    }
}


class $26efcff9bda53fd7$export$2e2bcd8739ae039 {
    constructor(trackingId, tracker, defaultEndpoint, options){
        this.trackingId = trackingId;
        this.tracker = tracker;
        this.endpoint = options?.endpoint || defaultEndpoint;
        this.url = this.endpoint.replace(/%KEY/g, trackingId);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
        this.favoriteActionMap = options?.favoriteActionMap || {
            added: 'add',
            deleted: 'delete'
        };
    }
    loadScript() {
        return new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.async = true;
            script.src = this.url;
            script.onload = ()=>resolve(script);
            script.onerror = ()=>reject(new Error(`Failed to load script: ${this.url}`));
            document.head.appendChild(script);
        });
    }
}


class $4fa2285174eed561$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
    }
    init() {
        return new Promise((resolve, reject)=>{
            try {
                this.initGTM();
                this.loadScript().then(()=>{
                    console.log('Google Tag Manager successfully loaded');
                    resolve();
                }).catch((error)=>{
                    console.error('Error loading Google Tag Manager', error);
                    reject(error);
                });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }
    initGTM() {
        this.tracker.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }
    push(item) {
        const { event: event, ...rest } = item;
        this.tracker.push({
            event: event,
            ecommerce: {
                ...rest
            }
        });
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item)=>({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price,
                        quantity: item.quantity
                    }))
            }
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action],
                name: item.name,
                value: item.value
            }
        });
    }
}



class $30ee64c4b301d5a8$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove'
        };
    }
    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }
    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
    }
    push(item) {
        this.tracker.push(item);
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action],
            name: item.name,
            value: item.value
        });
    }
}


// Registry of tracker
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('google', async (trackingId, options)=>new (0, $4fa2285174eed561$export$2e2bcd8739ae039)(trackingId, options));
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('matomo', async (trackingId, options)=>new (0, $30ee64c4b301d5a8$export$2e2bcd8739ae039)(trackingId, options));


class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}



const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    rangeOverflow: 'Please select a value that is no more than {max}.',
    rangeUnderflow: 'Please select a value that is no less than {min}.',
    stepMismatch: 'Please select a value that is a multiple from {step}.',
    tooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    tooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    typeMismatch: 'The value you have entered for this field is invalid.',
    valueMissing: 'Please fill out this field.',
    // These properties must be empty.
    valid: '',
    customError: ''
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: 'The password does not match the one above.'
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}',
    existigName: 'This name {currentValue} already exists.'
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    },
    allRemoved: {
        code: '1-6-6240',
        text: 'All items removed'
    },
    empty: {
        code: '1-6-6240',
        text: 'Your article comparison is empty.'
    },
    importantTitle: {
        code: '1-6-6240',
        text: 'The most important information'
    },
    removed: {
        code: '1-6-6240',
        text: 'The article was successfully removed.'
    },
    added: {
        code: '1-6-6240',
        text: 'The article was successfully added.'
    },
    noAttributesFound: {
        code: '1-6-6240',
        text: 'No comparison attributes were found.'
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    },
    messageClipboard: {
        code: '1-6-6290',
        text: 'The text has been successfully saved to the clipboard.'
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    },
    messageDangerousString: {
        code: '1-6-6260',
        text: 'invalid character <.'
    },
    messageDisallowedCharacter: {
        code: '1-6-6260',
        text: 'Invalid character: %1'
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: '1-1-6280',
        text: 'Keine Ergebnisse gefunden.'
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false, shouldDecode = false)=>{
    if (!html) $2d540709c75492d4$var$render('<div></div>');
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (shouldDecode) return $2d540709c75492d4$var$render(doc.documentElement.textContent || '');
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
    return NotificationType;
}({});
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return '';
    if (response.pluginId === 'paymentType') {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === 'deliveryType') textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === 'checkoutAdressChange') textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = 'white')=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        'display: block'
    ].join(';');
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('green'));
        },
        ["Warning"] () {
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('yellow', 'black'));
        },
        ["Error"] () {
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('red'));
        },
        ["Info"] () {
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('blue'));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector('[data-tk-message-container]');
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement('beforeend', messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll('dialog[open]');
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add('tk-message--show');
    messageContainer.appendChild(toast);
    toast.addEventListener('animationend', (event)=>{
        if (event.animationName !== 'fadeout') return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $aa35ef9547ba682e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute('data-tk-event-name') || 'event-purchase';
        this.basketId = this.querySelector('[data-tk-otm-basket-id]') || undefined;
        this.messageContainerSelector = this.getAttribute('data-tk-message-container-selector') || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector('[data-tk-session-timeout-wrapper]') || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute('data-tk-session-time') || 0);
        this.firstItemToScrollInto = this.querySelector('[data-tk-scroll-into]') || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll('.Info');
        const errorMessage = messageContainer.querySelectorAll('.Error');
        const warningMessage = messageContainer.querySelectorAll('.Warning');
        const debugMessage = messageContainer.querySelectorAll('.Debug');
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || '';
            const code = item.querySelector('.was-message-code')?.textContent || '';
            const addition = item.querySelector('.was-message-addition')?.textContent || '';
            const wait = Number(item.querySelector('.was-message-wait')?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: 'event-purchase',
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector('[data-tk-otm-affiliation]');
        const revenue = this.querySelector('[data-tk-otm-revenue]');
        const tax = this.querySelector('[data-tk-otm-tax]');
        const shipping = this.querySelector('[data-tk-otm-shipping]');
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : '',
            revenue: revenue ? revenue.innerText : '',
            tax: tax ? tax.innerText : '',
            shipping: shipping ? shipping.innerText : ''
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll('[data-tk-otm-item]');
        Array.from(items).forEach((item)=>{
            const id = item.querySelector('.otm-id');
            const name = item.querySelector('.otm-name');
            const brand = item.querySelector('.otm-brand');
            const category = item.querySelector('.otm-category');
            const price = item.querySelector('.otm-price');
            const quantity = item.querySelector('.otm-quantity');
            const position = item.querySelector('.otm-position');
            data.push({
                id: id ? id.innerText : '',
                name: name ? name.innerText : '',
                brand: brand ? brand.innerText : '',
                category: category ? category.innerText : '',
                price: price ? price.innerText : '',
                quantity: quantity ? quantity.innerText : '',
                position: position ? position.innerText : ''
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute('data-tk-scroll-into-offset')) || 16;
        const mainContainer = this.querySelector('main');
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: 'smooth'
            });
        }, 0);
    }
}





const $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462 = (value)=>{
    const bytes = new TextEncoder().encode(value);
    return btoa(String.fromCharCode(...bytes));
};
const $fbcf93c2a0aa5bcb$export$c537b38001c583b7 = (base64)=>{
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};
const $fbcf93c2a0aa5bcb$var$isBase64 = (value)=>{
    try {
        return $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462($fbcf93c2a0aa5bcb$export$c537b38001c583b7(value)) === value;
    } catch  {
        return false;
    }
};
var $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039 = $fbcf93c2a0aa5bcb$var$isBase64;


const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = '/WebPortal/async.aspx';
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    // const data = window.atob(response.data);
    const data = (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(response.data);
    const html = document.createElement('div');
    html.innerHTML = data;
    const json = response.contentType === 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === 'ok',
        dataAsHtml: response.contentType === 'text/html' ? html.innerText : '',
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || '');
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = 'default', showMessages: showMessages = true })=>{
    const headers = new Headers({
        'x-requested-with': 'XMLHttpRequest',
        'response-type': 'json'
    });
    let body;
    if (payload) {
        headers.set('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? 'POST' : 'GET',
        headers: headers,
        cache: cache,
        credentials: 'include',
        body: body
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json') ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector('[data-tk-request-manager]');
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};


class $40898dd22403025f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.pages = [];
        this.navigationWrapper = document.querySelector('[data-tk-nav-wrapper]') || undefined;
        this.wrapper = this.querySelector('[data-tk-wrapper]') || undefined;
        this.openButton = document.querySelector(`[data-tk-nav-open="${this.id}"]`) || undefined;
        this.closeButton = document.querySelector(`[data-tk-nav-close="${this.id}"]`) || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'viewport__navigation--open';
        this.currentMenuId = this.getAttribute('data-tk-current-menu-id') || undefined;
        this.hasChildrenClassName = this.getAttribute('data-tk-has-children-class-name') || 'tk-nav-burger-item--has-children';
        this.asyncTemplateName = this.getAttribute('data-tk-nav-async-template-name') || 'tk-navigation-burgerlist';
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 1200;
        this.overlayClassName = this.getAttribute('data-tk-overlay-class-name') || 'viewport__overlay';
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.overlay = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class="${this.overlayClassName}"></div>`);
    }
    connectedCallback() {
        if (!this.currentMenuId) throw new Error('Current menu id is missing!');
        this.registerViewportListener();
        this.registerButtonListener();
        this.registerClickListener();
        this.isMobile && this.switchToMobile();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    registerButtonListener() {
        this.openButton?.addEventListener('click', this.openNavigation.bind(this));
        this.closeButton?.addEventListener('click', this.closeNavigation.bind(this));
    }
    registerClickListener() {
        this.addEventListener('click', this.handleClickLink.bind(this));
    }
    openNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.add(this.openClassName) : this.classList.add(this.openClassName);
        document.body.insertAdjacentElement('beforeend', this.overlay);
    }
    closeNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.remove(this.openClassName) : this.classList.remove(this.openClassName);
        const overlay = document.querySelector(`.${this.overlayClassName}`);
        overlay?.remove();
    }
    async handleClickLink(event) {
        if (!this.isMobile) return;
        event.preventDefault();
        const target = event.target;
        let element;
        if (target.hasAttribute('data-tk-nav-id')) element = target;
        else element = target.closest('[data-tk-nav-id]');
        if (!element) return;
        if (!element.parentElement?.classList.contains(this.hasChildrenClassName) && !element.parentElement?.hasAttribute('data-tk-nav-page')) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute('data-tk-nav-id');
        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }
    getTemplate(id) {
        const url = window.opacc.systemUrls?.async || '/WebPortal/async.aspx';
        const data = {
            type: 'navigation',
            navigationid: id,
            template: this.asyncTemplateName
        };
        return new Promise((resolve, reject)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>resolve(response),
                rejectHandler: (error)=>reject(error),
                payload: data
            });
        });
    }
    responseNextLevel(response) {
        if (!response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
        if (!html) return;
        const navigation = html.querySelector('[data-tk-nav-page]');
        if (!navigation) return;
        this.addPage(navigation);
        this.insertPage(navigation);
        $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(navigation);
        this.removeLastPageFromDOM();
    }
    insertPage(element) {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        pages.insertAdjacentElement('afterbegin', element);
    }
    addPage(element) {
        const id = element.getAttribute('data-tk-nav-page') || '';
        !this.existPage(id) && this.pages.push({
            id: id,
            element: element
        });
    }
    getPage(id) {
        return this.pages.find((page)=>page.id === id);
    }
    existPage(id) {
        if (id === '') return false;
        const foundPage = this.pages.filter((page)=>page.id === id);
        return foundPage.length > 0;
    }
    removeLastPageFromDOM() {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        const pageList = Array.from(pages.children);
        const oldPages = pageList.filter((element)=>element !== pages.firstElementChild);
        oldPages.forEach((element)=>element.remove());
    }
    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;
        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId);
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
            if (!html) throw new Error('Burgerlist: Root Element is missing!');
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector('[data-tk-nav-page]');
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = '';
            this.wrapper.insertAdjacentHTML('afterbegin', this.mobileView);
        }
    }
    async switchToDesktop() {
        if (!this.isMobileActive) return;
        this.isMobileActive = false;
        this.closeButton && (this.closeButton.hidden = true);
        if (!this.wrapper) return;
        this.mobileView = this.wrapper.innerHTML;
        if (!this.desktopView) return;
        this.wrapper.innerHTML = '';
        this.wrapper.insertAdjacentHTML('afterbegin', this.desktopView);
    }
    static jumpToPage(element) {
        element.scrollIntoView(false);
    }
}



class $1352bbad447b1dc9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.lastScrollPosY = 0, this.scrollWay = 0;
        this.header = this.querySelector('header') || undefined;
        if (!this.header) throw new Error('Header: Header is missing!');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.elementToScrollWith = this.querySelector('[data-tk-to-scroll-with]') || undefined;
        if (!this.elementToScrollWith) throw new Error('Header: Element to scroll with is missing! Use the [data-tk-to-scroll-with] selector.');
        this.maxHeightScrollWith = this.getMaxHeight();
        this.scrollDeltaY = Number(this.getAttribute('data-tk-scroll-delta-y')) || 1;
    }
    connectedCallback() {
        this.registerViewportListener();
        window.viewport.clientWidth < this.minWidthBreakpoint && this.registerScrollListener();
    }
    registerScrollListener() {
        if (!this.elementToScrollWith) return;
        const onScrolldown = this.handleScrolldown.bind(this);
        this.maxHeightScrollWith = this.getMaxHeight();
        this.pushListener({
            event: 'scroll',
            element: window,
            action: onScrolldown
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.minWidthBreakpoint) this.registerScrollListener();
        else this.removeListener(window);
    }
    handleScrolldown(event) {
        if (!(this.header && this.elementToScrollWith)) return;
        const { scrollY: scrollY } = event.currentTarget;
        if (scrollY > this.lastScrollPosY) {
            if (scrollY <= this.maxHeightScrollWith) this.scrollWay = scrollY;
            else this.scrollWay = this.maxHeightScrollWith;
        } else if (this.scrollWay > this.scrollDeltaY) this.scrollWay = this.lastScrollPosY - scrollY >= this.maxHeightScrollWith ? 0 : this.lastScrollPosY - scrollY;
        else this.scrollWay = 0;
        this.elementToScrollWith.style.transform = `translateY(-${this.scrollWay}px)`;
        this.lastScrollPosY = scrollY;
    }
    getMaxHeight() {
        if (!this.elementToScrollWith) return 0;
        const { paddingBottom: paddingBottom } = window.getComputedStyle(this.elementToScrollWith);
        const { height: height } = this.elementToScrollWith.getBoundingClientRect();
        return height - parseInt(paddingBottom, 10);
    }
}



class $49fab39bf1404505$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute('data-tk-resize-event-name') || 'tk-viewport-resize';
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = 'xs';
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}



// @ts-ignore Import module




var $96991178596c0a84$export$eb1b84084436143e = /*#__PURE__*/ function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
    return BasketAction;
}({});
class $96991178596c0a84$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector('[data-tk-basket-list]') || undefined;
        this.totalAmount = document.querySelector('[data-tk-basket-total-amount]') || undefined;
        this.miniBasket = document.querySelector('tk-minibasket') || undefined;
        this.emptyClassName = this.basketList?.getAttribute('data-tk-basket-empty-class-name') || 'module-basket--empty';
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: 'basket',
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith('tkSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === 'addall') {
            const quantities = $96991178596c0a84$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== '{}' && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector('[data-tk-basket-add-all-wrapper]');
        const articles = articleList?.querySelectorAll('article');
        articles?.forEach((article)=>{
            const id = article.getAttribute('data-tk-item-number');
            if (!id) return;
            const basketButton = article.querySelector('tk-basket-button');
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll('[data-tk-dimension]:not([hidden])');
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute('data-tk-dimension') || '';
                const fieldElement = dimension.querySelector('[data-tk-input-quantity]');
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || '0';
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector('[data-tk-input-quantity]');
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector('[data-tk-basket-dim-unit]');
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute('data-count', `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0 && document.querySelector('body[data-page="basket"]')) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector('[data-tk-basket-list]');
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector('[data-tk-basket-list-actions]');
            const deleteAllButton = html.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement('beforeend', deleteAllButton);
        }
        const footer = document.querySelector('[data-tk-basket-list-footer]');
        if (!footer) {
            const footerWrapper = html.querySelector('[data-tk-basket-list-footer]');
            footerWrapper && this.basketList.insertAdjacentElement('afterend', footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest('[data-tk-counter]');
        if (!wrapper) wrapper = target.closest('[data-tk-dimension]');
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector('[data-tk-counter-decreaser]');
        const incrementButton = wrapper.querySelector('[data-tk-counter-increaser]');
        const inputField = wrapper.querySelector('[data-tk-input-quantity]');
        if (!inputField) return;
        const step = Number(inputField.getAttribute('step') || 1);
        const min = Number(inputField.getAttribute('min') || step);
        const max = Number(inputField.getAttribute('max') || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = true;
        let operator = '+';
        if (incrementButton && target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        }
        if (event.key === 'ENTER') {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (artDimCheck > 0) {
            const multiplikator = $96991178596c0a84$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{currentValue}', String(oldValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
                operator = '+';
            }
        }
        const { value: value } = inputField;
        const valueNumber = Number(value);
        if (max !== 0 && valueNumber >= max && operator === '+') {
            inputField.value = String(max);
            if (valueNumber > max) {
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, 'Maximalmenge erreicht');
                return false;
            }
            if (currentTarget !== decrementButton && currentTarget !== incrementButton) return true;
            else return false;
        } else if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $96991178596c0a84$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || '');
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || '');
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || '');
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || '');
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || '');
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || '');
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = '+') {
        const multiplikator = $96991178596c0a84$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = currentVal * 10 ** multiplikator;
        const stepPow = step * 10 ** multiplikator;
        const minPow = min * 10 ** multiplikator;
        const maxPow = max * 10 ** multiplikator;
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            '-': ()=>$96991178596c0a84$export$2e2bcd8739ae039.calcMinus(currentVal, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            '+': ()=>$96991178596c0a84$export$2e2bcd8739ae039.calcPlus(currentVal, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow && (minPow > 0 ? newValuePow >= minPow : true) && (maxPow > 0 ? newValuePow <= maxPow : true)) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{step}', String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{max}', String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow < minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{min}', String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
}





var $bf823a090d476043$export$416096e8140b15df = /*#__PURE__*/ function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
    return BasketActionTypes;
}({});
class $bf823a090d476043$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $96991178596c0a84$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute('data-tk-action') || "add";
        this.button = this.querySelector('[data-tk-basket-button]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.variantWrapper = this.querySelector('[data-tk-basket-variants]') || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
            this.counters = this.querySelectorAll('[data-tk-input-quantity]');
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error('Basket: Button is missing!');
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: 'change',
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: 'change',
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                'refreshed-list': ()=>event.data && this.closeDialog(event.data),
                'refreshed-basket': ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        const qChanger = (0, $96991178596c0a84$export$2e2bcd8739ae039).quantityChanger(event);
        if (qChanger !== false) {
            console.log(this.closest('.tk-article--basket-tile'));
            const listItem = this.closest('.tk-article--basket-tile');
            const itemStock = listItem?.querySelector('[data-tk-basket-item-stock]');
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(()=>{
                this.button?.click();
                if (itemStock) {
                    const url = itemStock.getAttribute('data-stock-async-url');
                    console.log(url);
                    (0, $1653b55d89a7adce$export$24835cb787452b46)({
                        requestURL: url,
                        payload: {},
                        resolveHandler: this.replaceStock.bind(this)
                    });
                }
            }, 500);
        }
    }
    replaceStock(response) {
        if (!response || !response.success) return;
        const listItem = this.closest('.tk-article--basket-tile');
        const itemStock = listItem?.querySelector('[data-tk-basket-item-stock]');
        if (itemStock) itemStock.innerHTML = response.dataAsHtml;
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute('data-tk-art-dim-check-cd') === '1';
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace('{currentValue}', String(currentValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || '0';
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || '';
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || '';
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute('data-tk-min'));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute('data-tk-max'));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute('data-tk-step'));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute('data-tk-art-dim-check-cd') || '';
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector('[data-tk-input-quantity]');
            const nameElement = wrapper.querySelector('[data-tk-basket-dim-unit-name]');
            const unitElements = wrapper.querySelectorAll('[data-tk-basket-dim-unit]');
            if (!fieldElement) return;
            fieldElement.value = value !== '0' ? value : '';
            fieldElement.setAttribute('data-tk-art-dim-check-cd', getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute('min', String(getDimensionMin()));
            else fieldElement.removeAttribute('min');
            if (getDimensionMax() > 0) fieldElement.setAttribute('max', String(getDimensionMax()));
            else fieldElement.removeAttribute('max');
            if (getDimensionStep() > 0) fieldElement.setAttribute('step', String(getDimensionStep()));
            else fieldElement.removeAttribute('step');
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll('[data-tk-dimension]:not([hidden])');
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute('data-tk-dimension');
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute('data-tk-variant', selectedVariant.value);
    }
}



function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $259c506f0517ca0d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('[data-tk-context-button]');
        this.items = this.querySelector('[data-tk-context-items]') || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-context-menu--open';
        this.responsiveClassName = this.getAttribute('data-tk-responsive-class-name') || 'tk-context-menu--responsive';
        this.dropDownClassName = this.getAttribute('data-tk-dropdown-class-name') || 'tk-context-menu__dropdown';
        this.showAlways = this.hasAttribute('data-tk-show-always');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute('data-tk-context-offset')) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error('Context Menu: Elements are missing!');
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton() {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton();
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton();
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement('beforeend', copiedItems);
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    setPosition(element) {
        const button = this.getVisibleButton();
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    close(event) {
        const button = this.getVisibleButton();
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.copiedItems.classList.remove(this.openClassName);
            this.removeListener(window);
            this.resizeObserver.unobserve(document.body);
        }
    }
}



class $0d07f57cc5d15afe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorFlagItem = '[data-tk-flag-item]', this.selectorFlagIcon = '[data-tk-flag-icon]', this.selectorFlagLabel = '[data-tk-flag-label]', this.flagItems = [], this.removedFlagElements = [];
    }
    connectedCallback() {
        this.getAllFlags();
        if (this.flagItems.length < 1) return;
        this.appendSummarizedFlag();
    }
    getAllFlags() {
        const allFlagElements = this.querySelectorAll(this.selectorFlagItem) || undefined;
        // convert NodeList to Array
        const allFlags = Array.from(allFlagElements);
        // remove last Element (not needed for Tooltip-Flag)
        allFlags.pop();
        if (allFlags.length < 1) return;
        allFlags.forEach((item)=>{
            const iconElem = item.querySelector(this.selectorFlagIcon);
            const labelElem = item.querySelector(this.selectorFlagLabel);
            const singleFlagItem = {
                icon: iconElem?.outerHTML,
                label: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true' ? labelElem.innerHTML : '',
                showIcon: iconElem?.getAttribute(this.selectorFlagIcon.slice(1, -1)) === 'true',
                showLabel: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true'
            };
            this.flagItems.push(singleFlagItem);
            this.removedFlagElements.push(item);
            item.remove();
        });
    }
    getFlagDetails() {
        const returnVal = [];
        this.flagItems.forEach((elem)=>{
            let tooltipString;
            if (elem.showLabel) tooltipString = elem.showIcon ? `${elem.icon} ${elem.label}` : `${elem.label}`;
            else {
                const removedElement = this.removedFlagElements.shift();
                const removedElementLabel = removedElement?.querySelector('[data-tk-flag-label]')?.innerHTML;
                const tmpTooltipString = removedElementLabel || '';
                tooltipString = elem.showIcon ? `${elem.icon}` : tmpTooltipString;
            }
            returnVal.push(tooltipString);
        });
        return returnVal.join(', ').trim();
    }
    appendSummarizedFlag() {
        const tooltipTemplate = this.querySelector('[data-tk-flag-merged]');
        if (!tooltipTemplate) return;
        const clone = tooltipTemplate.content.cloneNode(true);
        const tooltipElement = clone.querySelector('[data-tk-tooltip-content]');
        if (!tooltipElement) return;
        tooltipElement.innerHTML = `+${this.flagItems.length}`;
        tooltipElement.setAttribute('data-tk-tooltip-content', this.getFlagDetails());
        this.prepend(clone);
    }
}




class $21ae20c5af7baedb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.productVariants = this.querySelector('[data-tk-product-variants]') || undefined;
    }
    connectedCallback() {
        if (!this.url) throw new Error('Product-Tile: No URL defined!');
        this.registerListener();
    }
    registerListener() {
        if (!this.productVariants) return;
        const switchProductVariantHandler = this.changeVariant.bind(this);
        this.pushListener({
            event: 'change',
            element: this.productVariants,
            action: switchProductVariantHandler
        });
    }
    changeVariant() {
        this.getProductVariant(this.productVariants.value);
    }
    getProductVariant(id) {
        const data = {
            article: id
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.switchProductVariant.bind(this),
            payload: data
        });
    }
    switchProductVariant(response) {
        if (!response || !response.success) return;
        this.insertAdjacentHTML('afterend', response.dataAsHtml);
        this.remove();
    }
}




class $21611c672b0d32ce$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorProductVariant = '[data-tk-product-variant]', this.selectorproductVariantFilters = '[data-tk-product-variant-filter]', this.selectorProductVariantList = '[data-tk-product-variant-list]', this.selectorProductVariantAttribute = '[data-tk-product-variant-attribute]', this.selectorProductVariantValue = '[data-tk-product-variant-value]', this.filteredOptions = [], this.selectionHistory = [];
        this.productVariantList = this.querySelector(this.selectorProductVariantList) || undefined;
        this.productVariantFilters = this.querySelectorAll(this.selectorproductVariantFilters) || undefined;
        this.productVariantsCollection = [];
        this.filteredCollection = [];
        this.noVariantFound = this.getAttribute('data-tk-product-variant-none') || 'NONE';
        this.disableSelectingFirst = this.hasAttribute('data-tk-disable-selecting-first');
        this.resetButton = this.querySelector('[data-tk-product-variants-reset]') || undefined;
        this.enableFilterInURL = this.hasAttribute('data-tk-enable-filter-in-url');
    }
    connectedCallback() {
        this.collectProductVariants();
        this.prepareVariantFilters();
        !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.productVariantsCollection);
        this.registerListener();
    }
    registerListener() {
        if (this.productVariantFilters) this.productVariantFilters.forEach((filter)=>{
            const filterListEventHandler = this.filterList.bind(this);
            this.pushListener({
                event: 'change',
                element: filter,
                action: filterListEventHandler
            });
        });
        if (this.productVariantsCollection.length > 0) this.productVariantsCollection.forEach((variant)=>{
            const getSelectedVariantValueHandler = this.getSelectedVariantValue.bind(this, variant.element);
            this.pushListener({
                event: 'change',
                element: variant.element,
                action: getSelectedVariantValueHandler
            });
        });
        const handleReset = this.handleReset.bind(this);
        this.resetButton && this.pushListener({
            event: 'click',
            element: this.resetButton,
            action: handleReset
        });
    }
    getSelectedVariantValue(variant) {
        this.setSelectedVariant(variant.getAttribute('data-tk-product-variant') || '');
    }
    filterList(event) {
        const selectedValues = this.getSelectedFilterValues();
        this.filteredCollection = this.productVariantsCollection.filter((element)=>{
            return Object.keys(selectedValues).every((key)=>{
                return selectedValues[key] === element.spec[key];
            });
        }) || [];
        this.updateProductVariantList();
        this.enableFilterInURL && this.setFilterInURL();
        event && this.filterOptions(event.currentTarget);
    }
    setFilterInURL() {
        const url = new URL(window.location.href);
        const selectedValues = this.getSelectedFilterValues();
        Object.keys(selectedValues).forEach((key)=>{
            url.searchParams.set(key, selectedValues[key]);
        });
        window.history.pushState(null, '', url.href);
    }
    handleReset() {
        this.productVariantsCollection.filter((item)=>item.id !== 'NONE').forEach((item)=>{
            item.element.hidden = false;
        });
        this.filteredOptions.forEach((item)=>{
            const { element: element } = item;
            if (!element) return;
            const optionList = Array.from(element.options);
            optionList.forEach((option)=>{
                option.hidden = false;
                option.selected = false;
            });
            element.disabled = item.options.size < 2;
            const firstOption = element.options.item(0);
            if (!firstOption) return;
            firstOption.selected = true;
        });
        if (!this.enableFilterInURL) return;
        const url = new URL(window.location.href);
        const { searchParams: searchParams } = url;
        this.filteredOptions.forEach((option)=>{
            const { attr: attr } = option;
            searchParams.has(attr) && searchParams.delete(attr);
        });
        window.history.pushState(null, '', url.href);
    }
    filterOptions(target) {
        const filteredList = this.filteredOptions.filter((item)=>item.element !== target);
        const currentValues = filteredList.map((filterOption)=>{
            const values = new Set();
            this.filteredCollection.forEach((item)=>{
                values.add(item.spec[filterOption.attr]);
            });
            return {
                attr: filterOption.attr,
                values: values
            };
        });
        filteredList.forEach((filterOption)=>{
            if (!filterOption.element) return;
            const { options: options } = filterOption.element;
            const optionList = Array.from(options);
            const values = currentValues.find((item)=>item.attr === filterOption.attr)?.values;
            if (!values) return;
            optionList.forEach((option)=>{
                option.hidden = false;
            });
            optionList.filter((option)=>option.value !== '').forEach((option)=>{
                option.hidden = !values.has(option.value);
            });
            filterOption.element.disabled = optionList.filter((item)=>!item.hidden && item.value !== '').length < 2;
        });
        const selectedOption = target.options.item(target.selectedIndex);
        if (!selectedOption) return;
        if (selectedOption.value === '') {
            this.enableLastSelection(target);
            return;
        }
        if (this.selectionHistory.at(-1) !== target) this.selectionHistory.push(target);
    }
    enableLastSelection(target) {
        if (this.selectionHistory.length < 1) return;
        const lastSelection = this.selectionHistory.at(-2);
        if (lastSelection === target) return;
        const index = this.filteredOptions.findIndex((item)=>item.element === lastSelection);
        const lastItem = this.filteredOptions.at(index);
        const lastElement = lastItem?.element;
        if (!lastElement) return;
        Array.from(lastElement.options).forEach((option)=>{
            option.hidden = false;
        });
        lastElement.disabled = false;
        lastElement.dispatchEvent(new Event('change'));
    }
    updateProductVariantList() {
        this.productVariantsCollection.forEach((variant)=>{
            variant.element.hidden = true;
        });
        this.filteredCollection.forEach((variant)=>{
            variant.element.hidden = false;
            if (variant.id === this.noVariantFound) variant.element.hidden = true;
        });
        if (this.filteredCollection.length > 0) !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.filteredCollection);
        else this.showNoVariantsFoundMessage();
    }
    selectFirstVariantInCollection(collection) {
        const hasSelectedElement = collection.some($21611c672b0d32ce$export$2e2bcd8739ae039.findFirstSelectedElement);
        if (hasSelectedElement) return;
        const input = collection.at(0)?.element.querySelector('input[type="radio"]');
        if (!input) return;
        input.checked = true;
        this.setSelectedVariant(input.value);
    }
    static findFirstSelectedElement(variant) {
        const input = variant.element.querySelector('input');
        if (!input) return false;
        return !input.hidden && input.checked;
    }
    setSelectedVariant(selectedValue) {
        this.selectedVariant = selectedValue;
    }
    showNoVariantsFoundMessage() {
        const noVariantFound = this.productVariantsCollection.filter((variant)=>variant.id === this.noVariantFound);
        if (noVariantFound) noVariantFound[0].element.hidden = false;
        this.setSelectedVariant('');
    }
    getSelectedFilterValues() {
        const selectedValues = {};
        this.productVariantFilters.forEach((filter)=>{
            if (filter.value !== '') {
                const selected = {
                    attr: filter.getAttribute('data-tk-product-variant-filter') || '',
                    value: filter.value
                };
                selectedValues[selected.attr] = selected.value;
            }
        });
        return selectedValues;
    }
    collectProductVariants() {
        const variants = this.productVariantList?.querySelectorAll(this.selectorProductVariant);
        variants?.forEach((element)=>{
            const variant = {
                id: element.getAttribute('data-tk-product-variant') || '',
                element: element,
                spec: this.getVariantSpecs(element)
            };
            this.productVariantsCollection.push(variant);
        });
    }
    prepareVariantFilters() {
        const filterAttribute = new Set();
        this.productVariantsCollection.forEach((variant)=>{
            Object.keys(variant.spec).forEach((key)=>filterAttribute.add(key));
        });
        filterAttribute.forEach((attr)=>{
            // filter undefined or null values
            const distinctOptions = new Set(this.productVariantsCollection.map((variant)=>variant.spec[attr]).filter(Boolean));
            const sortedOptions = new Set([
                ...distinctOptions
            ].sort());
            const selectElement = this.querySelector(`[data-tk-product-variant-filter="${attr}"]`) || undefined;
            this.filteredOptions.push({
                element: selectElement,
                attr: attr,
                options: sortedOptions
            });
        });
        this.filteredOptions.forEach((item)=>{
            if (!item.element) return;
            item.element.disabled = item.options.size < 2;
            const optionsHTML = [
                ...item.options
            ].map((option)=>{
                const urlParams = new URLSearchParams(window.location.search);
                const isSelected = urlParams.get(item.attr) === option;
                return `<option value="${option}" ${isSelected ? 'selected' : ''}>${option}</option>`;
            }).join('');
            let resultHTML = '';
            item.options.size > 1 ? resultHTML = `<option value="">${(0, $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc).all.text}</option>${optionsHTML}` : resultHTML = optionsHTML;
            item.element.insertAdjacentHTML('beforeend', resultHTML);
        });
        this.enableFilterInURL && this.filterList();
    }
    getVariantSpecs(variant) {
        const specs = variant.querySelectorAll(this.selectorProductVariantAttribute);
        const specCollection = {};
        specs.forEach((elem)=>{
            const spec = {
                attr: elem.getAttribute('data-tk-product-variant-attribute') || '',
                value: elem.getAttribute('data-tk-product-variant-value') || ''
            };
            specCollection[spec.attr] = spec.value;
        });
        return specCollection;
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}


function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement('div');
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, 'NodeList');
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, 'MouseEvent');
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c55de979aca75bc6$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTooltipContent = 'data-tk-tooltip-content', this.selectorTooltipOptions = 'data-tk-tooltip-options';
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || '{}';
        if (!this.tooltipContent) throw new Error('TK: Missing tooltip content');
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: 'tk-tooltip',
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}





const $f1a4dbe7c35f0ef9$var$group = (array, property)=>array.reduce((result, object)=>{
        const key = object[property];
        if (!result[key]) result[key] = [];
        result[key].push(object);
        return result;
    }, {});
var $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039 = $f1a4dbe7c35f0ef9$var$group;



const $4cfe9ec7fa1b3e1e$var$showDimmer = (elementToAttach, style)=>{
    if (elementToAttach) {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer tk-dimmer--attached"></div>');
        style && Object.keys(style).forEach((key)=>{
            dimmer.style.setProperty(key, style[key]);
        });
        elementToAttach.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    } else {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer"></div>');
        const dialog = Array.from(document.querySelectorAll('dialog[open]'));
        dialog.length > 0 ? dialog.at(-1)?.insertAdjacentElement('beforeend', dimmer) : document.body.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    }
};
var $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039 = $4cfe9ec7fa1b3e1e$var$showDimmer;



var $178b0b1cc6a532a3$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["RD_FILTER"] = "rd-filter";
    FilterType["URL_PARAM_FILTER"] = "url-param-filter";
    FilterType["SIMPLE_FILTER"] = "simple-filter";
    return FilterType;
}({});
class $178b0b1cc6a532a3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.observers = [];
        this.type = this.getAttribute('data-tk-filter-type') || "url-param-filter";
        this.groupId = this.getAttribute('data-tk-filter-group-id') || 'cat';
        this.pageLayout = this.getAttribute('data-tk-page-layout') || 'asyn';
        this.allowURLParamsPrefix = this.getAttribute('data-tk-allow-url-params-prefix') || 'cf-';
        this.filterGroupSelectedClassName = this.getAttribute('data-tk-filter-group-selected-class-name') || 'tk-filter-group--has-selected';
        this.filterList = [];
        this.filterURL = this.getAttribute('data-tk-filter-url') || undefined;
    }
    connectedCallback() {
        this.emit({
            action: 'STARTED',
            filterList: this.filterList
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.emit({
            action: 'ENDED',
            filterList: this.filterList
        });
    }
    subscribe(listener) {
        this.observers.push(listener);
    }
    emit(data) {
        this.observers.forEach((listener)=>{
            listener(data);
        });
    }
    add(filterList, isRange = false) {
        const property = this.type === "rd-filter" ? 'id' : 'attr';
        const selectedProperties = new Set(filterList.map((item)=>item[property]));
        selectedProperties.forEach((item)=>{
            this.deleteAllByProp(item);
        });
        if (isRange) {
            const filterValues = filterList.map((item)=>item.value);
            const filterItem = filterList.at(0);
            if (!filterItem) return;
            const { id: id, attr: attr } = filterItem;
            this.filterList.push({
                id: id,
                attr: attr,
                value: $178b0b1cc6a532a3$export$2e2bcd8739ae039.convertToMultiValue(filterValues)
            });
        } else filterList.forEach((item)=>{
            this.filterList.push(item);
        });
    }
    exist({ id: id, attr: attr, value: value }) {
        return this.type === "rd-filter" ? this.filterList.some((item)=>item.id === id && item.value === value) : this.filterList.some((item)=>item.attr === attr && item.value === $178b0b1cc6a532a3$export$2e2bcd8739ae039.neutralizeRangeValue(value));
    }
    delete({ id: id, attr: attr, value: value }) {
        const filteredList = this.filterList.filter((item)=>item.id !== id || item.value !== value || item.attr !== attr);
        this.filterList = filteredList;
    }
    deleteAllByProp(value) {
        const property = this.type === "rd-filter" ? 'id' : 'attr';
        const filteredList = this.filterList.filter((item)=>item[property] !== value);
        this.filterList = filteredList;
    }
    deleteAll() {
        this.filterList = [];
        this.emit({
            action: 'RESETTED',
            filterList: this.filterList
        });
    }
    post() {
        const preparedFilter = this.getPreparedFilter(this.type);
        const request = {
            requestURL: preparedFilter.url,
            resolveHandler: this.refreshResultList.bind(this)
        };
        if (this.type === "simple-filter") request.payload = preparedFilter.data;
        (0, $1653b55d89a7adce$export$24835cb787452b46)(request);
        this.emit({
            action: 'SENDED',
            filterList: this.filterList
        });
        if (this.type === "simple-filter") return;
        !this.filterURL && window.history.replaceState(null, '', preparedFilter.url);
        this.dimmer = (0, $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039)();
    }
    refreshResultList(response) {
        if (!response || !response.success) return;
        const currentContent = this.querySelector('[data-tk-filter-content]');
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newContent = html.querySelector('[data-tk-filter-content]');
        if (!currentContent || !newContent) return;
        currentContent.innerHTML = newContent.innerHTML;
        this.emit({
            action: 'REFRESHED',
            filterList: this.filterList
        });
        this.dimmer?.remove();
    }
    refreshDrilldown() {
        const groupedData = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, 'id');
        const list = [];
        Object.keys(groupedData).forEach((key)=>{
            const values = groupedData[key].map((obj)=>obj.value).join(', ');
            list.push({
                id: key,
                values: values
            });
        });
        this.resetFilterGroups(list.map((item)=>item.id));
        const preparedFilter = this.getPreparedFilter(this.type);
        const request = {
            requestURL: preparedFilter.url,
            resolveHandler: this.refreshDrilldownContent.bind(this)
        };
        if (this.type === "simple-filter") request.payload = preparedFilter.data;
        (0, $1653b55d89a7adce$export$24835cb787452b46)(request);
        this.emit({
            action: 'SENDED',
            filterList: this.filterList
        });
        if (this.type === "simple-filter") return;
        window.history.replaceState(null, '', preparedFilter.url);
    }
    refreshDrilldownContent(response) {
        if (!response || !response.success) return;
        const currentContent = this.querySelector('[data-tk-filter-group-wrapper]');
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newContent = html.querySelector('[data-tk-filter-group-wrapper]');
        const articleListContent = this.querySelector('[data-tk-article-list]');
        const articleListHTML = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newArticleListContent = articleListHTML.querySelector('[data-tk-article-list]');
        if (!currentContent || !newContent || !articleListContent || !newArticleListContent) return;
        currentContent.innerHTML = newContent.innerHTML;
        articleListContent.innerHTML = newArticleListContent.innerHTML;
        currentContent.sync();
        this.emit({
            action: 'REFRESHED-DRILLDOWN',
            filterList: this.filterList
        });
    }
    resetFilterGroups(filteredIds) {
        const filterGroupElements = this.querySelectorAll('[data-tk-filter-group-dropdown]');
        const filterGroupList = Array.from(filterGroupElements);
        const filteredList = filterGroupList.filter((element)=>!filteredIds.includes(element.getAttribute('data-tk-filter-group-dropdown') || ''));
        filteredList.forEach((element)=>{
            element.classList.remove(this.filterGroupSelectedClassName);
            const selectedElement = element.querySelector('[data-tk-filter-group-selected]');
            if (!selectedElement) return;
            selectedElement.textContent = '';
        });
    }
    getPreparedFilter(type) {
        const handlers = {
            'rd-filter': this.prepareRDFilter.bind(this),
            'url-param-filter': this.prepareQueryFilter.bind(this),
            'simple-filter': this.prepareSimpleFilter.bind(this)
        };
        return handlers[type]();
    }
    prepareRDFilter() {
        const groupedArray = this.getGroupedFilterArrayValue('id');
        const jsonString = JSON.stringify(groupedArray);
        const data = {};
        data[this.groupId] = jsonString;
        const urlData = {};
        // urlData[this.groupId] = window.btoa(jsonString);
        urlData[this.groupId] = (0, $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462)(jsonString);
        const url = Object.keys(groupedArray).length > 0 ? this.mergeURLParamsByData(urlData) : this.mergeURLParamsByData(urlData, true);
        return {
            data: data,
            url: url.href
        };
    }
    prepareQueryFilter() {
        const data = this.getGroupedFilter('attr', ',');
        const urlParams = this.getGroupedFilter('attr', '|');
        const url = this.mergeURLParams(urlParams);
        return {
            data: data,
            url: url.href
        };
    }
    prepareSimpleFilter() {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, 'id');
        const jsonString = JSON.stringify(groupedArray);
        const data = {};
        data.selection = jsonString;
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        url.searchParams.set('pagelayout', this.pageLayout);
        return {
            data: data,
            url: url.href
        };
    }
    getGroupedFilter(property, separator) {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, property);
        const result = {};
        Object.keys(groupedArray).forEach((key)=>{
            const values = groupedArray[key].map((obj)=>obj.value).join(separator);
            result[key] = values;
        });
        return result;
    }
    getGroupedFilterArrayValue(property) {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, property);
        const result = {};
        Object.keys(groupedArray).forEach((key)=>{
            const values = groupedArray[key].map((obj)=>obj.value);
            result[key] = values;
        });
        return result;
    }
    mergeURLParamsByData(data, shouldReset = false) {
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        const searchParamList = Array.from(url.searchParams);
        const filteredList = searchParamList.filter((item)=>!item[0].startsWith(this.groupId));
        const existingParams = Object.fromEntries(filteredList);
        const mergedParams = shouldReset ? {
            ...existingParams
        } : {
            ...data,
            ...existingParams
        };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }
    mergeURLParams(selectedParams) {
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        const allowedList = this.allowURLParamsPrefix.split(',');
        const searchParamList = Array.from(url.searchParams);
        const filteredList = searchParamList.filter((item)=>allowedList.every((allowed)=>!item[0].startsWith(allowed)));
        const existingParams = Object.fromEntries(filteredList);
        const mergedParams = {
            ...selectedParams,
            ...existingParams
        };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }
    static convertToMultiValue(multivalues) {
        return `[${multivalues.join('|')}]`;
    }
    static neutralizeRangeValue(value) {
        if (value.includes('[') || value.includes(']')) return value.replaceAll('[', '').replaceAll(']', '');
        return value;
    }
    static mergeURLs(relativeURL) {
        if (!relativeURL) return;
        const baseURL = new URL(window.location.href);
        const mergedURL = new URL(relativeURL, baseURL.origin);
        mergedURL.search = baseURL.search;
        return mergedURL;
    }
}



class $c51b1a9a7c03f7bf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.chip = this.querySelector('[data-tk-filter-chip-remove]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.chip || !this.dataset.tkFilterChipId || !this.dataset.tkFilterChipAttribute || !this.dataset.tkFilterChipValue) return;
        this.filterItem = {
            id: this.dataset.tkFilterChipId,
            attr: this.dataset.tkFilterChipAttribute,
            value: this.dataset.tkFilterChipValue
        };
        this.registerClickListener();
        this.registerFilterListener();
    }
    registerClickListener() {
        const handleRemoveChip = this.removeFilterItem.bind(this);
        this.pushListener({
            event: 'click',
            element: this.chip,
            action: handleRemoveChip
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED') {
                if (!this.tkFilter?.exist(this.filterItem)) this.remove();
            }
        });
    }
    removeFilterItem() {
        this.tkFilter?.delete(this.filterItem);
        this.tkFilter?.post();
    }
}



class $4e5f7d9c5ffa7d20$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.removeAll = this.querySelector('[data-tk-filter-result-remove]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        this.registerClickListener();
        this.registerFilterListener();
    }
    registerClickListener() {
        const handleRemoveAll = this.removeFilterItems.bind(this);
        this.pushListener({
            event: 'click',
            element: this.removeAll,
            action: handleRemoveAll
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED') {
                if (data.filterList.length === 0) this.remove();
            }
        });
    }
    removeFilterItems() {
        this.tkFilter?.deleteAll();
        this.tkFilter?.post();
    }
}




class $058daee80809af6c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
        this.tkFilterGroup = this.closest('[data-tk-filter-group]') || undefined;
        this.filterForm = this.querySelector('form') || undefined;
        this.applyButton = this.querySelector('[data-tk-filter-apply]') || undefined;
        this.counterElement = this.querySelector('[data-tk-filter-dropdown-counter]') || undefined;
        this.hasItemsClassName = this.getAttribute('data-tk-has-items-class-name') || 'tk-filter-dropdown--has-items';
    }
    connectedCallback() {
        if (!this.dataset.tkFilterDropdownId || !this.dataset.tkFilterDropdownAttribute || !this.filterForm || !this.applyButton) return;
        if (this.checkFilterItems()) this.setupFilterList();
        this.registerListener();
        this.registerFilterListener();
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action !== 'REFRESHED-DRILLDOWN' || !this.counterElement) return;
            const filteredList = data.filterList.filter((item)=>item.id === this.getAttribute('data-tk-filter-dropdown-id'));
            this.counterElement.textContent = String(filteredList.length);
            this.classList.toggle(this.hasItemsClassName, filteredList.length > 0);
        });
    }
    registerListener() {
        const handleFilterSubmit = this.performFilter.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.filterForm,
            action: handleFilterSubmit
        });
        const handleFilterApply = this.applyFilterItem.bind(this);
        this.pushListener({
            event: 'click',
            element: this.applyButton,
            action: handleFilterApply
        });
    }
    setupFilterList() {
        const data = this.getFormData();
        data.length > 0 && this.addFilterItems(data);
    }
    applyFilterItem() {
        const data = this.getFormData();
        if (data.length > 0) this.addFilterItems(data);
        else this.tkFilter?.deleteAllByProp(this.tkFilter?.type === (0, $178b0b1cc6a532a3$export$c67e46de1ec7dfa6).RD_FILTER ? this.dataset.tkFilterDropdownId : this.dataset.tkFilterDropdownAttribute);
        this.tkFilter?.refreshDrilldown();
    }
    performFilter(event) {
        event.preventDefault();
        const data = this.getFormData();
        if (data.length > 0) this.addFilterItems(data);
        else this.tkFilter?.deleteAllByProp(this.tkFilter?.type === (0, $178b0b1cc6a532a3$export$c67e46de1ec7dfa6).RD_FILTER ? this.dataset.tkFilterDropdownId : this.dataset.tkFilterDropdownAttribute);
        this.tkFilter?.post();
    }
    getFormData() {
        const formData = new FormData(this.filterForm);
        const fieldElements = this.filterForm?.querySelectorAll('input, select');
        if (!fieldElements) return [];
        const ignoreFieldElements = Array.from(fieldElements).filter((element)=>element.hasAttribute('data-tk-ignore-field') && !element.closest('[data-tk-filter-dropdown-is-range]'));
        const ignoreFieldNames = ignoreFieldElements.map((field)=>field.getAttribute('name') || '');
        ignoreFieldNames.forEach((name)=>formData.delete(name));
        const dataList = Array.from(formData.entries());
        return dataList.filter((item)=>item[1].toString() !== '').map((item)=>{
            const value = item[1].toString();
            return {
                key: item[0],
                value: value
            };
        });
    }
    checkFilterItems() {
        const data = this.getFormData();
        return Object.keys(data).length > 0;
    }
    addFilterItems(data) {
        this.clearFilterCollection();
        data.forEach((item)=>{
            this.filterCollection.push({
                id: this.dataset.tkFilterDropdownId,
                attr: this.dataset.tkFilterDropdownAttribute,
                value: item.value
            });
        });
        this.tkFilter?.add(this.filterCollection, this.hasAttribute('data-tk-filter-dropdown-is-range'));
    }
    clearFilterCollection() {
        this.filterCollection = [];
    }
}



class $6deb510fe3e19897$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.groupsShowingCount = 0, this.groupCount = 0;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
        this.moreGroupWrapperClassName = this.getAttribute('data-tk-filter-group-wrapper-more-class') || 'tk-filter-group-wrapper--expand';
        this.collapseButton = this.querySelector('[data-tk-filter-group-collapse]') || undefined;
        this.expandButton = this.querySelector('[data-tk-filter-group-expand]') || undefined;
        this.closeDrilldownButtons = this.querySelectorAll('[data-tk-close-drilldown]') || undefined;
        this.resizeObserver = new ResizeObserver(this.checkResize.bind(this));
        this.drilldownClassName = this.getAttribute('data-tk-drilldown-class-name') || 'tk-filter-group-wrapper--drilldown';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-filter-group-wrapper--loaded';
    }
    connectedCallback() {
        if (!this.tkFilter || !this.collapseButton || !this.expandButton) throw new Error('TK Filter: Element is missing!');
        this.resizeObserver.observe(this);
        this.registerClickListener();
        this.classList.add(this.loadedClassName);
    }
    sync() {
        this.collapseButton = this.querySelector('[data-tk-filter-group-collapse]') || undefined;
        this.expandButton = this.querySelector('[data-tk-filter-group-expand]') || undefined;
        this.closeDrilldownButtons = this.querySelectorAll('[data-tk-close-drilldown]') || undefined;
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
        this.registerClickListener();
    }
    registerClickListener() {
        const handleCollapseGroups = this.collapseFilterGroups.bind(this);
        this.pushListener({
            event: 'click',
            element: this.collapseButton,
            action: handleCollapseGroups
        });
        const handleExpandGroups = this.expandFilterGroups.bind(this);
        this.pushListener({
            event: 'click',
            element: this.expandButton,
            action: handleExpandGroups
        });
        const handleCloseDrilldown = this.closeDrilldown.bind(this);
        this.closeDrilldownButtons.length > 0 && this.closeDrilldownButtons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: handleCloseDrilldown
            });
        });
    }
    collapseFilterGroups() {
        this.classList.remove(this.moreGroupWrapperClassName);
        this.hideCollapseButton();
        this.showExpandButton();
    }
    expandFilterGroups() {
        this.classList.add(this.moreGroupWrapperClassName);
        this.hideExpandButton();
        this.showCollapseButton();
        this.showAllGroups();
    }
    closeDrilldown() {
        this.classList.remove(this.drilldownClassName);
    }
    showExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.hidden = false;
    }
    hideExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.hidden = true;
    }
    showCollapseButton() {
        if (!this.collapseButton) return;
        this.collapseButton.hidden = false;
    }
    hideCollapseButton() {
        if (!this.collapseButton) return;
        this.collapseButton.hidden = true;
    }
    showAllGroups() {
        const childrenList = this.getFilteredGroups();
        childrenList.forEach((element)=>{
            element.hidden = false;
        });
    }
    checkResize(entries) {
        entries.forEach(()=>{
            this.checkGroupLength();
        });
    }
    checkGroupLength() {
        this.showAllGroups();
        this.optimizeGroups();
    }
    optimizeGroups() {
        if (this.classList.contains('tk-filter-group-wrapper--drilldown')) return;
        this.expandButton && (this.expandButton.hidden = true);
        let { scrollWidth: scrollWidth } = this;
        const { width: width, right: right } = this.getBoundingClientRect();
        if (width >= scrollWidth) return;
        scrollWidth = this.scrollWidth;
        const childrenList = this.getFilteredGroups();
        const closestHiddenChild = childrenList.find((child)=>{
            const childRect = child.getBoundingClientRect();
            const childRight = childRect.right;
            return right < childRight;
        });
        if (!closestHiddenChild) return;
        this.expandButton && (this.expandButton.hidden = false);
        const index = childrenList.indexOf(closestHiddenChild);
        this.groupsShowingCount = index - 1;
        this.trimGroupsToMaxCount(childrenList, this.groupsShowingCount);
    }
    getFilteredGroups() {
        return Array.from(this.querySelectorAll('[data-tk-filter-group]'));
    }
    trimGroupsToMaxCount(childrenList, maxShowingGroup) {
        const difference = this.groupCount - maxShowingGroup;
        const lastChildren = childrenList.slice(difference * -1);
        lastChildren.forEach((element)=>{
            element.hidden = true;
        });
    }
}




class $668e651a8805c9ff$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.isDrilldownActive = false;
        this.wrapper = this.closest('[data-tk-filter-group-wrapper]') || undefined;
        this.isOpenClass = this.getAttribute('data-tk-filter-group-show-class') || 'tk-filter-dropdown--open';
        this.drilldownDropdownClassName = this.getAttribute('data-tk-filter-drilldown-dropdown-class-name') || 'tk-filter-dropdown--drilldown';
        this.filterDropdown = this.querySelector(`#${this.getAttribute('data-tk-filter-group-dropdown')}`) || undefined;
        this.offset = Number(this.getAttribute('data-tk-filter-group-dropdown-offset')) || 4;
        this.drilldownClassName = this.getAttribute('data-tk-drilldown-class-name') || 'tk-filter-group-wrapper--drilldown';
        this.backButton = this.querySelector('[data-tk-filter-dropdown-jump-back]') || undefined;
    }
    connectedCallback() {
        if (!this.filterDropdown || !this.wrapper) return;
        this.attachClickListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.filterDropdown?.remove();
    }
    attachClickListener() {
        const handleDropdownVisibility = this.toggleDropdown.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleDropdownVisibility
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
        if (!this.backButton) return;
        const handleCloseDropdown = this.closeDropdown.bind(this);
        this.pushListener({
            event: 'click',
            element: this.backButton,
            action: handleCloseDropdown
        });
    }
    toggleDropdown() {
        this.isDrilldownActive = this.wrapper.classList.contains(this.drilldownClassName);
        this.resetDropdownVisibility();
        if (this.filterDropdown.hidden) {
            document.body.insertAdjacentElement('beforeend', this.filterDropdown);
            this.filterDropdown.hidden = false;
            this.filterDropdown.classList.add(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown.classList.add(this.drilldownDropdownClassName);
            this.alignDropdownToButton();
        } else {
            this.filterDropdown.hidden = true;
            this.filterDropdown.classList.remove(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown.classList.remove(this.drilldownDropdownClassName);
            this.insertAdjacentElement('beforeend', this.filterDropdown);
        }
    }
    closeDropdown() {
        this.filterDropdown.classList.remove(this.isOpenClass);
    }
    resetDropdownVisibility() {
        const openDropdowns = document.querySelectorAll('[data-tk-filter-dropdown]');
        const dropdownsToClose = Array.from(openDropdowns).filter((dropdown)=>dropdown !== this.filterDropdown);
        dropdownsToClose.forEach((dropdown)=>{
            dropdown.hidden = true;
            dropdown.classList.remove(this.isOpenClass);
        });
    }
    alignDropdownToButton() {
        const { bottom: bottom, left: left } = this.getBoundingClientRect();
        this.filterDropdown.style.top = `${bottom + window.scrollY + this.offset}px`;
        this.filterDropdown.style.left = `${left + window.scrollX}px`;
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    close(event) {
        if (!this.filterDropdown) return;
        const buttonRect = this.getBoundingClientRect();
        const dropdownRect = this.filterDropdown.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.filterDropdown.hidden = true;
            this.filterDropdown.classList.remove(this.isOpenClass);
            this.removeListener(window);
        }
    }
}



class $c0415a55fc888360$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.existsMessage = false;
        this.wrapper = this.closest('[data-tk-filter-dropdown]') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.lastChildClassName = this.getAttribute('data-tk-last-child-class-name') || 'tk-filter-select--last-child';
    }
    connectedCallback() {
        if (!this.wrapper || !this.fieldElement) throw new Error('Filter-Search: Element is missing!');
        this.registerInputListener();
    }
    registerInputListener() {
        const onInput = this.filter.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onInput
        });
    }
    filter(event) {
        const filterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        const search = event.target;
        this.resetAll();
        if (!filterTypes || !search) return;
        const value = search.value.toLowerCase();
        const { children: children } = filterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const element = child;
            const input = element.querySelector('input');
            const label = element.querySelector('label');
            element.hidden = !input?.value.toLowerCase().includes(value) && !label?.textContent?.toLowerCase().includes(value) || false;
        });
        const visibleChilds = childList.filter((item)=>{
            const element = item;
            return !element.hidden;
        });
        filterTypes.classList.toggle(this.lastChildClassName, visibleChilds.length === 1);
        if (visibleChilds.length === 0) {
            if (this.existsMessage) return;
            const messageElement = $c0415a55fc888360$export$2e2bcd8739ae039.createMessage();
            filterTypes.insertAdjacentElement('beforebegin', messageElement);
            this.existsMessage = true;
        } else if (this.existsMessage) {
            const messageElement = this.wrapper?.querySelector('.tk-message');
            if (!messageElement) return;
            messageElement.remove();
            this.existsMessage = false;
        }
    }
    resetAll() {
        const fiterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children: children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const element = child;
            element.hidden = false;
        });
    }
    static createMessage() {
        const emptyInfo = document.createElement('div');
        emptyInfo.classList.add('tk-message', 'tk-message--info', 'tk-message--fullwidth');
        emptyInfo.textContent = window.opacc.tkFilterMessages?.emptyResult.text || '';
        return emptyInfo;
    }
}



class $f21079be2cdb055f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.wrapper = this.closest('[data-tk-filter-dropdown]') || undefined;
        this.button = this.querySelector('button') || undefined;
    }
    connectedCallback() {
        if (!this.button) throw new Error('Select Reset: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.reset.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    reset() {
        const fiterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children: children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const input = child.querySelector('input');
            if (!input) return;
            input.checked = false;
        });
    }
}



class $b604e9d6535c82d7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.openDrilldownClass = this.getAttribute('data-tk-filter-drilldown-open-class') || 'tk-filter-group-wrapper--drilldown';
        this.activeFilterClass = this.getAttribute('data-tk-filter-drilldown-active-class') || 'tk-filter-drilldown-button--active';
        this.activeFilterCountWrapper = this.querySelector('[data-tk-filter-drilldown-button-count]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.activeFilterCountWrapper || !this.tkFilter) return;
        this.tkFilterGroupWrapper = this.tkFilter.querySelector('[data-tk-filter-group-wrapper]') || undefined;
        if (!this.tkFilterGroupWrapper) return;
        this.registerClickListener();
        this.registerFilterListener();
        this.updateFilterCount();
        this.hidden = !this.isFilterAvailable();
    }
    registerClickListener() {
        const handleDrilldownToggle = this.toggleDrilldown.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleDrilldownToggle
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED-DRILLDOWN') this.updateFilterCount();
        });
    }
    toggleDrilldown() {
        this.tkFilterGroupWrapper.classList.add(this.openDrilldownClass);
        this.tkFilterGroupWrapper.showAllGroups();
    }
    updateFilterCount() {
        const activeFilters = [
            ...new Set(this.tkFilter.filterList.map((filter)=>filter.id))
        ];
        if (activeFilters.length > 0) {
            this.activeFilterCountWrapper.innerHTML = `${activeFilters.length}`;
            this.classList.add(this.activeFilterClass);
        } else {
            this.activeFilterCountWrapper.innerHTML = '';
            this.classList.remove(this.activeFilterClass);
        }
    }
    isFilterAvailable() {
        if (!this.tkFilter) return false;
        return this.tkFilter.querySelectorAll('[data-tk-filter-group]').length > 0;
    }
}







class $1ccb7c18f671f1de$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasStartedSync = false;
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.service = this.getAttribute('data-tk-service') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.sort = this.getAttribute('data-tk-sort') || '';
        this.key = this.getAttribute('data-tk-key') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.isServiceClassName = this.getAttribute('data-tk-is-service-class-name') || 'tk-price--has-service';
        this.isPromotionClassName = this.getAttribute('data-tk-is-promotion-class-name') || 'tk-price--has-promotion';
    }
    connectedCallback() {
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        if (this.articleList && this.loadingType !== '2' && !this.isAsyncTile) this.sendDataToArticleList();
        else this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    registerHoverListener() {
        const onHover = this.handlePrice.bind(this);
        this.pushListener({
            event: 'mouseover',
            element: this,
            action: onHover
        });
    }
    hover() {
        this.hasStartedSync = true;
        this.handlePrice();
    }
    sendDataToArticleList() {
        this.item && this.articleList.addPrice(this.item);
    }
    handlePrice() {
        if (!this.item) return;
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsJSONString([
            this.item
        ]) : $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            this.item
        ]);
        const data = {
            type: 'price',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleResponse.bind(this),
            payload: data
        });
    }
    static getItemsAsEntrypoint(data) {
        const articles = [];
        data.forEach((item)=>{
            articles.push(item.articleId);
        });
        return {
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                service: item.service,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                loadingtype: item.loadingType,
                sort: item.sort,
                key: item.key,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshPrice(item, responseItem);
    }
    handleError(error) {
        this.hasStartedSync = false;
        throw new Error(error);
    }
    refreshPrice(item, responseItem) {
        const conditions = [
            {
                condition: responseItem.basispriceisset,
                selector: '[data-tk-price-basic]',
                className: undefined
            },
            {
                condition: responseItem.servicepriceisset,
                selector: '[data-tk-price-service]',
                className: this.isServiceClassName
            },
            {
                condition: responseItem.promopriceisset,
                selector: '[data-tk-price-promotion]',
                className: this.isPromotionClassName
            }
        ];
        const { selector: selector, className: className } = conditions.find(({ condition: condition })=>condition) || {};
        if (!selector) return;
        const element = this.querySelector(selector);
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        if (element) element.innerHTML = htmlString;
        else this.innerHTML = htmlString;
        className && this.classList.add(className);
    }
}





class $ad2181492f474118$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.stockType = this.getAttribute('data-tk-stock-type') || '';
        this.stockLocation = this.getAttribute('data-tk-stock-location') || '';
        this.dispo = this.getAttribute('data-tk-dispo') || '';
        this.dispoDate = this.getAttribute('data-tk-dispo-date') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.stockPeriodType = this.getAttribute('data-tk-stock-period-type') || '1';
        this.artUnitType = this.getAttribute('data-tk-art-unit-type') || '3';
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && !this.isAsyncTile) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    sendDataToArticleList(item) {
        this.articleList.addStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsJSONString([
            item
        ]) : $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    static getItemsAsEntrypoint(data) {
        const items = [];
        const articles = [];
        data.forEach((item)=>{
            items.push([
                item.articleId,
                item.stockType,
                item.stockLocation,
                item.stockPeriodType,
                item.dispoDate,
                item.artUnitType
            ].join(','));
            articles.push(item.articleId);
        });
        return {
            items: items.join(','),
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                stocktype: item.stockType,
                stockloc: item.stockLocation,
                dispo: item.dispo,
                dispodate: item.dispoDate,
                loadingtype: item.loadingType,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshStock(item, responseItem);
    }
    refreshStock(item, responseItem) {
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}


var $6406837936bc2cfc$var$ArticleDataType = /*#__PURE__*/ function(ArticleDataType) {
    ArticleDataType["PRICE"] = "price";
    ArticleDataType["STOCK"] = "stock";
    return ArticleDataType;
}($6406837936bc2cfc$var$ArticleDataType || {});
class $6406837936bc2cfc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.prices = [], this.stocks = [], this.isCustomPriceURL = false, this.isCustomStockURL = false;
    }
    addPrice(item) {
        this.prices.push(item);
        this.handlePrice();
    }
    addStock(item) {
        this.stocks.push(item);
        this.handleStock();
    }
    handlePrice() {
        const elements = this.querySelectorAll('[data-tk-price-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.prices.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomPriceURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshPriceData.bind(this),
            payload: this.getPreparedData("price")
        });
    }
    handleStock() {
        const elements = this.querySelectorAll('[data-tk-stock-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.stocks.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomStockURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshStockData.bind(this),
            payload: this.getPreparedData("stock")
        });
    }
    getPreparedData(type) {
        return {
            type: type,
            ...this.getListByType(type)
        };
    }
    getListByType(type) {
        const handler = {
            price: ()=>this.getPriceData(),
            stock: ()=>this.getStockData()
        };
        return handler[type]();
    }
    getPriceData() {
        const items = this.isCustomPriceURL ? (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.prices) : (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsJSONString(this.prices);
        return items;
    }
    getStockData() {
        const items = this.isCustomStockURL ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.stocks) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString(this.stocks);
        return items;
    }
    refreshPriceData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.prices.length) return;
        const list = response.dataAsJson.items;
        this.prices.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshPrice(item, responseItem);
        });
    }
    refreshStockData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.stocks.length) return;
        const list = response.dataAsJson.items;
        this.stocks.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshStock(item, responseItem);
        });
    }
}









/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ var $2215c02a950e9fbf$var$DialogActions = /*#__PURE__*/ function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    return DialogActions;
}($2215c02a950e9fbf$var$DialogActions || {});
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.dialogs = [], this.currentDialog = 0, this.shouldOpen = false, this.closeOnBackdropClick = true;
        this.tag = this.getAttribute('data-tk-tag') || 'dialog';
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.shouldOpen = this.hasAttribute('data-tk-open');
        this.closeOnBackdropClick = this.hasAttribute('data-tk-close-on-backdrop-click') ? JSON.parse(this.getAttribute('data-tk-close-on-backdrop-click')) : true;
        this.shouldMaxWidth = this.hasAttribute('data-tk-should-max-width');
        this.dialogClassName = this.getAttribute('data-tk-dialog-class-name') || 'tk-dialog';
        this.dialogInnerClassName = this.getAttribute('data-tk-dialog-inner-class-name') || 'tk-dialog__inner';
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close';
        this.maxWidthClassName = this.getAttribute('data-tk-max-width-class-name') || 'tk-dialog--max-width';
        this.formDataString = this.getAttribute('data-tk-form-data') || undefined;
        this.isPopup = this.hasAttribute('data-tk-is-popup');
        this.isConfirm = this.hasAttribute('data-tk-is-confirm');
        this.confirmTitle = this.getAttribute('data-tk-confirm-title') || undefined;
        this.confirmDescription = this.getAttribute('data-tk-confirm-description') || undefined;
        this.confirmCancelIcon = this.getAttribute('data-tk-confirm-cancel-icon') || 'cross';
        this.confirmCancelLabel = this.getAttribute('data-tk-confirm-cancel-label') || undefined;
        this.confirmSubmitIcon = this.getAttribute('data-tk-confirm-submit-icon') || 'check';
        this.confirmSubmitLabel = this.getAttribute('data-tk-confirm-submit-label') || undefined;
        this.forceReloadContent = this.hasAttribute('data-tk-force-reload-content');
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: 'submit',
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.forceReloadContent ? 0 : this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event, this.forceReloadContent);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, this.forceReloadContent));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialogItem.dialog, this.forceReloadContent);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || '{}');
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute('data-tk-url');
        if (!url) throw new Error('Dialog: URL is missing!');
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute('data-tk-dialog-jump-to'));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute('data-tk-switch-to-next');
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = 'tk-dialog', closeClassName: closeClassName = 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close', innerClassName: innerClassName = 'tk-dialog__inner', content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel, forceClosing: forceClosing } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, forceClosing));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add('tk-dialog--open');
    }
    static close(element, forceClosing = false) {
        forceClosing && $2215c02a950e9fbf$export$2e2bcd8739ae039.destoryInstances(element);
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove('tk-dialog--open');
            element.dispatchEvent(new Event('close'));
        }
        const contextMenus = element.querySelectorAll('[data-tk-context-menu]');
        contextMenus.forEach((menu)=>menu.close());
        forceClosing && element.remove();
    }
    static closeDialogIfOutside(element, event, forceClosing = false) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $2215c02a950e9fbf$export$2e2bcd8739ae039.close(element, forceClosing);
    }
    checkAutoOpen() {
        if (!this.shouldOpen) return;
        this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector('[data-tk-dialog-content]');
        dialogInner.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(openDialog);
        this.hookAfterShowModal(openDialog);
    }
    static destoryInstances(element) {
        const richtexts = element.querySelectorAll('[data-cms-richtext]');
        const datepickers = element.querySelectorAll('[data-tk-form-datepicker]');
        richtexts.forEach((richtext)=>{
            const item = richtext;
            item.editors?.forEach((editor)=>{
                editor.destroy();
            });
        });
        datepickers.forEach((datepicker)=>{
            datepicker.flatpickr?.destroy();
        });
    }
}




var $2c226fea39ede692$var$Actions = /*#__PURE__*/ function(Actions) {
    Actions["ADD"] = "add";
    Actions["ADDED"] = "added";
    Actions["DELETED"] = "deleted";
    Actions["MOVED"] = "moved";
    Actions["MOVE"] = "move";
    return Actions;
}($2c226fea39ede692$var$Actions || {});
class $2c226fea39ede692$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.artBoId = this.getAttribute('data-tk-art-bo-id') || '';
        this.user = this.getAttribute('data-tk-art-bo-user') || '';
        this.type = this.getAttribute('data-tk-type') || '';
        this.artNumber = this.getAttribute('data-tk-art-number') || '';
        this.asyncCountId = this.getAttribute('data-tk-async-count-id') || '';
        this.multiFavoritesAction = this.getAttribute('data-tk-multi-favorites-action') || '';
        this.onList = this.getAttribute('data-tk-on-list') || '';
        this.saldocBoIdTarget = this.getAttribute('data-tk-saldoc-bo-id-target') || '';
        this.saldocBoIdSource = this.getAttribute('data-tk-saldoc-bo-id-source') || '';
        this.maxList = Number(this.getAttribute('data-tk-max-list'));
        this.maxPosition = Number(this.getAttribute('data-tk-max-position'));
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-button--selected';
        this.listName = this.getAttribute('data-tk-list-name') || '';
        this.selectedOption = Number(this.getAttribute('data-tk-selected-option')) || 1;
        this.isGuestUser = this.hasAttribute('data-tk-guest-user');
    }
    connectedCallback() {
        if (!this.button) throw new Error('Favorite: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.send.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    async send(event) {
        const formValidator = this.closest('[data-tk-form-validator]');
        const formElement = formValidator?.form;
        if (formElement) {
            const formData = new FormData(formElement);
            const optionElements = formElement.querySelectorAll('input[name="favorite-option"]');
            const optionElementList = Array.from(optionElements);
            const selectedOptionIndex = optionElementList.findIndex((element)=>element.checked);
            // if the selected option is `existing`, then take the `saldocBoIdTarget`
            if (selectedOptionIndex === this.selectedOption) {
                const selectElement = formElement.querySelector('select');
                const selectedOption = selectElement?.selectedOptions.item(0);
                this.saldocBoIdTarget = selectedOption?.getAttribute('data-tk-saldoc-bo-id-target') || '';
            }
            if (this.listName === '') {
                const { length: length } = formData.getAll('field-name');
                this.listName = length > 1 ? formData.getAll('field-name')?.at(selectedOptionIndex)?.toString() || '' : formData.get('field-name')?.toString() || '';
            } else this.listName = formData.get('field-name')?.toString() || '';
            if (this.multiFavoritesAction === "added" || this.multiFavoritesAction === "moved") this.checkMaximum(formElement, selectedOptionIndex);
        }
        const isFormValid = await formValidator?.isFormValid();
        if (formValidator && !isFormValid) return;
        const data = {
            Type: 'favorite',
            ArtFavorite_ArtNo: this.artNumber,
            ArtFavorite_ArtBoId: this.artBoId,
            ArtFavorite_ListName: this.listName,
            ArtFavorite_MultiAction: this.multiFavoritesAction,
            ArtFavorite_OnList: this.onList,
            ArtFavorite_SalDocBoIdSource: this.saldocBoIdSource,
            ArtFavorite_SalDocBoIdTarget: this.saldocBoIdTarget,
            maxLists: String(this.maxList),
            maxPositions: String(this.maxPosition)
        };
        Object.keys(this.dataset).filter((key)=>key.startsWith('opSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.dataset[key];
        });
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this, event),
            payload: data,
            showMessages: false
        });
    }
    refreshContent(event, response) {
        if (!response) return;
        if (response.success && response.messages?.length === 0 && (response.dataAsJson.action === "add" || response.dataAsJson.action === "move")) {
            if (response.dataAsJson.isGuest && this.listName !== '') {
                const html = document.createElement('div');
                html.innerHTML = response.dataAsJson.message;
                const favoriteButton = html.querySelector('[data-tk-saldoc-bo-id-target]');
                const saldocBoIdTarget = favoriteButton?.getAttribute('data-tk-saldoc-bo-id-target');
                const saldocBoId = favoriteButton?.getAttribute('data-tk-saldoc-bo-id');
                saldocBoIdTarget && (this.saldocBoIdTarget = saldocBoIdTarget);
                this.multiFavoritesAction = "added";
                this.setAttribute('data-tk-on-list', `#${saldocBoId}#`);
                this.setAttribute('data-tk-saldoc-bo-id-target', this.saldocBoIdTarget);
                this.send(event);
            } else {
                const { message: message } = response.dataAsJson;
                const dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
                    content: message,
                    className: 'tk-dialog tk-dialog--max-width',
                    tag: 'dialog'
                });
                const favoriteButton = dialog.querySelector('tk-favorite-button');
                if (favoriteButton) favoriteButton.addButton = this;
                dialog.showModal();
                this.pushListener({
                    event: 'close',
                    element: dialog,
                    action: ()=>dialog.remove()
                });
            }
        } else {
            const dialog = this.closest('dialog');
            const { action: action, artBoId: artBoId, favoriteCount: favoriteCount } = response.dataAsJson;
            action !== "added" && dialog?.close();
            const actionHandler = {
                added: ()=>this.addedItem(response),
                deleted: ()=>this.deleteArticle(artBoId, response),
                moved: ()=>this.deleteArticle(artBoId, response),
                ["add"] () {
                    throw new Error('Function not implemented.');
                },
                ["move"] () {
                    throw new Error('Function not implemented.');
                }
            };
            actionHandler[action]();
            if (response.dataAsJson.isGuest) return;
            $2c226fea39ede692$export$2e2bcd8739ae039.syncInfo(favoriteCount);
        }
    }
    addedItem(response) {
        const { messages: messages } = response;
        const dialog = this.closest('dialog');
        // check for empty value
        if (!response.dataAsJson.salDocName) return;
        dialog?.close();
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
        if (this.addButton) {
            this.addButton.setAttribute('data-tk-on-list', response.dataAsJson.onList);
            this.addButton.button.classList.add(this.activeClassName);
            this.addButton.onList = response.dataAsJson.onList;
        }
        this.button.setAttribute('data-tk-on-list', response.dataAsJson.onList);
        this.button.classList.add(this.activeClassName);
        this.onList = response.dataAsJson.onList;
        this.saldocBoIdTarget = response.dataAsJson.salDocBoIdTarget;
        this.setAttribute('data-tk-multi-favorites-action', 'added');
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        if (this.isGuestUser) {
            this.setAttribute('data-tk-multi-favorites-action', 'deleted');
            this.multiFavoritesAction = "deleted";
        }
        this.pushTrackItem(response.dataAsJson);
    }
    deleteArticle(id, response) {
        const article = document.querySelector(`[data-tk-article-id="${id}"]`);
        if (!article) return;
        if (article.getAttribute('data-tk-item-number')) {
            article.remove();
            const contextMenu = this.closest('[data-tk-context-items]');
            if (!contextMenu) return;
            contextMenu.remove();
            $2c226fea39ede692$export$2e2bcd8739ae039.syncCounter();
        }
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        this.button?.removeAttribute('data-tk-on-list');
        this.button?.classList.remove(this.activeClassName);
        this.removeAttribute('data-tk-on-list');
        this.setAttribute('data-tk-multi-favorites-action', 'add');
        this.multiFavoritesAction = "add";
        this.saldocBoIdTarget = '';
        const { messages: messages } = response;
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
    }
    checkMaximum(formElement, selectedOptionIndex) {
        // if the selected option is `existing`, check positions
        const selectElement = formElement.querySelector('select');
        const selectedOption = selectElement?.selectedOptions.item(0);
        const countPositions = Number(selectedOption?.getAttribute('data-tk-saldoc-count-positions'));
        if (selectedOptionIndex === 0 && countPositions > this.maxPosition) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Positionen.');
            throw new Error('Rechead maximum of positions in this list');
        } else if ((selectElement?.options.length || 0) > this.maxList) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Listen.');
            throw new Error('Rechead maximum of lists');
        }
    }
    pushTrackItem(data) {
        const { action: action, artNo: artNo } = data;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).FAVORITE_UPDATE,
                item: {
                    action: action,
                    location: window.location.href,
                    category: 'Wishlist',
                    name: artNo,
                    value: '1'
                }
            }
        }));
    }
    static syncCounter() {
        const counterElement = document.querySelector('[data-tk-favorite-counter]');
        const listElement = document.querySelector('[data-tk-article-list-grid]');
        if (!counterElement || !listElement) return;
        counterElement.textContent = String(listElement.childElementCount);
    }
    static syncInfo(quantity) {
        const infoElement = document.querySelector('[data-tk-favorite-info]');
        if (!infoElement) return;
        infoElement.setAttribute('data-tk-quantity', String(quantity));
    }
    static updateItemsCount(action) {
        // TODO: After the next WAS update, the item count should be included in the response when not logged in. Until then workaround with + 1
        const favoriteInfoElement = document.querySelector('[data-tk-favorite-info]');
        if (!favoriteInfoElement) return;
        const previousItemscount = favoriteInfoElement.getAttribute('data-tk-quantity') ? parseInt(favoriteInfoElement.getAttribute('data-tk-quantity'), 10) : 0;
        favoriteInfoElement.setAttribute('data-tk-quantity', (action === "deleted" ? previousItemscount - 1 : previousItemscount + 1).toString());
    }
}








class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute('data-tk-zip-list-class') || 'tk-form-zipcity__list';
        this.fieldCountry = this.querySelector('[data-tk-zip-country]') || undefined;
        this.fieldZip = this.querySelector('[data-tk-zip-zip]') || undefined;
        this.fieldCity = this.querySelector('[data-tk-zip-city]') || undefined;
        this.lastSearchTerm = '';
        this.selectedField = undefined;
        this.listWrapper = document.createElement('div');
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: 'click',
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: 'change',
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === 'Tab' || event.code === 'Enter' || event.code === 'ArrowDown')) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove('hide');
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = 'unset';
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement('afterend', this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || 'ch';
        const arr = value.split(' ');
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = '';
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || '';
        }
        zip = zip.toString();
        city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
        }
        this.listWrapper.style.border = '';
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest('[data-tk-zip]');
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute('data-tk-zip');
        const city = selectedItem.getAttribute('data-tk-city');
        const country = selectedItem.getAttribute('data-tk-country');
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = '';
        this.fieldZip.value = '';
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
    static async isValidZipCity(form) {
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const zipCityElem = {
            country: form.querySelector('[data-tk-zip-country]') || '',
            zip: form.querySelector('[data-tk-zip-zip]') || '',
            city: form.querySelector('[data-tk-zip-city]') || ''
        };
        const zipCityValue = {
            country: zipCityElem.country.value,
            zip: zipCityElem.zip.value,
            city: zipCityElem.city.value
        };
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCityValue).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: urlObject.toString(),
                decodeJSONResponse: false,
                resolveHandler: (response)=>{
                    let isValid = false;
                    if (Array.isArray(response)) response.some((item)=>{
                        isValid = $cb17fd7e698c018c$export$2e2bcd8739ae039.shallowObjectEquality(zipCityValue, item);
                        return isValid;
                    });
                    resolve(isValid);
                }
            });
        });
    }
    static shallowObjectEquality(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        let isEqual = true;
        if (keys1.length !== keys2.length) {
            isEqual = false;
            return isEqual;
        }
        keys1.forEach((key)=>{
            if (object1[key] !== object2[key]) {
                isEqual = false;
                return isEqual;
            }
        });
        return isEqual;
    }
}


var $40812120dfc15f21$var$matchType = /*#__PURE__*/ function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
    return matchType;
}($40812120dfc15f21$var$matchType || {});
class $40812120dfc15f21$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.validationList = [];
        this.form = this.querySelector('form') || undefined;
        this.fieldWrapperSelector = this.getAttribute('data-tk-field-wrapper-selector') || '[data-tk-field-wrapper]';
        this.formErrorClassName = this.getAttribute('data-tk-form-error-class-name') || 'tk-form--error';
        this.fieldHintClassName = this.getAttribute('data-tk-field-hint-class-name') || 'tk-form__hint';
        this.shouldValidateInline = this.hasAttribute('data-tk-should-validate-inline');
        this.passwordStrengthMeter = this.querySelector('[data-tk-password-strength-meter]') || undefined;
        this.passwordNewElement = this.querySelector('[data-tk-password-new]') || undefined;
        this.passwordRepeatElement = this.querySelector('[data-tk-password-repeat]') || undefined;
        this.passwordValidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--valid';
        this.passwordInvalidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--invalid';
        this.googleRecaptcha = this.querySelector('[data-tk-google-recaptcha]') || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute('data-tk-enter-data-attribute-selector') || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        window.addEventListener('fields-added', this.reConnectedCallback.bind(this));
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    reConnectedCallback() {
        console.log('reConnectedCallback');
        this.validationList.forEach((validationItem)=>{
            this.removeMessage(validationItem);
        });
        this.removeListener(window);
        this.validationList = [];
        this.searchFieldElements();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll('input, select, textarea');
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $40812120dfc15f21$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: 'input',
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: 'input',
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: 'blur',
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: 'input',
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute('data-tk-site-key');
                if (!siteKey) return resolve(false);
                const token = await grecaptcha.execute(siteKey, {
                    action: 'submit'
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateZipCity() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-zip-city]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const input = element.querySelector('input');
            if (!input) return true;
            const isValid = await (0, $cb17fd7e698c018c$export$2e2bcd8739ae039).isValidZipCity(this.form);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-api]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute('data-tk-field-check-api');
            const input = element.querySelector('input');
            if (!input || !apiURL || input.value === '') return true;
            const response = await $40812120dfc15f21$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const { isValid: isValid } = response.dataAsJson;
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector('button')?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI() && await this.validateZipCity();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $40812120dfc15f21$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || '' : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement('span');
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $40812120dfc15f21$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement('beforeend', spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = 'data-tk-error-msg-';
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, '').replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            '{minLength}': element.getAttribute('minlength') || '',
            '{maxLength}': element.getAttribute('maxlength') || '',
            '{length}': element.value.length.toString() || '',
            '{step}': element.getAttribute('step') || '',
            '{min}': element.getAttribute('min') || '',
            '{max}': element.getAttribute('max') || '',
            '{currentValue}': element.value
        };
        const re = new RegExp(Object.keys(dictionary).join('|'), 'gi');
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || '', item.matchtype === "FULLMATCH" ? 'g' : '');
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-character-pattern]');
        const upperPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-upper-pattern]');
        const numberPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-number-pattern]');
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-allowed-symbols-pattern]');
        const characterPattern = characterPatternElement?.getAttribute('data-tk-pwd-character-pattern');
        const upperPattern = upperPatternElement?.getAttribute('data-tk-pwd-upper-pattern');
        const numberPattern = numberPatternElement?.getAttribute('data-tk-pwd-number-pattern');
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute('data-tk-pwd-allowed-symbols-pattern');
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $5163560edb86f711$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.counter = 0;
        this.link = this.querySelector('a') || undefined;
        this.emptyClass = this.getAttribute('data-tk-compare-list-link-empty-class') || 'tk-button__header--empty';
    }
    connectedCallback() {
        if (!this.hasAttribute('data-tk-compare-list-link-count') || !this.link) return;
        this.initCounter();
    }
    initCounter() {
        const countString = this.getAttribute('data-tk-compare-list-link-count');
        this.counter = Number(countString);
        this.setCounter();
    }
    updateCounter(compareState) {
        if (compareState === 'a') this.counter += 1;
        if (compareState === 'p') this.counter -= 1;
        this.setCounter();
    }
    setCounter() {
        this.link.setAttribute('data-count', `${this.counter}`);
        this.updateCounterVisibility();
    }
    updateCounterVisibility() {
        this.link.classList.toggle(this.emptyClass, this.counter === 0);
    }
}







var $69165974676831f6$export$80844e5a810aad22 = /*#__PURE__*/ function(CompareState) {
    CompareState["ADDED"] = "a";
    CompareState["REMOVED"] = "p";
    return CompareState;
}({});
class $69165974676831f6$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.type = 'Compare';
        this.button = this.querySelector('button') || undefined;
        this.item = this.getAttribute('data-tk-compare-item') || '';
        this.compareType = this.getAttribute('data-tk-compare-type') || 'Art';
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        this.activeClass = this.getAttribute('data-tk-compare-active-class') || 'tk-compare-button--active';
        this.itemList = document.querySelectorAll(`[data-tk-compare-item="${this.item}"]`);
        this.compareListLink = document.querySelector('tk-compare-list-link') || undefined;
        this.shouldRemoveAll = this.hasAttribute('data-tk-should-remove-all');
        this.wrapper = document.querySelector('tk-compare-wrapper') || undefined;
    }
    connectedCallback() {
        if (!this.button) throw new Error('Compare: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const handleCompare = this.shouldRemoveAll ? this.removeAllItems.bind(this) : this.addOrRemoveFromCompare.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleCompare
        });
    }
    addOrRemoveFromCompare() {
        const data = {
            Id: this.item,
            Type: this.type,
            CompareType: this.compareType
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    async removeAllItems() {
        this.button.disabled = true;
        const itemList = document.querySelectorAll('[data-tk-compare-item]');
        const itemSet = new Set();
        itemList.forEach((item)=>{
            const id = item.getAttribute('data-tk-compare-item') || '';
            itemSet.add(id);
        });
        const promises = [];
        itemSet.forEach((id)=>{
            promises.push(this.fetch(id));
        });
        try {
            await Promise.all(promises);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).allRemoved.text);
            this.resetPage();
            this.updateItemsCount(true);
        } catch (error) {
            throw new Error(`${error}`);
        }
    }
    resetPage() {
        if (!this.wrapper) return;
        this.wrapper.innerHTML = '';
        const headerElement = document.querySelector('[data-tk-compare-header]');
        headerElement?.classList.add('tk-compare__header--empty');
        this.wrapper.insertAdjacentElement('beforeend', (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
                <div class="tk-message tk-message--fullwidth tk-message--padding-block-unset">
                    <span class="tk-message__label tk-message__label--fullwidth tk-message__label--text-center">
                        ${(0, $86b3c5b6d66bd808$export$ad480231e1cfb49).empty.text}
                    </span>
                </div>
            `));
        // remove remove all button
        const removeAllButton = document.querySelector('[data-tk-should-remove-all]');
        if (removeAllButton) removeAllButton.parentElement?.removeChild(removeAllButton);
    }
    fetch(id) {
        const data = {
            Id: id,
            Type: this.type,
            CompareType: this.compareType
        };
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.asyncURL,
                payload: data,
                resolveHandler: (success)=>resolve(success),
                showMessages: false
            });
        });
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        const json = response.dataAsJson;
        if (!json.success) return;
        const handler = {
            a: ()=>this.addActiveClass(),
            p: ()=>this.remove()
        };
        handler[json.comparestatus]();
        this.compareListLink?.updateCounter(response.dataAsJson.comparestatus);
    }
    showErrorMessage(error) {
        const errorMessage = this.getMessage(error);
        if (errorMessage !== '') (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, errorMessage);
    }
    // eslint-disable-next-line class-methods-use-this
    getMessage(error) {
        const tmpMessage = document.createElement('div');
        tmpMessage.innerHTML = error;
        const errorMessage = tmpMessage.querySelector('[data-tk-compare-failed-text]') || undefined;
        return errorMessage ? errorMessage.innerText : '';
    }
    addActiveClass() {
        this.itemList.forEach((item)=>{
            item.classList.add(this.activeClass);
        });
    }
    remove() {
        this.removeActiveClass();
        this.removeItem();
        // update items count
        this.updateItemsCount();
    }
    removeActiveClass() {
        this.itemList.forEach((item)=>{
            item.classList.remove(this.activeClass);
        });
    }
    removeItem() {
        const column = this.closest('[data-tk-column]');
        if (!column) return;
        const columnNumber = column.getAttribute('data-tk-column');
        const rows = document.querySelectorAll('[data-tk-row]');
        rows.forEach((row)=>{
            const col = row.querySelector(`[data-tk-column="${columnNumber}"]`);
            col?.remove();
        });
    }
    updateItemsCount(preventPageReset = false) {
        const itemsCountContainer = document.querySelector('[data-compare-items-count]');
        if (!itemsCountContainer) return;
        const itemsCountString = itemsCountContainer.getAttribute('data-compare-items-count');
        const itemsCount = itemsCountString ? parseInt(itemsCountString, 10) : 0;
        if (itemsCount <= 1 && !preventPageReset) this.resetPage();
    }
}


function $f844812df082fc15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f844812df082fc15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f844812df082fc15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f844812df082fc15$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $f844812df082fc15$var$CREATED = 1;
var $f844812df082fc15$var$MOUNTED = 2;
var $f844812df082fc15$var$IDLE = 3;
var $f844812df082fc15$var$MOVING = 4;
var $f844812df082fc15$var$SCROLLING = 5;
var $f844812df082fc15$var$DRAGGING = 6;
var $f844812df082fc15$var$DESTROYED = 7;
var $f844812df082fc15$var$STATES = {
    CREATED: $f844812df082fc15$var$CREATED,
    MOUNTED: $f844812df082fc15$var$MOUNTED,
    IDLE: $f844812df082fc15$var$IDLE,
    MOVING: $f844812df082fc15$var$MOVING,
    SCROLLING: $f844812df082fc15$var$SCROLLING,
    DRAGGING: $f844812df082fc15$var$DRAGGING,
    DESTROYED: $f844812df082fc15$var$DESTROYED
};
function $f844812df082fc15$var$empty(array) {
    array.length = 0;
}
function $f844812df082fc15$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $f844812df082fc15$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($f844812df082fc15$var$slice(arguments, 1)));
}
var $f844812df082fc15$var$nextTick = setTimeout;
var $f844812df082fc15$var$noop = function noop() {};
function $f844812df082fc15$var$raf(func) {
    return requestAnimationFrame(func);
}
function $f844812df082fc15$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $f844812df082fc15$var$isObject(subject) {
    return !$f844812df082fc15$var$isNull(subject) && $f844812df082fc15$var$typeOf("object", subject);
}
var $f844812df082fc15$var$isArray = Array.isArray;
var $f844812df082fc15$var$isFunction = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "function");
var $f844812df082fc15$var$isString = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "string");
var $f844812df082fc15$var$isUndefined = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "undefined");
function $f844812df082fc15$var$isNull(subject) {
    return subject === null;
}
function $f844812df082fc15$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $f844812df082fc15$var$toArray(value) {
    return $f844812df082fc15$var$isArray(value) ? value : [
        value
    ];
}
function $f844812df082fc15$var$forEach(values, iteratee) {
    $f844812df082fc15$var$toArray(values).forEach(iteratee);
}
function $f844812df082fc15$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $f844812df082fc15$var$push(array, items) {
    array.push.apply(array, $f844812df082fc15$var$toArray(items));
    return array;
}
function $f844812df082fc15$var$toggleClass(elm, classes, add) {
    if (elm) $f844812df082fc15$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $f844812df082fc15$var$addClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, $f844812df082fc15$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $f844812df082fc15$var$append(parent, children) {
    $f844812df082fc15$var$forEach(children, parent.appendChild.bind(parent));
}
function $f844812df082fc15$var$before(nodes, ref) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $f844812df082fc15$var$matches(elm, selector) {
    return $f844812df082fc15$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $f844812df082fc15$var$children(parent, selector) {
    var children2 = parent ? $f844812df082fc15$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $f844812df082fc15$var$matches(child, selector);
    }) : children2;
}
function $f844812df082fc15$var$child(parent, selector) {
    return selector ? $f844812df082fc15$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $f844812df082fc15$var$ownKeys = Object.keys;
function $f844812df082fc15$var$forOwn(object, iteratee, right) {
    if (object) (right ? $f844812df082fc15$var$ownKeys(object).reverse() : $f844812df082fc15$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $f844812df082fc15$var$assign(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $f844812df082fc15$var$merge(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            if ($f844812df082fc15$var$isArray(value)) object[key] = value.slice();
            else if ($f844812df082fc15$var$isObject(value)) object[key] = $f844812df082fc15$var$merge({}, $f844812df082fc15$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $f844812df082fc15$var$omit(object, keys) {
    $f844812df082fc15$var$forEach(keys || $f844812df082fc15$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $f844812df082fc15$var$removeAttribute(elms, attrs) {
    $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $f844812df082fc15$var$setAttribute(elms, attrs, value) {
    if ($f844812df082fc15$var$isObject(attrs)) $f844812df082fc15$var$forOwn(attrs, function(value2, name) {
        $f844812df082fc15$var$setAttribute(elms, name, value2);
    });
    else $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$isNull(value) || value === "" ? $f844812df082fc15$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $f844812df082fc15$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $f844812df082fc15$var$isString(attrs) ? $f844812df082fc15$var$addClass(elm, attrs) : $f844812df082fc15$var$setAttribute(elm, attrs);
    parent && $f844812df082fc15$var$append(parent, elm);
    return elm;
}
function $f844812df082fc15$var$style(elm, prop, value) {
    if ($f844812df082fc15$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$f844812df082fc15$var$isNull(value)) elm.style[prop] = "" + value;
}
function $f844812df082fc15$var$display(elm, display2) {
    $f844812df082fc15$var$style(elm, "display", display2);
}
function $f844812df082fc15$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $f844812df082fc15$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $f844812df082fc15$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $f844812df082fc15$var$rect(target) {
    return target.getBoundingClientRect();
}
function $f844812df082fc15$var$remove(nodes) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $f844812df082fc15$var$parseHtml(html) {
    return $f844812df082fc15$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $f844812df082fc15$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $f844812df082fc15$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $f844812df082fc15$var$queryAll(parent, selector) {
    return selector ? $f844812df082fc15$var$slice(parent.querySelectorAll(selector)) : [];
}
function $f844812df082fc15$var$removeClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, classes, false);
}
function $f844812df082fc15$var$timeOf(e) {
    return e.timeStamp;
}
function $f844812df082fc15$var$unit(value) {
    return $f844812df082fc15$var$isString(value) ? value : value ? value + "px" : "";
}
var $f844812df082fc15$var$PROJECT_CODE = "splide";
var $f844812df082fc15$var$DATA_ATTRIBUTE = "data-" + $f844812df082fc15$var$PROJECT_CODE;
function $f844812df082fc15$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $f844812df082fc15$var$PROJECT_CODE + "] " + (message || ""));
}
var $f844812df082fc15$var$min = Math.min, $f844812df082fc15$var$max = Math.max, $f844812df082fc15$var$floor = Math.floor, $f844812df082fc15$var$ceil = Math.ceil, $f844812df082fc15$var$abs = Math.abs;
function $f844812df082fc15$var$approximatelyEqual(x, y, epsilon) {
    return $f844812df082fc15$var$abs(x - y) < epsilon;
}
function $f844812df082fc15$var$between(number, x, y, exclusive) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $f844812df082fc15$var$clamp(number, x, y) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return $f844812df082fc15$var$min($f844812df082fc15$var$max(minimum, number), maximum);
}
function $f844812df082fc15$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $f844812df082fc15$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $f844812df082fc15$var$format(string, replacements) {
    $f844812df082fc15$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $f844812df082fc15$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $f844812df082fc15$var$ids = {};
function $f844812df082fc15$var$uniqueId(prefix) {
    return "" + prefix + $f844812df082fc15$var$pad($f844812df082fc15$var$ids[prefix] = ($f844812df082fc15$var$ids[prefix] || 0) + 1);
}
function $f844812df082fc15$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $f844812df082fc15$var$forEach(targets, function(target) {
            target && $f844812df082fc15$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $f844812df082fc15$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $f844812df082fc15$export$d300dc1a2634364b = "mounted";
var $f844812df082fc15$export$d8dac49b4532735a = "ready";
var $f844812df082fc15$export$2aa493d7c3275167 = "move";
var $f844812df082fc15$export$fe5802204b967f0d = "moved";
var $f844812df082fc15$export$5adb665701eda1ce = "click";
var $f844812df082fc15$export$92e3eae133acac4c = "active";
var $f844812df082fc15$export$6bcbb81035c12cea = "inactive";
var $f844812df082fc15$export$6a5b3445e4066a53 = "visible";
var $f844812df082fc15$export$8c5c7a21d54563e9 = "hidden";
var $f844812df082fc15$export$7f4701ac5e05e39f = "refresh";
var $f844812df082fc15$export$db40ab7c0855fa5c = "updated";
var $f844812df082fc15$export$7e019dae5103a285 = "resize";
var $f844812df082fc15$export$d637eba1e9e28482 = "resized";
var $f844812df082fc15$export$e84bf5065c9087ac = "drag";
var $f844812df082fc15$export$8e9f636d2c722196 = "dragging";
var $f844812df082fc15$export$90ea576bd3fdeb60 = "dragged";
var $f844812df082fc15$export$49801896908b5e33 = "scroll";
var $f844812df082fc15$export$ff8164bff3202b9 = "scrolled";
var $f844812df082fc15$export$6cbac5b662a31e1b = "overflow";
var $f844812df082fc15$export$88c4cf7419e470cd = "destroy";
var $f844812df082fc15$export$8647f6b043e04e9d = "arrows:mounted";
var $f844812df082fc15$export$d467f9343b961f75 = "arrows:updated";
var $f844812df082fc15$export$bf89a4e4349c9778 = "pagination:mounted";
var $f844812df082fc15$export$eb2019082ed6de0b = "pagination:updated";
var $f844812df082fc15$export$84015c33508f94ec = "navigation:mounted";
var $f844812df082fc15$export$23663268a31b79e2 = "autoplay:play";
var $f844812df082fc15$export$185723258309b608 = "autoplay:playing";
var $f844812df082fc15$export$16a1e4f3d0368265 = "autoplay:pause";
var $f844812df082fc15$export$9f64346e17f0ec8e = "lazyload:loaded";
var $f844812df082fc15$export$6d5af59619d10e6a = "sk";
var $f844812df082fc15$export$f0af896383d5adff = "sh";
var $f844812df082fc15$export$28dea85f216954dc = "ei";
function $f844812df082fc15$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $f844812df082fc15$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $f844812df082fc15$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $f844812df082fc15$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($f844812df082fc15$export$88c4cf7419e470cd, binder.destroy);
    return $f844812df082fc15$var$assign(binder, {
        bus: bus,
        on: on,
        off: $f844812df082fc15$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $f844812df082fc15$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $f844812df082fc15$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $f844812df082fc15$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $f844812df082fc15$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $f844812df082fc15$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $f844812df082fc15$export$efff0f5979573c99(func, duration) {
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $f844812df082fc15$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $f844812df082fc15$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($f844812df082fc15$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $f844812df082fc15$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $f844812df082fc15$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $f844812df082fc15$var$merge(options, reducedMotion) : $f844812df082fc15$var$omit(options, $f844812df082fc15$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $f844812df082fc15$var$merge(options, opts);
        base && $f844812df082fc15$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($f844812df082fc15$var$CREATED)) Splide2.emit($f844812df082fc15$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $f844812df082fc15$var$ARROW = "Arrow";
var $f844812df082fc15$var$ARROW_LEFT = $f844812df082fc15$var$ARROW + "Left";
var $f844812df082fc15$var$ARROW_RIGHT = $f844812df082fc15$var$ARROW + "Right";
var $f844812df082fc15$var$ARROW_UP = $f844812df082fc15$var$ARROW + "Up";
var $f844812df082fc15$var$ARROW_DOWN = $f844812df082fc15$var$ARROW + "Down";
var $f844812df082fc15$export$373e92e0788ff06e = "ltr";
var $f844812df082fc15$export$850f7749a2909601 = "rtl";
var $f844812df082fc15$export$97170d9824b89709 = "ttb";
var $f844812df082fc15$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $f844812df082fc15$var$ARROW_UP,
        $f844812df082fc15$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $f844812df082fc15$var$ARROW_DOWN,
        $f844812df082fc15$var$ARROW_LEFT
    ]
};
function $f844812df082fc15$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $f844812df082fc15$export$850f7749a2909601 && !axisOnly ? 1 : direction === $f844812df082fc15$export$97170d9824b89709 ? 0 : -1;
        return $f844812df082fc15$var$ORIENTATION_MAP[prop] && $f844812df082fc15$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $f844812df082fc15$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $f844812df082fc15$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $f844812df082fc15$var$ROLE = "role";
var $f844812df082fc15$var$TAB_INDEX = "tabindex";
var $f844812df082fc15$var$DISABLED = "disabled";
var $f844812df082fc15$var$ARIA_PREFIX = "aria-";
var $f844812df082fc15$var$ARIA_CONTROLS = $f844812df082fc15$var$ARIA_PREFIX + "controls";
var $f844812df082fc15$var$ARIA_CURRENT = $f844812df082fc15$var$ARIA_PREFIX + "current";
var $f844812df082fc15$var$ARIA_SELECTED = $f844812df082fc15$var$ARIA_PREFIX + "selected";
var $f844812df082fc15$var$ARIA_LABEL = $f844812df082fc15$var$ARIA_PREFIX + "label";
var $f844812df082fc15$var$ARIA_LABELLEDBY = $f844812df082fc15$var$ARIA_PREFIX + "labelledby";
var $f844812df082fc15$var$ARIA_HIDDEN = $f844812df082fc15$var$ARIA_PREFIX + "hidden";
var $f844812df082fc15$var$ARIA_ORIENTATION = $f844812df082fc15$var$ARIA_PREFIX + "orientation";
var $f844812df082fc15$var$ARIA_ROLEDESCRIPTION = $f844812df082fc15$var$ARIA_PREFIX + "roledescription";
var $f844812df082fc15$var$ARIA_LIVE = $f844812df082fc15$var$ARIA_PREFIX + "live";
var $f844812df082fc15$var$ARIA_BUSY = $f844812df082fc15$var$ARIA_PREFIX + "busy";
var $f844812df082fc15$var$ARIA_ATOMIC = $f844812df082fc15$var$ARIA_PREFIX + "atomic";
var $f844812df082fc15$var$ALL_ATTRIBUTES = [
    $f844812df082fc15$var$ROLE,
    $f844812df082fc15$var$TAB_INDEX,
    $f844812df082fc15$var$DISABLED,
    $f844812df082fc15$var$ARIA_CONTROLS,
    $f844812df082fc15$var$ARIA_CURRENT,
    $f844812df082fc15$var$ARIA_LABEL,
    $f844812df082fc15$var$ARIA_LABELLEDBY,
    $f844812df082fc15$var$ARIA_HIDDEN,
    $f844812df082fc15$var$ARIA_ORIENTATION,
    $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
];
var $f844812df082fc15$var$CLASS_PREFIX = $f844812df082fc15$var$PROJECT_CODE + "__";
var $f844812df082fc15$var$STATUS_CLASS_PREFIX = "is-";
var $f844812df082fc15$export$93b21159ad85c843 = $f844812df082fc15$var$PROJECT_CODE;
var $f844812df082fc15$export$7738b09ac0a98952 = $f844812df082fc15$var$CLASS_PREFIX + "track";
var $f844812df082fc15$export$19cc2a5451235cae = $f844812df082fc15$var$CLASS_PREFIX + "list";
var $f844812df082fc15$export$8d922915837a38d3 = $f844812df082fc15$var$CLASS_PREFIX + "slide";
var $f844812df082fc15$export$2c1ba4a4f1aa4947 = $f844812df082fc15$export$8d922915837a38d3 + "--clone";
var $f844812df082fc15$export$e9ba7e444ba60a12 = $f844812df082fc15$export$8d922915837a38d3 + "__container";
var $f844812df082fc15$export$a26cbd955fecf11e = $f844812df082fc15$var$CLASS_PREFIX + "arrows";
var $f844812df082fc15$export$516e7d18e13a2dca = $f844812df082fc15$var$CLASS_PREFIX + "arrow";
var $f844812df082fc15$export$58ea3db24c33b76 = $f844812df082fc15$export$516e7d18e13a2dca + "--prev";
var $f844812df082fc15$export$4885afd7098a65c2 = $f844812df082fc15$export$516e7d18e13a2dca + "--next";
var $f844812df082fc15$export$cbf8e5a0ab95eda3 = $f844812df082fc15$var$CLASS_PREFIX + "pagination";
var $f844812df082fc15$export$52f2cca6a5eee805 = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "__page";
var $f844812df082fc15$export$4c82dc32b1c4ace5 = $f844812df082fc15$var$CLASS_PREFIX + "progress";
var $f844812df082fc15$export$2c9b091c749f4409 = $f844812df082fc15$export$4c82dc32b1c4ace5 + "__bar";
var $f844812df082fc15$export$a29701deef84b825 = $f844812df082fc15$var$CLASS_PREFIX + "toggle";
var $f844812df082fc15$export$d9d247d51b430dbb = $f844812df082fc15$export$a29701deef84b825 + "__play";
var $f844812df082fc15$export$3529f201a419925b = $f844812df082fc15$export$a29701deef84b825 + "__pause";
var $f844812df082fc15$export$3e5381ee3fab8374 = $f844812df082fc15$var$CLASS_PREFIX + "spinner";
var $f844812df082fc15$export$bb78d7c200da8960 = $f844812df082fc15$var$CLASS_PREFIX + "sr";
var $f844812df082fc15$export$7761661e2d5b9388 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "initialized";
var $f844812df082fc15$export$72d36ecf3758cb4b = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "active";
var $f844812df082fc15$export$e423ac4972f5e196 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "prev";
var $f844812df082fc15$export$457a2d20827a2779 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "next";
var $f844812df082fc15$export$53ca4621bbab9a = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "visible";
var $f844812df082fc15$export$d22ec4ccb7996ba2 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "loading";
var $f844812df082fc15$export$b6f202a162a09100 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "focus-in";
var $f844812df082fc15$export$cd908cd1dd625e29 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "overflow";
var $f844812df082fc15$export$49f9eaea10ebf193 = [
    $f844812df082fc15$export$72d36ecf3758cb4b,
    $f844812df082fc15$export$53ca4621bbab9a,
    $f844812df082fc15$export$e423ac4972f5e196,
    $f844812df082fc15$export$457a2d20827a2779,
    $f844812df082fc15$export$d22ec4ccb7996ba2,
    $f844812df082fc15$export$b6f202a162a09100,
    $f844812df082fc15$export$cd908cd1dd625e29
];
var $f844812df082fc15$export$ba41d43e4a419565 = {
    slide: $f844812df082fc15$export$8d922915837a38d3,
    clone: $f844812df082fc15$export$2c1ba4a4f1aa4947,
    arrows: $f844812df082fc15$export$a26cbd955fecf11e,
    arrow: $f844812df082fc15$export$516e7d18e13a2dca,
    prev: $f844812df082fc15$export$58ea3db24c33b76,
    next: $f844812df082fc15$export$4885afd7098a65c2,
    pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
    page: $f844812df082fc15$export$52f2cca6a5eee805,
    spinner: $f844812df082fc15$export$3e5381ee3fab8374
};
function $f844812df082fc15$var$closest(from, selector) {
    if ($f844812df082fc15$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($f844812df082fc15$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $f844812df082fc15$var$FRICTION = 5;
var $f844812df082fc15$var$LOG_INTERVAL = 200;
var $f844812df082fc15$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $f844812df082fc15$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $f844812df082fc15$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $f844812df082fc15$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, setup);
        on($f844812df082fc15$export$db40ab7c0855fa5c, update);
        bind(document, $f844812df082fc15$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $f844812df082fc15$var$ALL_ATTRIBUTES.concat("style");
        $f844812df082fc15$var$empty(slides);
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        $f844812df082fc15$var$removeAttribute([
            track,
            list
        ], attrs);
        $f844812df082fc15$var$removeAttribute(root, completely ? attrs : [
            "style",
            $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        rootClasses = getClasses($f844812df082fc15$export$93b21159ad85c843);
        trackClasses = getClasses($f844812df082fc15$export$7738b09ac0a98952);
        $f844812df082fc15$var$addClass(root, rootClasses);
        $f844812df082fc15$var$addClass(track, trackClasses);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABEL, options.label);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $f844812df082fc15$export$7738b09ac0a98952);
        list = $f844812df082fc15$var$child(track, "." + $f844812df082fc15$export$19cc2a5451235cae);
        $f844812df082fc15$var$assert(track && list, "A track/list element is missing.");
        $f844812df082fc15$var$push(slides, $f844812df082fc15$var$children(list, "." + $f844812df082fc15$export$8d922915837a38d3 + ":not(." + $f844812df082fc15$export$2c1ba4a4f1aa4947 + ")"));
        $f844812df082fc15$var$forOwn({
            arrows: $f844812df082fc15$export$a26cbd955fecf11e,
            pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
            prev: $f844812df082fc15$export$58ea3db24c33b76,
            next: $f844812df082fc15$export$4885afd7098a65c2,
            bar: $f844812df082fc15$export$2c9b091c749f4409,
            toggle: $f844812df082fc15$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $f844812df082fc15$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $f844812df082fc15$var$uniqueId($f844812df082fc15$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ROLE) && root.tagName !== "SECTION" && role) $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ROLE, role);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $f844812df082fc15$var$query(root, selector);
        return elm && $f844812df082fc15$var$closest(elm, "." + $f844812df082fc15$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $f844812df082fc15$export$93b21159ad85c843 && $f844812df082fc15$export$72d36ecf3758cb4b
        ];
    }
    return $f844812df082fc15$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $f844812df082fc15$export$e5a58a5ee5b54c22 = "slide";
var $f844812df082fc15$export$f42383286ed1223d = "loop";
var $f844812df082fc15$export$742b62a5690c060 = "fade";
function $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $f844812df082fc15$var$getAttribute(slide, "style");
    var label = $f844812df082fc15$var$getAttribute(slide, $f844812df082fc15$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $f844812df082fc15$var$child(slide, "." + $f844812df082fc15$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $f844812df082fc15$var$pad(index + 1);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, pagination ? "tabpanel" : "group");
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || $f844812df082fc15$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$6d5af59619d10e6a, self));
        on([
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$f0af896383d5adff,
            $f844812df082fc15$export$ff8164bff3202b9
        ], update);
        on($f844812df082fc15$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $f844812df082fc15$var$removeClass(slide, $f844812df082fc15$export$49f9eaea10ebf193);
        $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ALL_ATTRIBUTES);
        $f844812df082fc15$var$setAttribute(slide, "style", styles);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CONTROLS, controls);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$e423ac4972f5e196, index === curr - 1);
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b, active);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $f844812df082fc15$export$92e3eae133acac4c : $f844812df082fc15$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ])) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_HIDDEN, hidden || "");
        $f844812df082fc15$var$setAttribute($f844812df082fc15$var$queryAll(slide, options.focusableNodes || ""), $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$53ca4621bbab9a)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$53ca4621bbab9a, visible);
            emit(visible ? $f844812df082fc15$export$6a5b3445e4066a53 : $f844812df082fc15$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $f844812df082fc15$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $f844812df082fc15$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) return isActive();
        var trackRect = $f844812df082fc15$var$rect(Components.Elements.track);
        var slideRect = $f844812df082fc15$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $f844812df082fc15$var$floor(trackRect[left]) <= $f844812df082fc15$var$ceil(slideRect[left]) && $f844812df082fc15$var$floor(slideRect[right]) <= $f844812df082fc15$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $f844812df082fc15$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($f844812df082fc15$export$f42383286ed1223d))) diff = $f844812df082fc15$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $f844812df082fc15$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $f844812df082fc15$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $f844812df082fc15$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $f844812df082fc15$var$forEach(items, function(slide) {
            if ($f844812df082fc15$var$isString(slide)) slide = $f844812df082fc15$var$parseHtml(slide);
            if ($f844812df082fc15$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $f844812df082fc15$var$before(slide, ref) : $f844812df082fc15$var$append(list, slide);
                $f844812df082fc15$var$addClass(slide, options.classes.slide);
                observeImages(slide, $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285));
            }
        });
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $f844812df082fc15$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($f844812df082fc15$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $f844812df082fc15$var$isString(matcher) ? $f844812df082fc15$var$matches(Slide2.slide, matcher) : $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $f844812df082fc15$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $f844812df082fc15$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $f844812df082fc15$export$efff0f5979573c99($f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285)));
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
        on($f844812df082fc15$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $f844812df082fc15$export$97170d9824b89709;
        $f844812df082fc15$var$style(root, "maxWidth", $f844812df082fc15$var$unit(options.width));
        $f844812df082fc15$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $f844812df082fc15$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $f844812df082fc15$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $f844812df082fc15$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $f844812df082fc15$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($f844812df082fc15$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$cd908cd1dd625e29, overflow);
                emit($f844812df082fc15$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $f844812df082fc15$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $f844812df082fc15$var$unit(options.height || $f844812df082fc15$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $f844812df082fc15$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $f844812df082fc15$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $f844812df082fc15$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $f844812df082fc15$var$rect(Slide.slide)[resolve("right")];
            var left = $f844812df082fc15$var$rect(list)[resolve("left")];
            return $f844812df082fc15$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($f844812df082fc15$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($f844812df082fc15$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($f844812df082fc15$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $f844812df082fc15$var$MULTIPLIER = 2;
function $f844812df082fc15$var$Clones(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, remount);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $f844812df082fc15$var$remove(clones);
        $f844812df082fc15$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
            $f844812df082fc15$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $f844812df082fc15$var$before(clone, slides[0].slide) : $f844812df082fc15$var$append(Elements.list, clone);
                $f844812df082fc15$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $f844812df082fc15$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $f844812df082fc15$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($f844812df082fc15$export$f42383286ed1223d)) clones2 = 0;
        else if ($f844812df082fc15$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $f844812df082fc15$var$ceil($f844812df082fc15$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $f844812df082fc15$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $f844812df082fc15$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$d637eba1e9e28482,
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($f844812df082fc15$var$MOVING);
        emit($f844812df082fc15$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($f844812df082fc15$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $f844812df082fc15$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($f844812df082fc15$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($f844812df082fc15$var$ceil($f844812df082fc15$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $f844812df082fc15$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $f844812df082fc15$var$rect(list)[left] - $f844812df082fc15$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22)) position = $f844812df082fc15$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $f844812df082fc15$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $f844812df082fc15$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $f844812df082fc15$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($f844812df082fc15$export$f42383286ed1223d);
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var getNext = $f844812df082fc15$var$apply(getAdjacent, false);
    var getPrev = $f844812df082fc15$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], init);
        on($f844812df082fc15$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $f844812df082fc15$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($f844812df082fc15$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $f844812df082fc15$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($f844812df082fc15$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $f844812df082fc15$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$f844812df082fc15$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($f844812df082fc15$var$between(0, dest, from, true) || $f844812df082fc15$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $f844812df082fc15$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $f844812df082fc15$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $f844812df082fc15$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $f844812df082fc15$var$min(index, endIndex) : $f844812df082fc15$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $f844812df082fc15$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$f844812df082fc15$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $f844812df082fc15$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $f844812df082fc15$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $f844812df082fc15$var$SIZE = 40;
function $f844812df082fc15$var$Arrows(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $f844812df082fc15$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $f844812df082fc15$var$display(wrapper, enabled ? "" : "none");
            $f844812df082fc15$var$addClass(wrapper, wrapperClasses = $f844812df082fc15$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $f844812df082fc15$var$setAttribute([
                    prev,
                    next
                ], $f844812df082fc15$var$ARIA_CONTROLS, track.id);
                emit($f844812df082fc15$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $f844812df082fc15$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $f844812df082fc15$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $f844812df082fc15$var$removeAttribute([
            prev,
            next
        ], $f844812df082fc15$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$ff8164bff3202b9,
            $f844812df082fc15$export$28dea85f216954dc
        ], update);
        bind(next, "click", $f844812df082fc15$var$apply(go, ">"));
        bind(prev, "click", $f844812df082fc15$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $f844812df082fc15$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $f844812df082fc15$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $f844812df082fc15$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $f844812df082fc15$var$PATH) + "\" />";
        return $f844812df082fc15$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $f844812df082fc15$var$setAttribute(prev, $f844812df082fc15$var$ARIA_LABEL, prevLabel);
            $f844812df082fc15$var$setAttribute(next, $f844812df082fc15$var$ARIA_LABEL, nextLabel);
            emit($f844812df082fc15$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-interval";
function $f844812df082fc15$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $f844812df082fc15$export$2aa493d7c3275167,
            $f844812df082fc15$export$49801896908b5e33,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($f844812df082fc15$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($f844812df082fc15$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $f844812df082fc15$var$toggleClass(toggle, $f844812df082fc15$export$72d36ecf3758cb4b, !stopped);
            $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $f844812df082fc15$var$style(bar, "width", rate * 100 + "%");
        emit($f844812df082fc15$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$f844812df082fc15$var$getAttribute(Slide.slide, $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $f844812df082fc15$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($f844812df082fc15$export$9f64346e17f0ec8e, $f844812df082fc15$var$apply(toggle, true));
            on([
                $f844812df082fc15$export$d300dc1a2634364b,
                $f844812df082fc15$export$db40ab7c0855fa5c,
                $f844812df082fc15$export$7f4701ac5e05e39f
            ], $f844812df082fc15$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $f844812df082fc15$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $f844812df082fc15$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply(cover, false)
    };
}
var $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD = 10;
var $f844812df082fc15$var$BOUNCE_DURATION = 600;
var $f844812df082fc15$var$FRICTION_FACTOR = 0.6;
var $f844812df082fc15$var$BASE_VELOCITY = 1.5;
var $f844812df082fc15$var$MIN_DURATION = 800;
function $f844812df082fc15$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($f844812df082fc15$export$2aa493d7c3275167, clear);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $f844812df082fc15$var$sign(destination) * size * $f844812df082fc15$var$floor($f844812df082fc15$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $f844812df082fc15$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $f844812df082fc15$var$max($f844812df082fc15$var$abs(destination - from) / $f844812df082fc15$var$BASE_VELOCITY, $f844812df082fc15$var$MIN_DURATION);
        callback = onScrolled;
        interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration, onEnd, $f844812df082fc15$var$apply(update, from, destination, noConstrain), 1);
        set($f844812df082fc15$var$SCROLLING);
        emit($f844812df082fc15$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($f844812df082fc15$var$IDLE);
        callback && callback();
        emit($f844812df082fc15$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $f844812df082fc15$var$FRICTION_FACTOR;
            if ($f844812df082fc15$var$abs(diff) < $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $f844812df082fc15$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $f844812df082fc15$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $f844812df082fc15$var$POINTER_MOVE_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_UP_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_DOWN_EVENTS, onPointerDown, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $f844812df082fc15$var$prevent);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $f844812df082fc15$var$MOVING,
                        $f844812df082fc15$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $f844812df082fc15$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$DRAGGING);
            emit($f844812df082fc15$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $f844812df082fc15$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($f844812df082fc15$export$8e9f636d2c722196);
                $f844812df082fc15$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $f844812df082fc15$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $f844812df082fc15$var$prevent(e);
        }
        unbind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $f844812df082fc15$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) Controller.go(orient($f844812df082fc15$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $f844812df082fc15$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $f844812df082fc15$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $f844812df082fc15$var$abs(diffCoord(e)) > $f844812df082fc15$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $f844812df082fc15$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $f844812df082fc15$var$sign(velocity) * $f844812df082fc15$var$min($f844812df082fc15$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $f844812df082fc15$var$timeOf(e) - $f844812df082fc15$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) ? $f844812df082fc15$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$f844812df082fc15$var$matches(target2, "." + $f844812df082fc15$export$52f2cca6a5eee805 + ", ." + $f844812df082fc15$export$516e7d18e13a2dca) && (!noDrag || !$f844812df082fc15$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $f844812df082fc15$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $f844812df082fc15$var$ARROW_RIGHT,
    Left: $f844812df082fc15$var$ARROW_LEFT,
    Up: $f844812df082fc15$var$ARROW_UP,
    Down: $f844812df082fc15$var$ARROW_DOWN
};
function $f844812df082fc15$var$normalizeKey(key) {
    key = $f844812df082fc15$var$isString(key) ? key : key.key;
    return $f844812df082fc15$var$NORMALIZATION_MAP[key] || key;
}
var $f844812df082fc15$var$KEYBOARD_EVENT = "keydown";
function $f844812df082fc15$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, destroy);
        on($f844812df082fc15$export$db40ab7c0855fa5c, init);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $f844812df082fc15$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $f844812df082fc15$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $f844812df082fc15$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $f844812df082fc15$var$normalizeKey(e);
            if (key === resolve($f844812df082fc15$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($f844812df082fc15$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $f844812df082fc15$var$SRC_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-lazy";
var $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE = $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $f844812df082fc15$var$IMAGE_SELECTOR = "[" + $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "], [" + $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE + "]";
function $f844812df082fc15$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $f844812df082fc15$export$fe5802204b967f0d,
        $f844812df082fc15$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($f844812df082fc15$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $f844812df082fc15$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $f844812df082fc15$var$queryAll(Slide.slide, $f844812df082fc15$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
                var srcset = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $f844812df082fc15$var$child(parent, "." + className) || $f844812df082fc15$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $f844812df082fc15$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $f844812df082fc15$var$addClass(data[1].slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        bind(img, "load error", $f844812df082fc15$var$apply(onLoad, data));
        $f844812df082fc15$var$setAttribute(img, "src", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE));
        $f844812df082fc15$var$setAttribute(img, "srcset", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE));
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $f844812df082fc15$var$removeClass(Slide.slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $f844812df082fc15$var$remove(data[2]);
            $f844812df082fc15$var$display(img, "");
            emit($f844812df082fc15$export$9f64346e17f0ec8e, img, Slide);
            emit($f844812df082fc15$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply($f844812df082fc15$var$empty, entries),
        check: check
    };
}
function $f844812df082fc15$var$Pagination(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $f844812df082fc15$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $f844812df082fc15$export$2aa493d7c3275167,
                $f844812df082fc15$export$49801896908b5e33,
                $f844812df082fc15$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($f844812df082fc15$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $f844812df082fc15$var$remove(placeholder ? $f844812df082fc15$var$slice(list.children) : list);
            $f844812df082fc15$var$removeClass(list, paginationClasses);
            $f844812df082fc15$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $f844812df082fc15$var$ceil(length / perPage);
        list = placeholder || $f844812df082fc15$var$create("ul", classes.pagination, Elements.track.parentElement);
        $f844812df082fc15$var$addClass(list, paginationClasses = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "tablist");
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_LABEL, i18n.select);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_ORIENTATION, getDirection() === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $f844812df082fc15$var$create("li", null, list);
            var button = $f844812df082fc15$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $f844812df082fc15$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $f844812df082fc15$var$apply(onKeydown, i));
            $f844812df082fc15$var$setAttribute(li, $f844812df082fc15$var$ROLE, "presentation");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ROLE, "tab");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_CONTROLS, controls.join(" "));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(text, i + 1));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $f844812df082fc15$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($f844812df082fc15$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($f844812df082fc15$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $f844812df082fc15$var$focus(item.button);
            go(">" + nextPage);
            $f844812df082fc15$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $f844812df082fc15$var$removeClass(button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$removeAttribute(button, $f844812df082fc15$var$ARIA_SELECTED);
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $f844812df082fc15$var$addClass(_button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$ARIA_SELECTED, true);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$TAB_INDEX, "");
        }
        emit($f844812df082fc15$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $f844812df082fc15$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $f844812df082fc15$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $f844812df082fc15$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $f844812df082fc15$export$f188226459c8a3ff(splide);
        event.on($f844812df082fc15$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($f844812df082fc15$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($f844812df082fc15$export$5adb665701eda1ce, onClick);
        on($f844812df082fc15$export$6d5af59619d10e6a, onKeydown);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($f844812df082fc15$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $f844812df082fc15$var$setAttribute(Components2.Elements.list, $f844812df082fc15$var$ARIA_ORIENTATION, options.direction === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($f844812df082fc15$var$includes($f844812df082fc15$var$TRIGGER_KEYS, $f844812df082fc15$var$normalizeKey(e))) {
            onClick(Slide);
            $f844812df082fc15$var$prevent(e);
        }
    }
    return {
        setup: $f844812df082fc15$var$apply(Components2.Media.set, {
            slideFocus: $f844812df082fc15$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $f844812df082fc15$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $f844812df082fc15$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($f844812df082fc15$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $f844812df082fc15$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($f844812df082fc15$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $f844812df082fc15$var$SR_REMOVAL_DELAY = 90;
function $f844812df082fc15$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $f844812df082fc15$var$create("span", $f844812df082fc15$export$bb78d7c200da8960);
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0($f844812df082fc15$var$SR_REMOVAL_DELAY, $f844812df082fc15$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($f844812df082fc15$export$23663268a31b79e2, $f844812df082fc15$var$apply(disable, true));
            on($f844812df082fc15$export$16a1e4f3d0368265, $f844812df082fc15$var$apply(disable, false));
            on([
                $f844812df082fc15$export$fe5802204b967f0d,
                $f844812df082fc15$export$ff8164bff3202b9
            ], $f844812df082fc15$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_BUSY, active);
        if (active) {
            $f844812df082fc15$var$append(track, sr);
            interval.start();
        } else {
            $f844812df082fc15$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $f844812df082fc15$var$removeAttribute(track, [
            $f844812df082fc15$var$ARIA_LIVE,
            $f844812df082fc15$var$ARIA_ATOMIC,
            $f844812df082fc15$var$ARIA_BUSY
        ]);
        $f844812df082fc15$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $f844812df082fc15$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $f844812df082fc15$var$Media,
    Direction: $f844812df082fc15$var$Direction,
    Elements: $f844812df082fc15$var$Elements,
    Slides: $f844812df082fc15$var$Slides,
    Layout: $f844812df082fc15$var$Layout,
    Clones: $f844812df082fc15$var$Clones,
    Move: $f844812df082fc15$var$Move,
    Controller: $f844812df082fc15$var$Controller,
    Arrows: $f844812df082fc15$var$Arrows,
    Autoplay: $f844812df082fc15$var$Autoplay,
    Cover: $f844812df082fc15$var$Cover,
    Scroll: $f844812df082fc15$var$Scroll,
    Drag: $f844812df082fc15$var$Drag,
    Keyboard: $f844812df082fc15$var$Keyboard,
    LazyLoad: $f844812df082fc15$var$LazyLoad,
    Pagination: $f844812df082fc15$var$Pagination,
    Sync: $f844812df082fc15$var$Sync,
    Wheel: $f844812df082fc15$var$Wheel,
    Live: $f844812df082fc15$var$Live
});
var $f844812df082fc15$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $f844812df082fc15$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $f844812df082fc15$export$ba41d43e4a419565,
    i18n: $f844812df082fc15$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $f844812df082fc15$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $f844812df082fc15$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $f844812df082fc15$var$noop
    };
}
function $f844812df082fc15$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $f844812df082fc15$var$apply($f844812df082fc15$var$style, list, "transition");
    var endCallback;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($f844812df082fc15$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $f844812df082fc15$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $f844812df082fc15$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $f844812df082fc15$export$7254cc27399e90bd($f844812df082fc15$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $f844812df082fc15$var$isString(target) ? $f844812df082fc15$var$query(document, target) : target;
        $f844812df082fc15$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $f844812df082fc15$var$merge({
            label: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABEL) || "",
            labelledby: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY) || ""
        }, $f844812df082fc15$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $f844812df082fc15$var$merge(options, JSON.parse($f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $f844812df082fc15$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($f844812df082fc15$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $f844812df082fc15$var$assert(state.is([
            $f844812df082fc15$var$CREATED,
            $f844812df082fc15$var$DESTROYED
        ]), "Already mounted!");
        state.set($f844812df082fc15$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($f844812df082fc15$export$742b62a5690c060) ? $f844812df082fc15$var$Fade : $f844812df082fc15$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $f844812df082fc15$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $f844812df082fc15$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($f844812df082fc15$export$d300dc1a2634364b);
        $f844812df082fc15$var$addClass(this.root, $f844812df082fc15$export$7761661e2d5b9388);
        state.set($f844812df082fc15$var$IDLE);
        this.emit($f844812df082fc15$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($f844812df082fc15$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($f844812df082fc15$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($f844812df082fc15$var$CREATED)) $f844812df082fc15$export$f188226459c8a3ff(this).on($f844812df082fc15$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $f844812df082fc15$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($f844812df082fc15$export$88c4cf7419e470cd);
            event.destroy();
            completely && $f844812df082fc15$var$empty(this.splides);
            state.set($f844812df082fc15$var$DESTROYED);
        }
        return this;
    };
    $f844812df082fc15$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $f844812df082fc15$export$24494c7438c070bf = $f844812df082fc15$var$_Splide;
$f844812df082fc15$export$24494c7438c070bf.defaults = {};
$f844812df082fc15$export$24494c7438c070bf.STATES = $f844812df082fc15$var$STATES;
var $f844812df082fc15$var$CLASS_RENDERED = "is-rendered";
var $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $f844812df082fc15$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $f844812df082fc15$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $f844812df082fc15$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $f844812df082fc15$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $f844812df082fc15$var$merge($f844812df082fc15$export$f484e977a69c6ba6, defaults || {});
        $f844812df082fc15$var$merge($f844812df082fc15$var$merge(this.options, $f844812df082fc15$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $f844812df082fc15$var$uniqueId("splide");
        this.Style = new $f844812df082fc15$var$Style(this.id, this.options);
        this.Direction = $f844812df082fc15$var$Direction(null, null, this.options);
        $f844812df082fc15$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $f844812df082fc15$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $f844812df082fc15$var$queryAll(root, "." + $f844812df082fc15$export$2c1ba4a4f1aa4947);
        on($f844812df082fc15$export$d300dc1a2634364b, function() {
            $f844812df082fc15$var$remove($f844812df082fc15$var$child(root, "style"));
        });
        $f844812df082fc15$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $f844812df082fc15$var$push(this.slides, this.contents.map(function(content, index) {
            content = $f844812df082fc15$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $f844812df082fc15$export$72d36ecf3758cb4b : "");
            $f844812df082fc15$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $f844812df082fc15$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $f844812df082fc15$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $f844812df082fc15$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $f844812df082fc15$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $f844812df082fc15$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $f844812df082fc15$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($f844812df082fc15$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $f844812df082fc15$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $f844812df082fc15$var$merge($f844812df082fc15$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $f844812df082fc15$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $f844812df082fc15$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $f844812df082fc15$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $f844812df082fc15$export$93b21159ad85c843,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.type,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $f844812df082fc15$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $f844812df082fc15$export$93b21159ad85c843 + "--nav",
            $f844812df082fc15$export$72d36ecf3758cb4b,
            !this.config.hidden && $f844812df082fc15$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $f844812df082fc15$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $f844812df082fc15$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $f844812df082fc15$var$forOwn(styles, function(value, key) {
            style += " " + $f844812df082fc15$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
        $f844812df082fc15$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $f844812df082fc15$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $f844812df082fc15$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $f844812df082fc15$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $f844812df082fc15$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();



class $2ef7b87a2ac1a70d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.customOptions = {};
        this.root = this.querySelector('[data-tk-carousel-root]') || undefined;
        this.options = this.getAttribute('data-tk-carousel-options') || undefined;
        this.paginationClassName = this.getAttribute('data-tk-pagination-class-name') || 'tk-carousel__pagination';
        this.paginationPageClassName = this.getAttribute('data-tk-pagination-page-class-name') || 'tk-carousel__pagination-page';
        this.arrowsClassName = this.getAttribute('data-tk-arrows-class-name') || 'tk-carousel__arrows';
        this.arrowClassName = this.getAttribute('data-tk-arrow-class-name') || 'tk-carousel__arrow';
        this.prevClassName = this.getAttribute('data-tk-prev-class-name') || 'tk-carousel__arrow--prev';
        this.nextClassName = this.getAttribute('data-tk-next-class-name') || 'tk-carousel__arrow--next';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-carousel--loaded';
        if (this.options) this.customOptions = JSON.parse(this.options);
    }
    connectedCallback() {
        this.mountCarousel();
    }
    mountCarousel() {
        const carouselBreakpoints = {};
        carouselBreakpoints[window.viewport.breakpoints.get('l') || 1200] = {
            perPage: 3,
            arrows: true,
            pagination: true
        };
        const defaultOptions = {
            type: 'slide',
            arrows: false,
            pagination: false,
            perMove: 1,
            padding: {
                left: '4px',
                right: '4px'
            },
            gap: 24,
            mediaQuery: 'min',
            classes: {
                pagination: `splide__pagination ${this.paginationClassName}`,
                page: `splide__pagination__page ${this.paginationPageClassName}`,
                arrows: `splide__arrows ${this.arrowsClassName}`,
                arrow: `splide__arrow ${this.arrowClassName}`,
                prev: `splide__arrow--prev ${this.prevClassName}`,
                next: `splide__arrow--next ${this.nextClassName}`
            },
            breakpoints: carouselBreakpoints,
            width: '100%'
        };
        if (!this.root) return;
        this.slider = new (0, $f844812df082fc15$export$24494c7438c070bf)(this.root, Object.assign(defaultOptions, this.customOptions));
        this.slider.on('ready', this.movePaginationToArrows.bind(this));
        this.slider.on('resized', this.movePaginationToArrows.bind(this));
        this.slider.mount();
    }
    movePaginationToArrows() {
        const arrows = this.querySelector(`.${this.arrowsClassName}`);
        const pagination = this.querySelector(`.${this.paginationClassName}`);
        if (arrows?.querySelector(`.${this.paginationClassName}`)) return;
        if (!arrows || !pagination) return;
        arrows?.insertAdjacentElement('beforeend', pagination);
        this.root?.classList.add(this.loadedClassName);
    }
}






var $a891510b26e6e0ec$exports = {};
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */ (function(global, factory) {
    $a891510b26e6e0ec$exports = factory();
})($a891510b26e6e0ec$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*}/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.3';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint) {
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $cf4d99a15e7ffead$var$sanitize = (content)=>(0, (/*@__PURE__*/$parcel$interopDefault($a891510b26e6e0ec$exports))).sanitize(content, {
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM: false,
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: true
        },
        ADD_TAGS: [
            'use'
        ]
    });
var $cf4d99a15e7ffead$export$2e2bcd8739ae039 = $cf4d99a15e7ffead$var$sanitize;


const $084901060266a3ff$export$7892ac5e21f7f65f = ()=>`${window.location.pathname}${window.location.search}`;
const $084901060266a3ff$export$b133e49578bc0022 = (key)=>{
    window.sessionStorage.removeItem(key);
    return true;
};
const $084901060266a3ff$export$90cc9345251baa19 = (url)=>$084901060266a3ff$export$b133e49578bc0022(url);
const $084901060266a3ff$export$5f485f7748acb272 = (key, value)=>{
    window.sessionStorage.setItem(key, value);
    return true;
};
const $084901060266a3ff$export$9e136a631bf74376 = (key)=>window.sessionStorage.getItem(key);
const $084901060266a3ff$export$ea606431d2f3c045 = (url, replaceSelectors = true)=>{
    const data = JSON.parse($084901060266a3ff$export$9e136a631bf74376(url) || '[]');
    if (!replaceSelectors) return data;
    data.forEach((item)=>{
        const wrapper = document.querySelector(item.selector);
        if (!wrapper) return;
        wrapper.outerHTML = (0, $cf4d99a15e7ffead$export$2e2bcd8739ae039)(item.element);
    });
};
const $084901060266a3ff$export$47393a4c08668ccd = (url, ...selectors)=>{
    const data = [];
    selectors.forEach((selector)=>{
        data.push({
            selector: selector,
            element: document.querySelector(selector)?.outerHTML || ''
        });
    });
    return $084901060266a3ff$export$5f485f7748acb272(url, JSON.stringify(data));
};
const $084901060266a3ff$export$421eaf623316c864 = (url)=>{
    Object.keys(window.sessionStorage).forEach((item)=>{
        if (!(item === url || item.includes('take=async'))) return;
        $084901060266a3ff$export$b133e49578bc0022(item);
    });
};


class $d587f703cacf0ca0$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('button');
        this.action = this.getAttribute('data-tk-action') || window.location.href;
        this.sortFieldName = this.getAttribute('data-tk-article-list-sort-name') || 'field-sort';
        this.articleList = document.querySelector('[data-tk-article-list-to-sort]') || undefined;
        this.headerElement = this.articleList?.querySelector('[data-tk-article-list-header]') || undefined;
        this.gridElement = this.articleList?.querySelector('[data-tk-article-list-grid]') || undefined;
        this.pagingElement = this.articleList?.querySelector('[data-tk-article-list-paging]') || undefined;
    }
    connectedCallback() {
        if (!this.articleList) throw new Error('TKArticleListSort: Article list is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sortList.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    sortList(event) {
        if (!event.target) return;
        const { value: value } = event.currentTarget;
        const data = {
            [this.sortFieldName]: value,
            originalUrl: window.location.href
        };
        const dimmer = (0, $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.action,
            resolveHandler: this.refreshResultList.bind(this),
            payload: data
        }).finally(()=>{
            this.remove();
            dimmer.remove();
        });
    }
    refreshResultList(response) {
        if (!response || !response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const headerElement = html.querySelector('[data-tk-article-list-header]');
        const gridElement = html.querySelector('[data-tk-article-list-grid]');
        const pagingElement = html.querySelector('[data-tk-article-list-paging]');
        if (headerElement) this.headerElement.innerHTML = headerElement.innerHTML;
        if (gridElement) this.gridElement.innerHTML = gridElement.innerHTML;
        if (this.pagingElement && pagingElement) this.pagingElement.innerHTML = pagingElement.innerHTML;
        (0, $084901060266a3ff$export$90cc9345251baa19)((0, $084901060266a3ff$export$7892ac5e21f7f65f)());
    }
}





class $aae44772e434b2fe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.layouts = [];
        this.articleList = document.querySelector('[data-tk-article-list-to-switch-layout]') || undefined;
        this.url = this.getAttribute('data-tk-url') || undefined;
    }
    connectedCallback() {
        if (!this.articleList || !this.url) throw new Error('TKArticleListLayoutSwitch: Elements are missing!');
        this.initLayouts();
        this.registerLayoutListener();
    }
    initLayouts() {
        const fieldElements = this.querySelectorAll('input');
        fieldElements.forEach((element)=>{
            this.layouts.push({
                id: element.value,
                className: element.getAttribute('data-tk-layout-class-name') || undefined
            });
        });
    }
    registerLayoutListener() {
        const radioElements = this.querySelectorAll('input');
        const onInput = this.handleInput.bind(this);
        radioElements.forEach((element)=>{
            this.pushListener({
                event: 'input',
                element: element,
                action: onInput
            });
        });
    }
    handleInput(event) {
        if (!event.target) return;
        const { value: value } = event.target;
        this.switchLayout(value);
        this.saveSelectedLayout(value);
        (0, $084901060266a3ff$export$47393a4c08668ccd)((0, $084901060266a3ff$export$7892ac5e21f7f65f)(), '[data-tk-article-list]');
    }
    switchLayout(id) {
        this.layouts.forEach((item)=>{
            const className = item.className || '';
            this.articleList.classList.contains(className) && this.articleList.classList.remove(className);
        });
        const layoutItem = this.layouts.find((item)=>item.id === id);
        layoutItem?.className && this.articleList.classList.add(layoutItem.className);
    }
    saveSelectedLayout(value) {
        const data = {
            value: value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: ()=>{},
            payload: data
        });
    }
}



class $4c4645f38df6caf9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.scrollingWrapper = this.querySelector('[data-tk-scrolling-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.scrollingWrapper) return;
        this.scrollEnd();
    }
    scrollEnd() {
        const { scrollWidth: scrollWidth } = this.scrollingWrapper;
        const { width: width } = this.scrollingWrapper.getBoundingClientRect();
        this.scrollingWrapper?.scrollTo({
            behavior: 'smooth',
            left: scrollWidth - width
        });
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6 = /*#__PURE__*/ function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
    return SortDirectionEnum;
}({});
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split('.').reverse().join('-');
    const dateFormattedB = b.split('.').reverse().join('-');
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(':').map((item)=>Number(item));
    const splittedB = b.split(':').map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(' ');
    const timeStampListB = b.split(' ');
    const dateA = timeStampListA.at(0)?.split('.').reverse().join('-');
    const dateB = timeStampListB.at(0)?.split('.').reverse().join('-');
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster = /*#__PURE__*/ function(DataMaster) {
    DataMaster["CLIENT"] = "client";
    return DataMaster;
}($2595e2ca594d6789$var$DataMaster || {});
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.gridTemplateColList = [], this.hasAccordionRows = false, this.isHorizontalScrollable = false;
        this.headElement = this.querySelector('[data-tk-table-head]') || undefined;
        if (!this.headElement) throw new Error('Table: Head is missing!');
        this.rowHeadElement = this.headElement.querySelector('[data-tk-table-row]') || undefined;
        this.headShadowClassName = this.getAttribute('data-tk-head-shadow-class-name') || 'tk-table__head-shadow';
        this.isStickyLeft = this.hasAttribute('data-tk-is-sticky-left');
        this.isStickyHead = this.hasAttribute('data-tk-is-sticky-head');
        this.gridTemplateMobile = this.getAttribute('data-tk-grid-template-mobile') || '1fr';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-table--loaded';
        this.stickyLeftClassname = this.getAttribute('data-tk-sticky-left-class-name') || 'tk-table--sticky-left';
        this.rightShadowClassName = this.getAttribute('data-tk-right-shadow-class-name') || 'tk-table__right-shadow';
        this.stickyHeadClassName = this.getAttribute('data-tk-sticky-head-class-name') || 'tk-table--sticky-head';
        this.customCols = this.getAttribute('data-tk-col-width') || 'auto';
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 992;
        this.rowLinkSelector = 'data-tk-table-row-link';
        this.table = this.querySelector('table') || undefined;
        this.ascSortClassName = this.getAttribute('data-tk-asc-sort-class-name') || 'tk-table--sort-asc';
        this.descSortClassName = this.getAttribute('data-tk-desc-sort-class-name') || 'tk-table--sort-desc';
        this.isSortTable = Boolean(this.table?.hasAttribute('data-tk-table-sort'));
        this.colAlignStart = this.hasAttribute('data-tk-col-align-start');
        this.colAlignStartClassName = this.getAttribute('data-tk-col-align-start-class-name') || 'tk-table__col--align-left';
        this.colItemAlignCenter = this.hasAttribute('data-tk-col-item-align-center');
        this.colItemAlignCenterClassName = this.getAttribute('data-tk-col-item-align-center-class-name') || 'tk-table__col--item-align-center';
        this.colItemAlignStart = this.hasAttribute('data-tk-col-item-align-start');
        this.colItemAlignStartClassName = this.getAttribute('data-tk-col-item-align-start-class-name') || 'tk-table__col--item-align-start';
        this.colItemAlignEnd = this.hasAttribute('data-tk-col-item-align-end');
        this.colItemAlignEndClassName = this.getAttribute('data-tk-col-item-align-end-class-name') || 'tk-table__col--item-align-end';
        this.tableSelector = '[data-tk-table-sort]';
        this.sortDirectionSelector = '[data-tk-sort-direction]';
        this.tkSortDirectionSelector = 'tkSortDirection';
        this.tkSortAttrSelector = 'tkSortAttr';
        this.tkSortDatatypeSelector = 'tkSortDatatype';
        this.dataMasterSelector = 'data-tk-datamaster';
        this.dataSortAttrSelector = 'data-tk-sort-attr';
        this.hasAccordionRows = this.hasAttribute('data-tk-accordion-rows');
        this.accordionRowHeadActiveClassName = this.getDataAttribute('accordion-row-head-active-class-name', 'tk-table__row--head-accordion-active');
        this.accordionRowBodyActiveClassName = this.getDataAttribute('accordion-row-body-active-class-name', 'tk-table__row--body-accordion-active');
        this.accordionLastElementClassName = this.getDataAttribute('accordion-last-element-class-name', 'tk-table--accordion-last-row');
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
        this.hasAccordionRows && this.registerAccordionListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const handleHorizontalScrollListener = this.toggleScrollHorizontalBehavior.bind(this);
        this.pushListener({
            event: 'scroll',
            element: this,
            action: handleHorizontalScrollListener
        });
        if (this.isStickyLeft) {
            const handleStickyLeftListener = this.toggleScrollLeftBehavior.bind(this);
            this.pushListener({
                event: 'scroll',
                element: this,
                action: handleStickyLeftListener
            });
        }
        if (this.isStickyHead) {
            const handleStickyHeadListener = this.toggleScrollTopBehavior.bind(this);
            this.pushListener({
                event: 'scroll',
                element: this,
                action: handleStickyHeadListener
            });
        }
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleRowLink
        });
    }
    registerAccordionListener() {
        const onClick = this.handleAccordion.bind(this);
        const rows = this.querySelectorAll('[data-tk-table-row-id]');
        rows.forEach((row)=>{
            this.pushListener({
                event: 'click',
                element: row,
                action: onClick
            });
        });
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest('th');
        column && column.hasAttribute('data-tk-sort-direction') && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',') ? this.gridTemplateColList?.join(' ') : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove('tk-table__title--force-mobile');
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add('tk-table__title--force-mobile');
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = `${element.scrollTop}px`;
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement('afterbegin', this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement('beforeend', this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll('[data-tk-table-row]');
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll('[data-tk-table-value]')).at(headItem.column)?.textContent || '';
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = '';
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: 'tablesort',
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr === sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = '';
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
    handleAccordion(event) {
        const headElement = event.currentTarget;
        const id = headElement.getAttribute('data-tk-table-row-id');
        if (!id) return;
        const bodyElements = this.querySelectorAll(`[data-tk-table-accordion="${id}"]`);
        const isActive = headElement.classList.toggle(this.accordionRowHeadActiveClassName);
        bodyElements.forEach((element, index)=>{
            element.hidden = !isActive;
            element.classList.toggle(this.accordionRowBodyActiveClassName, isActive);
            if (index === bodyElements.length - 1) element.classList.add(this.accordionLastElementClassName);
        });
    }
}


/* eslint-disable max-len */ /* eslint-disable class-methods-use-this */ 


class $7b256aa0b8661d27$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.focusHistory = [], this.allowedToClickBasketButton = true, this.activateBasketButton = false;
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.resetButton = this.querySelector('[data-tk-quick-order-reset]') || undefined;
        this.submitButton = this.querySelector('[data-tk-quick-order-submit]') || undefined;
        this.resultElement = this.querySelector('[data-tk-quick-order-result]') || undefined;
        this.backButton = this.querySelector('[data-tk-quick-order-back]') || undefined;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.hasDataClassName = this.getAttribute('data-tk-has-data-class-name') || 'tk-search--has-data';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search--loading';
        this.chooseKeybind = this.getAttribute('data-tk-choose-keybind') || 'Enter';
        this.navigateUpKeybind = this.getAttribute('data-tk-navigate-up-keybind') || 'ArrowUp';
        this.navigateDownKeybind = this.getAttribute('data-tk-navigate-down-keybind') || 'ArrowDown';
        this.chooseQuantityKeybind = this.getAttribute('data-tk-choose-quantity-keybind') || 'Enter';
        this.closeKeybind = this.getAttribute('data-tk-close-keybind') || 'Escape';
        this.keybinds = [
            {
                keybind: this.closeKeybind,
                action: ()=>this.hideDropdown()
            }
        ];
    }
    connectedCallback() {
        if (!this.url || !this.fieldElement || !this.resetButton || !this.submitButton || !this.resultElement || !this.backButton) throw new Error('TKQuickOrder: Elements are missing!');
        this.registerInputListener();
        this.registerKeydownListener();
        this.registerSubmitListener();
    }
    registerInputListener() {
        const onInput = this.search.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onInput
        });
    }
    registerKeydownListener() {
        this.pushListener({
            event: 'keydown',
            element: this,
            action: this.handleKeydown.bind(this)
        });
    }
    registerSubmitListener() {
        this.pushListener({
            event: 'submit',
            element: this,
            action: this.handleSubmit.bind(this)
        });
    }
    handleKeydown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (event.target.parentElement.classList.contains('tk-search__input')) {
                // Focus bzw. Select in das  Quantity Feld setzen
                const qty = this.resultElement?.querySelector('.tk-article #input_dim1') || undefined;
                if (qty) qty.select();
            }
            if (event.target.closest('input') && event.target.closest('input').id === 'input_dim1') {
                // focus auf den WK Button setzen
                const btn = this.resultElement?.querySelector('.tk-article button[type="submit"]') || undefined;
                if (btn) btn.focus();
            }
            if (event.target.closest('.tk-article button[type="submit"]')) {
                // WK Button klicken und Focus ins Suchfeld setzen
                const searchField = this.querySelector('input[type="search"]') || undefined;
                const btn = event.target.closest('.tk-article button[type="submit"]');
                btn.focus();
                btn.click();
                if (searchField) {
                    searchField.value = '';
                    searchField.focus();
                }
                this.classList.remove('tk-search--has-data');
            }
        }
    }
    handleSubmit(event) {
        event.preventDefault();
    }
    showDropdown() {
        this.classList.add(this.activeClassName);
    }
    hideDropdown() {
        this.classList.remove(this.activeClassName);
    }
    search() {
        const { value: value } = this.fieldElement;
        if (value.length < 3) {
            this.classList.remove(this.hasDataClassName);
            this.timerId && clearTimeout(this.timerId);
            return;
        }
        this.classList.add(this.loadingClassName);
        this.timerId && clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            const data = {
                value: value
            };
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.url,
                resolveHandler: this.renderResult.bind(this),
                payload: data
            });
        }, 500);
    }
    renderResult(response) {
        if (!response || !response.success) return;
        this.classList.remove(this.loadingClassName);
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.resultElement.innerHTML = '';
        this.resultElement.insertAdjacentHTML('afterbegin', html.innerHTML);
        html.childElementCount > 0 && this.classList.add(this.hasDataClassName);
    }
}




class $f1b6481dbe8d89b9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.fieldElement = this.querySelector('textarea[name="textarea-freitext"]') || undefined;
        this.quantity = this.querySelector('input[name="input_dim1"]') || undefined;
        this.submitButton = this.querySelector('[data-tk-freitext-submit]') || undefined;
    }
    connectedCallback() {
        if (!this.url || !this.fieldElement || !this.submitButton || !this.quantity) throw new Error('KDMZFreitext: Elements are missing!');
        this.registerSubmitListener();
    }
    registerSubmitListener() {
        const onSave = this.saveOrder.bind(this);
        this.pushListener({
            event: 'click',
            element: this.submitButton,
            action: onSave
        });
    }
    saveOrder() {
        const data = {
            value: this.fieldElement.value,
            quantity: this.quantity.value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.renderResult.bind(this),
            payload: data
        });
    }
    renderResult(response) {
        if (!response) return;
        // const tabBasket = this.closest('.tk-minibasket__content')?.querySelector(
        //     '[data-minibasket-tab-basket]',
        // ) as HTMLButtonElement;
        // if (!tabBasket || !response.success) return;
        // tabBasket.click();
        const dialogClose = this.closest('.tk-dialog')?.querySelector('.tk-dialog__close');
        if (!dialogClose || !response.success) return;
        // dialogClose.click();
        location.reload();
    }
}



class $4bab5d27fa43c4fc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTabsHead = '[data-tk-tab-head]', this.selectorTabsBody = '[data-tk-tab-body]';
        const tabHead = this.querySelector(this.selectorTabsHead);
        const tabBody = this.querySelector(this.selectorTabsBody);
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-tab--active';
        this.initialTabIndex = Number(this.getAttribute('data-tk-initial-tab')) || 1;
        this.enableLinks = this.hasAttribute('data-tk-enable-links');
        if (!tabHead) throw new Error('TK: Missing Tab-Header');
        if (!tabBody) throw new Error('TK: Missing Tab-Body');
        this.tabList = tabHead.childElementCount > 0 ? tabHead.children : undefined;
        this.tabContentList = tabBody.childElementCount > 0 ? tabBody.children : undefined;
        if (!this.tabList) throw new Error('TK: Empty Tab-Header');
        if (!this.tabContentList) throw new Error('TK: Empty Tab-Content');
        if (this.tabList.length !== this.tabContentList.length && !this.enableLinks) throw new Error('TK: Tab-Header Elements and Tab-Content Elements must be equal');
    }
    connectedCallback() {
        this.registerListener();
        if (this.tabList && +this.initialTabIndex > 0) {
            const button = this.tabList.item(this.initialTabIndex - 1);
            this.setTabActive(button, this.initialTabIndex - 1);
        }
    }
    registerListener() {
        if (this.tabList) [
            ...this.tabList
        ].forEach((element, index)=>{
            const button = element;
            const eventHandler = this.setTabActive.bind(this, button, index);
            this.pushListener({
                event: 'click',
                element: button,
                action: eventHandler
            });
        });
    }
    setTabActive(button, index) {
        const input = button.querySelector('input');
        if (input && input.disabled || button.disabled) return;
        const item = this.tabContentList?.item(index);
        this.setAttribute('data-tk-current-tab', String(index + 1));
        if (!item) {
            const url = button.getAttribute('data-tk-url');
            const target = button.getAttribute('target') || undefined;
            if (!url) return;
            window.open(url, target);
        } else {
            this.setTabInactive();
            button.classList.add(this.activeClassName);
            item.classList.add(this.activeClassName);
        }
        this.toggleRequiredAttribute(index);
    }
    setTabInactive() {
        if (!this.tabContentList) return;
        [
            ...this.tabContentList
        ].forEach((element, index)=>{
            const button = element;
            button.classList.remove(this.activeClassName);
            const item = this.tabList?.item(index);
            if (!item) return;
            item.classList.remove(this.activeClassName);
        });
    }
    toggleRequiredAttribute(index) {
        if (!this.tabContentList) return;
        const currentElement = this.tabContentList.item(index);
        const contentList = Array.from(this.tabContentList);
        const filteredList = contentList.filter((element)=>element !== currentElement);
        filteredList.forEach((element)=>{
            const fieldElements = element.querySelectorAll('input[required]');
            fieldElements.forEach((fieldElement)=>{
                fieldElement.required = false;
                fieldElement.setAttribute('data-tk-is-required', '');
            });
        });
        const fieldElements = currentElement?.querySelectorAll('input[data-tk-is-required]');
        fieldElements?.forEach((fieldElement)=>{
            fieldElement.required = true;
            fieldElement.removeAttribute('data-tk-is-required');
        });
    }
}



class $29c96caf3d8dbc7c$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.dialog = this.querySelector('dialog') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.selectedClassName = this.getAttribute('data-selected-class-name') || 'tk-button__account--selected';
        this.openingType = this.getAttribute('data-opening-type') || 'hover';
        this.alignedRightClassName = this.getAttribute('data-aligned-right-class-name') || 'tk-button__account--right';
        this.onShowEvent = ()=>{};
        this.onCloseEvent = ()=>{};
    }
    disconnectedCallback() {
        this.removeEventListener('mouseenter', this.onShowEvent);
        this.dialog?.removeEventListener('mouseleave', this.onCloseEvent);
    }
    connectedCallback() {
        this.registerOpenListener();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        if (this.openingType === 'click') this.addEventListener('click', this.onShowEvent);
        else this.addEventListener('mouseenter', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        if (this.openingType === 'click') window.addEventListener('click', this.onCloseEvent);
        else {
            this.addEventListener('mouseleave', this.onCloseEvent);
            this.dialog?.addEventListener('mouseleave', this.onCloseEvent);
        }
    }
    show() {
        if (!this.dialog || !this.button) return;
        this.dialog.show();
        this.button.classList.add(this.selectedClassName);
        const { left: left } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    close(event) {
        if (!this.dialog || !this.button) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.button.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.button.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}



class $31cb0bc6f587a976$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.activeClass = 'tk-search-overlay--active';
        this.toggleButtons = this.querySelectorAll('[data-tk-search-toggle]') || undefined;
        this.searchWrapper = this.querySelector('[data-tk-search-wrapper]') || undefined;
    }
    connectedCallback() {
        this.registerClickListener();
    }
    registerClickListener() {
        const toggleSearch = this.toggleSearch.bind(this);
        this.toggleButtons?.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: toggleSearch
            });
        });
    }
    toggleSearch() {
        if (!this.searchWrapper) return;
        this.searchWrapper.classList.toggle(this.activeClass, !this.searchWrapper.classList.contains(this.activeClass));
        document.querySelector('body').classList.toggle('search-overlay--active', this.searchWrapper.classList.contains(this.activeClass));
        if (this.searchWrapper.classList.contains(this.activeClass)) {
            const fieldElement = this.searchWrapper.querySelector('input[type="search"]');
            setTimeout(()=>{
                fieldElement?.select();
                const length = fieldElement?.value.length || 0;
                fieldElement?.setSelectionRange(length, length);
            }, 500);
        }
    }
}








class $8b05e2474621c644$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-count'
        ];
    }
    constructor(){
        super(), this.isDataFetched = false;
        this.headerButton = this.querySelector('[data-tk-header-button]') || undefined;
        this.overlay = this.querySelector('[data-tk-minibasket-overlay]') || undefined;
        this.contentWrapper = this.querySelector('[data-tk-minibasket-content]') || undefined;
        this.countItemsRequestURL = this.getAttribute('data-tk-count-items-request-url') || undefined;
        this.getContentRequestURL = this.getAttribute('data-tk-get-content-request-url') || undefined;
        this.headerButtonEmptyClassName = this.getAttribute('data-tk-header-button-empty-class-name') || 'tk-button__header--empty';
        this.offset = Number(this.getAttribute('data-tk-minibasket-offset')) || 4;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-minibasket--open';
        this.minDistanceToBorder = Number(this.getAttribute('data-tk-min-distance-to-border')) || 5;
        // Custom Events
        this.openedEventName = this.getAttribute('data-tk-event-opened-name') || 'tk-minibasket-opened';
        this.openedEvent = new CustomEvent(this.openedEventName);
        this.closedEventName = this.getAttribute('data-tk-event-closed-name') || 'tk-minibasket-closed';
        this.closedEvent = new CustomEvent(this.closedEventName);
        this.updateEventName = this.getAttribute('data-tk-event-update-name') || 'tk-minibasket-update';
        this.updateEvent = new CustomEvent(this.updateEventName);
    }
    connectedCallback() {
        if (!this.headerButton) throw new Error('Minibasket: Header Button is missing!');
        if (!this.countItemsRequestURL || !this.getContentRequestURL) throw new Error('Minibasket: Request URLs are missing!');
        this.registerInitializeListener();
        this.fetchQuantity();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-count') this.setCounter(Number(newValue));
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: 'click',
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerScrollListener() {
        const handleScroll = this.alignOverlayToButton.bind(this);
        this.pushListener({
            event: 'scroll',
            element: window,
            action: handleScroll
        });
    }
    open() {
        document.body.insertAdjacentElement('beforeend', this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
    }
    opened() {
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
            this.registerScrollListener();
        }, 0);
    }
    update() {
        this.fetchQuantity();
        this.fetchAll();
    }
    close(event) {
        if (!this.overlay) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
        }
    }
    fetchAll() {
        Promise.all([
            $8b05e2474621c644$export$2e2bcd8739ae039.fetchData(this.getContentRequestURL)
        ]).then((responses)=>{
            this.isDataFetched = true;
            this.placeContent(responses[0]);
        }).catch(()=>{
            this.isDataFetched = false;
        });
    }
    fetchQuantity() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.countItemsRequestURL,
            resolveHandler: this.getQuantity.bind(this)
        });
    }
    static fetchData(url) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    getQuantity(response) {
        if (!response || !response.success) return;
        const { quantity: quantity } = response.dataAsJson;
        this.setCounter(quantity);
    }
    setCounter(quantity) {
        if (quantity === 0) this.headerButton?.classList.add(this.headerButtonEmptyClassName);
        else {
            this.headerButton?.setAttribute('data-count', `${quantity || 0}`);
            this.headerButton?.classList.remove(this.headerButtonEmptyClassName);
        }
    }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.contentWrapper.innerHTML = '';
        this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
    }
    alignOverlayToButton() {
        const { bottom: bottom, right: right } = this.headerButton.getBoundingClientRect();
        const { width: width } = this.overlay.getBoundingClientRect();
        const distanceToBorder = right - width;
        this.overlay.style.top = `${bottom + this.offset}px`;
        if (distanceToBorder >= this.minDistanceToBorder) this.overlay.style.left = `${right - width}px`;
        else {
            this.overlay.style.left = '50%';
            this.overlay.style.transform = 'translateX(-50%)';
        }
    }
}



class $83b244d711489b95$export$2e2bcd8739ae039 extends (0, $8b05e2474621c644$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.header = this.closest('.viewport')?.querySelector('[data-tk-header]') || undefined;
        this.subheader = this.closest('.viewport')?.querySelector('[data-tk-header-subheader]') || undefined;
        this.miniBasketHeader = this.querySelector('.tk-minibasket__header') || undefined;
        this.tabBasketButtonSelector = '[data-minibasket-tab-basket]';
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: 'click',
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
        const handleUpdateBasketList = this.updateBasketList.bind(this);
        if (this.contentWrapper) this.pushListener({
            event: 'click',
            element: this.contentWrapper,
            action: handleUpdateBasketList
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
        if (this.miniBasketHeader) this.pushListener({
            event: 'click',
            element: this.miniBasketHeader,
            action: handleClose
        });
    }
    open() {
        document.body.classList.add('body--fixed');
        document.body.insertAdjacentElement('beforeend', this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
        this.overlay.style.height = `${this.overlay.clientHeight.toString()}px`;
    }
    close(event) {
        const targetElement = event.target;
        if (!this.overlay || targetElement.closest('[data-tk-action="change"]') || targetElement instanceof HTMLButtonElement) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.overlay.classList.remove('tk-minibasket__overlay--oopen');
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
            document.body.classList.remove('body--fixed');
        }
    }
    alignOverlayToButton() {
        const viewport = document.querySelector('[data-tk-viewport]');
        const currentBreakpoint = viewport?.getCurrentBreakpoint(window.innerWidth);
        const { bottom: bottom } = this.subheader ? this.subheader.getBoundingClientRect() : this.header.getBoundingClientRect();
        if (currentBreakpoint === 'l' || currentBreakpoint === 'xl') {
            this.overlay.style.top = `${bottom}px`;
            this.overlay.classList.add('tk-minibasket__overlay--oopen');
        } else {
            this.overlay.style.top = '0px';
            this.overlay.classList.add('tk-minibasket__overlay--oopen');
        }
    }
    // placeContent(response: TKResponse): void {
    //     if (!response || !response.success) return;
    //     if (!this.contentWrapper) return;
    //     const items = render<HTMLElement>(response.dataAsHtml);
    //     this.contentWrapper.innerHTML = '';
    //     this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
    // }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const currentMiniBasketAccordion = this.contentWrapper.querySelector('[data-tk-basket-list] .tk-tabs-accordion--active');
        if (currentMiniBasketAccordion) {
            // const currentContentWrapper = currentMiniBasketAccordion.querySelector('.tk-tabs-accordion__body') as HTMLElement;
            // if (currentContentWrapper) {
            //     const currentContentWrapperNumber = currentMiniBasketAccordion.dataset.saldocBoid;
            //     const divItem = document.createElement('div');
            //     currentContentWrapper.innerHTML = '';
            //     divItem.insertAdjacentHTML('beforeend', items.innerHTML);
            //     const itemsCurrentWrapper = divItem.querySelector(`[data-saldoc-boid="${currentContentWrapperNumber}"]`);
            //     currentContentWrapper.insertAdjacentHTML('beforeend', itemsCurrentWrapper.innerHTML);
            // }
            const accContent = currentMiniBasketAccordion.querySelector('[data-tk-accordion-content]');
            const asyncUrl = currentMiniBasketAccordion.getAttribute('data-content-url') || undefined;
            if (asyncUrl) {
                const htmlString = '<div class="kdmz-loading-icon"><div></div><div></div><div></div><div></div></div>';
                const loadingElement = document.createElement('div');
                loadingElement.innerHTML = htmlString;
                loadingElement.classList.add('flex', 'flex--justify-center', 'spacer-mb-4', 'spacer-mt-4', 'kdmz-loading-icon__wrapper');
                if (!accContent) return;
                // accContent.innerHTML = '';
                if (accContent.innerHTML.trim() === '') accContent.append(loadingElement);
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: asyncUrl,
                    resolveHandler: this.handleResponseSuccess.bind(this, asyncUrl, accContent)
                });
            }
        } else {
            this.contentWrapper.innerHTML = '';
            this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
        }
    }
    handleResponseSuccess(url, accContent, response) {
        if (!response || !response.success) return;
        const content = accContent;
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
    }
    updateBasketList(event) {
        // if event.
        // this.fetchAll();
        const evtTarget = event.target;
        const tabBasketButton = evtTarget.closest(this.tabBasketButtonSelector);
        if (tabBasketButton) {
            console.log('tabBasketButton', event.target);
            this.fetchAll();
        }
    }
}





class $a9217f7f02c1b9b3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.timerID = null, this.initial = false;
        this.viewport = {
            element: document.querySelector('.viewport'),
            clickClassName: this.getAttribute('data-viewport-click-class-name'),
            hasDataClassName: this.getAttribute('data-viewport-has-data-class-name'),
            nothingFoundClassName: this.getAttribute('data-viewport-nothing-found-class-name')
        };
        this.fieldElement = this.querySelector('input');
        this.resetButton = this.querySelector('[data-tk-search-reset]');
        this.hasValueClassName = this.getAttribute('data-has-value-class-name');
        this.hasClickClassName = this.getAttribute('data-click-class-name');
        this.isLoadingClassName = this.getAttribute('data-is-loading-class-name');
        this.hasDataClassName = this.getAttribute('data-has-data-class-name');
        this.nothingFoundClassName = this.getAttribute('data-nothing-found-class-name');
        this.nothingFoundText = this.getAttribute('data-nothing-found-text');
        this.activeClassName = this.getAttribute('data-active-class-name');
        this.url = this.getAttribute('data-url');
        this.initialURL = this.getAttribute('data-initial-url');
        this.searchTermReplace = this.getAttribute('data-search-term');
        this.headerWrapper = this.closest('[data-header-search]');
        this.resultWrapper = this.querySelector('[data-search-result]');
        this.filterResultWrapper = this.querySelector('[data-filter-result]');
        this.enterClickSelector = this.getAttribute('data-enter-click-element');
        this.hasSuggest = this.hasAttribute('data-has-suggest');
        if (this.hasSuggest) this.suggestTextField = this.querySelector('[data-search-suggest]');
        this.modalOptionModel = this.getAttribute('data-modal-option-model');
    }
    static get observedAttributes() {
        return [
            'data-reset-field'
        ];
    }
    connectedCallback() {
        if (!this.fieldElement || !this.url) throw new Error('KDMZSearch: Elements are missing!');
        if (this.hasValueClassName) {
            this.registerInputListener();
            this.registerResetListener();
            this.checkForValue();
        }
        if (this.url) this.registerSearchListener();
        if (this.hasClickClassName) {
            this.registerClickListener();
            this.registerFocusOutListener();
        }
        if (this.enterClickSelector) this.registerEnterClickEvent();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.initial = false;
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-reset-field' && newValue === 'true') this.resetField();
    }
    registerClickListener() {
        const listener = this.showField.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: listener
        });
    }
    registerFocusOutListener() {
        if (!this.fieldElement) return;
        const listener = this.hideField.bind(this);
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: listener
        });
    }
    registerInputListener() {
        if (!this.fieldElement) return;
        const listener = this.checkForValue.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: listener
        });
    }
    registerResetListener() {
        if (!this.resetButton) return;
        const listener = this.resetField.bind(this);
        this.pushListener({
            event: 'click',
            element: this.resetButton,
            action: listener
        });
    }
    registerSearchListener() {
        if (!this.fieldElement) return;
        const listener = this.search.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: listener
        });
    }
    registerEnterClickEvent() {
        if (!this.fieldElement) return;
        const listener = this.handleEnterClickListener.bind(this);
        this.pushListener({
            event: 'keypress',
            element: this.fieldElement,
            action: listener
        });
    }
    checkForValue() {
        if (!this.fieldElement) return;
        if (this.fieldElement.value) this.classList.add(this.hasValueClassName);
        else {
            this.classList.remove(this.hasValueClassName);
            this.classList.remove(this.hasDataClassName);
            this.classList.remove(this.nothingFoundClassName);
            this.viewport.element?.classList.remove(this.viewport.hasDataClassName);
            this.viewport.element?.classList.remove(this.viewport.nothingFoundClassName);
            this.initial ? this.resetResult() : this.initial = true;
            this.hasSuggest && (this.suggestTextField.textContent = '');
        }
    }
    resetField() {
        if (!this.fieldElement || this.fieldElement.value === '') return;
        this.fieldElement.value = '';
        this.checkForValue();
    }
    showField() {
        this.classList.add(this.hasClickClassName);
        this.viewport.element?.classList.add(this.viewport.clickClassName);
    }
    hideField() {
        if (!this.fieldElement || this.fieldElement.value) return;
        this.classList.remove(this.hasClickClassName);
        this.viewport.element?.classList.remove(this.viewport.clickClassName);
    }
    resetResult() {
        if (this.initialURL) (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.initialURL,
            resolveHandler: this.searchResponse.bind(this),
            rejectHandler: this.errorResponse.bind(this)
        });
        else this.resultWrapper && (this.resultWrapper.innerHTML = '');
    }
    search() {
        const value = this.fieldElement?.value || '';
        const formURL = this.url;
        if (value.length < 3) {
            this.classList.remove(this.hasDataClassName);
            this.classList.remove(this.nothingFoundClassName);
            this.viewport.element?.classList.remove(this.viewport.hasDataClassName);
            this.viewport.element?.classList.remove(this.viewport.nothingFoundClassName);
            this.timerID && clearTimeout(this.timerID);
            return;
        }
        this.classList.add(this.isLoadingClassName);
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            const searchUrl = new URL(formURL);
            searchUrl.searchParams.set('query', value);
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: searchUrl.toString(),
                resolveHandler: this.searchResponse.bind(this),
                rejectHandler: this.errorResponse.bind(this)
            });
        }, 300);
    }
    searchResponse(response) {
        if (response && response.success) {
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
            this.resultWrapper.innerHTML = html.innerHTML;
            this.classList.remove(this.isLoadingClassName);
            this.classList.add(this.hasDataClassName);
            this.classList.remove(this.nothingFoundClassName);
            this.viewport.element?.classList.remove(this.viewport.nothingFoundClassName);
            this.viewport.element?.classList.add(this.viewport.hasDataClassName);
            if (this.enterClickSelector) {
                const formFields = this.resultWrapper.querySelectorAll('input, textarea');
                formFields.forEach((field)=>{
                    this.pushListener({
                        event: 'keydown',
                        element: field,
                        action: this.handleEnterClickListener.bind(this)
                    });
                });
            }
            if (this.hasSuggest) {
                const suggestElement = html.querySelector('[data-search-result-suggest]');
                const suggest = suggestElement?.textContent || '';
                this.suggestTextField.textContent = suggest;
            }
        }
    }
    errorResponse() {
        this.classList.remove(this.isLoadingClassName);
        this.classList.add(this.nothingFoundClassName);
        this.viewport.element?.classList.add(this.viewport.nothingFoundClassName);
        this.resultWrapper.innerHTML = `<div data-no-serach-result-found class="search--nothing-found-area">
            <span>${this.nothingFoundText}</span>
        </div>`;
    }
    handleEnterClickListener(event) {
        if (event.key !== 'Enter') return;
        const basketButton = this.querySelector(this.enterClickSelector);
        basketButton && basketButton.click();
        this.fieldElement?.focus();
        const length = this.fieldElement?.value.length || 0;
        this.fieldElement?.setSelectionRange(length, length);
    }
}



class $1dbde1f973386300$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-tk-quantity'
        ];
    }
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.quantity = Number(this.getAttribute('data-tk-quantity'));
        this.isMulti = this.hasAttribute('data-tk-is-multi');
        this.href = this.getAttribute('data-tk-href') || '';
        this.emptyClassName = this.getAttribute('data-tk-empty-class-name') || 'tk-button__header--empty';
        this.disabledClassName = this.getAttribute('data-tk-disabled-class-name') || 'tk-button__header--disabled';
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-tk-quantity') {
            if (!this.anchor) return;
            this.anchor.setAttribute('data-count', newValue);
            this.anchor.classList.toggle(this.emptyClassName, Number(newValue) === 0);
            this.anchor.classList.toggle(this.disabledClassName, Number(newValue) === 0);
        // eslint-disable-next-line no-script-url
        // this.anchor.href = Number(newValue) === 0 ? 'javascript:void(0)' : this.href;
        }
    }
}




class $15716c1752b56a37$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.accordionHead = this.querySelector('[data-tk-accordion-head]') || undefined;
        this.accordionBody = this.querySelector('[data-tk-accordion-body]') || undefined;
        this.accordionContent = this.querySelector('[data-tk-accordion-content]') || undefined;
        this.accordionIcon = this.querySelector('[data-tk-accordion-icon]') || undefined;
        this.accordionIcons = {
            iconAdd: this.getAttribute('data-tk-icon-open') || 'tk-icon-add',
            iconRemove: this.getAttribute('data-tk-icon-collapse') || 'tk-icon-remove'
        };
        this.isActive = this.hasAttribute('data-tk-accordion-is-active');
        this.isHeaderLink = this.accordionHead && this.accordionHead.hasAttribute('data-tk-accordion-link');
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-accordion--active';
        this.asyncUrl = this.getAttribute('data-content-url') || undefined;
    }
    connectedCallback() {
        if ((!this.accordionHead || !this.accordionBody || !this.accordionIcon) && !this.isHeaderLink) throw new Error('Accordion: Elements are missing!');
        this.setAccordionState(this.isActive);
        this.registerListener();
        this.openOnInit();
    }
    registerListener() {
        const eventHandler = this.toggleEvent.bind(this);
        this.pushListener({
            event: 'click',
            element: this.accordionHead,
            action: eventHandler
        });
    }
    toggleEvent() {
        this.toggleMarkupElements();
        if (this.asyncUrl && this.accordionContent?.innerHTML === '') {
            const htmlString = '<div class="kdmz-loading-icon"><div></div><div></div><div></div><div></div></div>';
            const loadingElement = document.createElement('div');
            loadingElement.innerHTML = htmlString;
            loadingElement.classList.add('flex', 'flex--justify-center', 'spacer-mb-4', 'spacer-mt-4');
            this.accordionContent.append(loadingElement);
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.asyncUrl,
                resolveHandler: this.handleResponseSuccess.bind(this, this.asyncUrl)
            });
        }
    }
    openOnInit() {
        if (this.hasAttribute('data-open-on-init')) {
            this.toggleMarkupElements();
            this.accordionHead.classList.add('tk-tabs-accordion--active');
            if (this.asyncUrl && this.accordionContent?.innerHTML === '') {
                const htmlString = '<div class="kdmz-loading-icon"><div></div><div></div><div></div><div></div></div>';
                const loadingElement = document.createElement('div');
                loadingElement.innerHTML = htmlString;
                loadingElement.classList.add('flex', 'flex--justify-center', 'spacer-mb-4', 'spacer-mt-4');
                this.accordionContent.append(loadingElement);
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: this.asyncUrl,
                    resolveHandler: this.handleResponseSuccess.bind(this, this.asyncUrl)
                });
            }
        }
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        const content = this.accordionContent;
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
    }
    toggleMarkupElements() {
        if (this.closest('.tk-tabs-accordion__group')) {
            const currentState = this.classList.contains(this.activeClassName);
            this.closeAllAccordions();
            if (currentState) {
                this.classList.remove(this.activeClassName);
                this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
                this.accordionIcon?.classList.remove(this.accordionIcons.iconRemove);
            } else {
                this.classList.add(this.activeClassName);
                this.accordionIcon?.classList.remove(this.accordionIcons.iconAdd);
                this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
            }
        } else {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.toggle(this.accordionIcons.iconAdd);
            this.accordionIcon?.classList.toggle(this.accordionIcons.iconRemove);
        }
        const group = this.closest('.tk-tabs-accordion__group');
        const allOnInitAccordions = group.querySelectorAll('[data-open-on-init]');
        allOnInitAccordions.forEach((accordion)=>{
            accordion.classList.add('tk-tabs-accordion--active');
        });
    }
    setAccordionState(isActive) {
        if (isActive) {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
        } else this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
    }
    closeAllAccordions() {
        const group = this.closest('.tk-tabs-accordion__group');
        const allAccordions = group.querySelectorAll('.tk-tabs-accordion--active');
        allAccordions.forEach((accordion)=>{
            accordion.classList.remove('tk-tabs-accordion--active');
            accordion.querySelector('[data-tk-accordion-icon]')?.classList.toggle(this.accordionIcons.iconAdd);
            accordion.querySelector('[data-tk-accordion-icon]')?.classList.toggle(this.accordionIcons.iconRemove);
        });
    }
}





const $b314948e6a7c6950$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch  {
        return {
            isValid: false
        };
    }
};
var $b314948e6a7c6950$export$2e2bcd8739ae039 = $b314948e6a7c6950$var$isValidJSON;


const $3507ba4caf4aa34e$var$parseBooleanOrString = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};
var $3507ba4caf4aa34e$export$2e2bcd8739ae039 = $3507ba4caf4aa34e$var$parseBooleanOrString;


const $bf3fdf42d85858f4$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
var $bf3fdf42d85858f4$export$2e2bcd8739ae039 = $bf3fdf42d85858f4$var$toSnakeCase;


class $0efda1b115753384$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasItems = false, this.attributeList = [];
        this.trackerElement = this.closest('[data-tk-tracker-wrapper]') || undefined;
        this.event = this.getAttribute('data-tk-event') || undefined;
        this.isAsync = this.hasAttribute('data-tk-is-async');
        this.asyncAttributesURL = this.getAttribute('data-tk-async-attributes-url') || undefined;
        this.trackerType = this.getAttribute('data-tk-tracker-type') || undefined;
        this.hasItems = this.hasAttribute('data-tk-has-items');
        this.itemsKey = this.getDataAttribute('has-items', 'items');
        this.location = window.location.href;
    }
    async connectedCallback() {
        if (!this.trackerElement) throw new Error('Tracker Element is missing!');
        if (!this.event) throw new Error('Event is not defined');
        if (this.isAsync) this.init();
        else this.pushListener({
            event: 'tk-tracker-ready',
            element: this.trackerElement,
            action: this.init.bind(this)
        });
    }
    async init() {
        this.attributeList = this.extractAttributesFrom(this);
        if (this.hasItems) this.collectItemAttributes();
        await this.getAsyncAttributes();
        this.pushTracker();
    }
    extractAttributesFrom(element) {
        return Object.keys(element.dataset).filter((key)=>!key.startsWith('tk')).map((key)=>this.createAttribute(key, element.dataset[key])).filter(Boolean);
    }
    createAttribute(key, value) {
        const result = (0, $b314948e6a7c6950$export$2e2bcd8739ae039)(value);
        return {
            key: key,
            value: result.isValid ? result.json : (0, $3507ba4caf4aa34e$export$2e2bcd8739ae039)(value)
        };
    }
    collectItemAttributes() {
        const items = Array.from(this.querySelectorAll('[data-tk-item]'));
        const itemAttributes = items.map((item)=>this.extractAttributesFrom(item)).map(this.mapToSnakeCase);
        this.attributeList.push({
            key: this.itemsKey,
            value: itemAttributes
        });
    }
    mapToSnakeCase(attributes) {
        return attributes.reduce((acc, attr)=>{
            const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
            // Wenn der Wert ein Array ist, konvertiere ihn in einen String (z.B. JSON.stringify)
            if (Array.isArray(attr.value)) acc[key] = JSON.stringify(attr.value);
            else acc[key] = attr.value;
            return acc;
        }, {});
    }
    async getAsyncAttributes() {
        if (!this.asyncAttributesURL) return;
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncAttributesURL,
            resolveHandler: this.handleAsyncAttributes.bind(this)
        });
    }
    handleAsyncAttributes(response) {
        Object.entries(response.dataAsJson.attributes).forEach(([key, value])=>{
            this.attributeList.push({
                key: value,
                value: response.dataAsJson[key]
            });
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                trackerType: this.trackerType,
                item: item
            }
        }));
    }
}


var $5e6391609e4b352e$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $5e6391609e4b352e$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $983d310815fae63e$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $983d310815fae63e$export$2e2bcd8739ae039 = $983d310815fae63e$export$33e6c23ebe2ee669;


var $1aad83eefaa11659$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $1aad83eefaa11659$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $1aad83eefaa11659$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $1aad83eefaa11659$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $8d7d2474ed9a5f7d$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $8d7d2474ed9a5f7d$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $8d7d2474ed9a5f7d$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $8d7d2474ed9a5f7d$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $8d7d2474ed9a5f7d$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $763bd4de3a8b9966$var$doNothing = function() {
    return undefined;
};
var $763bd4de3a8b9966$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $763bd4de3a8b9966$export$9490b78b888a863f = {
    D: $763bd4de3a8b9966$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $763bd4de3a8b9966$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $763bd4de3a8b9966$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $763bd4de3a8b9966$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $763bd4de3a8b9966$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$763bd4de3a8b9966$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c($763bd4de3a8b9966$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)($763bd4de3a8b9966$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $d16da6e601d564a3$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $d16da6e601d564a3$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $5e6391609e4b352e$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $763bd4de3a8b9966$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $d16da6e601d564a3$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $d16da6e601d564a3$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $d16da6e601d564a3$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $d16da6e601d564a3$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $d16da6e601d564a3$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $d16da6e601d564a3$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $d16da6e601d564a3$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $9986d07d28cc86ca$var$__assign = undefined && undefined.__assign || function() {
    $9986d07d28cc86ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9986d07d28cc86ca$var$__assign.apply(this, arguments);
};
var $9986d07d28cc86ca$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS = 300;
function $9986d07d28cc86ca$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, (0, $5e6391609e4b352e$export$ebe90cb607ad99e)), $9986d07d28cc86ca$var$flatpickr.defaultConfig),
        l10n: (0, $983d310815fae63e$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $d16da6e601d564a3$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $d16da6e601d564a3$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $d16da6e601d564a3$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(triggerChange, $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $9986d07d28cc86ca$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $9986d07d28cc86ca$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $d16da6e601d564a3$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $d16da6e601d564a3$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.dateFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.altFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $5e6391609e4b352e$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $9986d07d28cc86ca$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $8d7d2474ed9a5f7d$export$25245567f53f158f)((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(isHourElem) && (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $9986d07d28cc86ca$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $9986d07d28cc86ca$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr([
            this
        ], config);
    };
}
var $9986d07d28cc86ca$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $9986d07d28cc86ca$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $9986d07d28cc86ca$var$_flatpickr([
        selector
    ], config);
    else return $9986d07d28cc86ca$var$_flatpickr(selector, config);
};
$9986d07d28cc86ca$var$flatpickr.defaultConfig = {};
$9986d07d28cc86ca$var$flatpickr.l10ns = {
    en: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039)),
    default: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039))
};
$9986d07d28cc86ca$var$flatpickr.localize = function(l10n) {
    $9986d07d28cc86ca$var$flatpickr.l10ns.default = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), l10n);
};
$9986d07d28cc86ca$var$flatpickr.setDefaults = function(config) {
    $9986d07d28cc86ca$var$flatpickr.defaultConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.defaultConfig), config);
};
$9986d07d28cc86ca$var$flatpickr.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({});
$9986d07d28cc86ca$var$flatpickr.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)({});
$9986d07d28cc86ca$var$flatpickr.compareDates = (0, $d16da6e601d564a3$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $9986d07d28cc86ca$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $9986d07d28cc86ca$var$flatpickr;
var $9986d07d28cc86ca$export$2e2bcd8739ae039 = $9986d07d28cc86ca$var$flatpickr;





var $dad224760cee6051$exports = {};
(function(global, factory) {
    factory($dad224760cee6051$exports);
})($dad224760cee6051$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $34ba2808af177678$exports = {};
(function(global, factory) {
    factory($34ba2808af177678$exports);
})($34ba2808af177678$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var French = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam"
            ],
            longhand: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ]
        },
        months: {
            shorthand: [
                "janv",
                "f\xe9vr",
                "mars",
                "avr",
                "mai",
                "juin",
                "juil",
                "ao\xfbt",
                "sept",
                "oct",
                "nov",
                "d\xe9c"
            ],
            longhand: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ]
        },
        ordinal: function(nth) {
            if (nth > 1) return "";
            return "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "D\xe9filer pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: true
    };
    fp.l10ns.fr = French;
    var fr = fp.l10ns;
    exports1.French = French;
    exports1.default = fr;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $2d773c0dc38d1892$exports = {};
(function(global, factory) {
    factory($2d773c0dc38d1892$exports);
})($2d773c0dc38d1892$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Italian = {
        weekdays: {
            shorthand: [
                "Dom",
                "Lun",
                "Mar",
                "Mer",
                "Gio",
                "Ven",
                "Sab"
            ],
            longhand: [
                "Domenica",
                "Luned\xec",
                "Marted\xec",
                "Mercoled\xec",
                "Gioved\xec",
                "Venerd\xec",
                "Sabato"
            ]
        },
        months: {
            shorthand: [
                "Gen",
                "Feb",
                "Mar",
                "Apr",
                "Mag",
                "Giu",
                "Lug",
                "Ago",
                "Set",
                "Ott",
                "Nov",
                "Dic"
            ],
            longhand: [
                "Gennaio",
                "Febbraio",
                "Marzo",
                "Aprile",
                "Maggio",
                "Giugno",
                "Luglio",
                "Agosto",
                "Settembre",
                "Ottobre",
                "Novembre",
                "Dicembre"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return "\xb0";
        },
        rangeSeparator: " al ",
        weekAbbreviation: "Se",
        scrollTitle: "Scrolla per aumentare",
        toggleTitle: "Clicca per cambiare",
        time_24hr: true
    };
    fp.l10ns.it = Italian;
    var it = fp.l10ns;
    exports1.Italian = Italian;
    exports1.default = it;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $f182ee79b4a84e83$exports = {};
(function(global, factory) {
    factory($f182ee79b4a84e83$exports);
})($f182ee79b4a84e83$exports, function(exports1) {
    'use strict';
    var english = {
        weekdays: {
            shorthand: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        daysInMonth: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        firstDayOfWeek: 0,
        ordinal: function(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch(s % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: [
            "AM",
            "PM"
        ],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: false
    };
    exports1.default = english;
    exports1.english = english;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $99c23931b84cf5a0$var$DatePickerLocale = /*#__PURE__*/ function(DatePickerLocale) {
    DatePickerLocale["DE"] = "de";
    DatePickerLocale["FR"] = "fr";
    DatePickerLocale["IT"] = "it";
    DatePickerLocale["EN"] = "en";
    return DatePickerLocale;
}($99c23931b84cf5a0$var$DatePickerLocale || {});
class $99c23931b84cf5a0$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input') || undefined;
        const localeValue = this.getAttribute('data-tk-locale');
        this.localeKey = localeValue && $99c23931b84cf5a0$var$DatePickerLocale[localeValue.toUpperCase()] || "de";
        this.allowMobile = this.hasAttribute('data-tk-allow-mobile');
        this.config = {
            positionElement: this.fieldElement,
            disableMobile: !this.allowMobile,
            locale: this.localeKey,
            wrap: true,
            allowInput: true,
            onValueUpdate: this.handleValueUpdate.bind(this)
        };
    }
    connectedCallback() {
        if (!this.fieldElement) return;
        $99c23931b84cf5a0$export$2e2bcd8739ae039.initLanguages();
    }
    handleValueUpdate() {
        this.fieldElement?.removeAttribute('data-tk-ignore-field');
        this.fieldElement?.dispatchEvent(new InputEvent('input'));
    }
    static initLanguages() {
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $dad224760cee6051$exports.German));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $34ba2808af177678$exports.French));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $2d773c0dc38d1892$exports.Italian));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $f182ee79b4a84e83$exports.english));
    }
}


class $e018ac17002873dc$export$2e2bcd8739ae039 extends (0, $99c23931b84cf5a0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.hideWeekNumbers = this.hasAttribute('data-tk-hide-week-numbers');
        this.minDate = this.getAttribute('data-tk-min-date');
        this.maxDate = this.getAttribute('data-tk-max-date');
        this.mode = this.getAttribute('data-tk-mode') || 'single';
        this.monthSelectorType = this.getAttribute('data-tk-month-selector-type') || 'dropdown';
        this.dateFormat = this.getAttribute('data-tk-date-format') || 'd.m.Y';
        this.conjunction = this.getAttribute('data-tk-conjunction') || ',';
        this.defaultDate = this.getAttribute('data-tk-default-date')?.split(';') || null;
        this.disableDates = this.getAttribute('data-tk-disable-dates')?.split(';') || [];
        this.disableWeekend = this.hasAttribute('data-tk-disable-weekend');
        if (this.getAttribute('data-tk-disable-dates-range')) this.disableDatesRange = JSON.parse(this.getAttribute('data-tk-disable-dates-range'));
    }
    connectedCallback() {
        super.connectedCallback();
        const datePickerConfig = {
            weekNumbers: !this.hideWeekNumbers,
            dateFormat: this.dateFormat,
            minDate: this.minDate,
            maxDate: this.maxDate,
            mode: this.mode,
            monthSelectorType: this.monthSelectorType,
            conjunction: this.conjunction,
            defaultDate: this.defaultDate,
            disable: this.disableDateRanges(),
            onReady: (selectedDates, dateStr, instance)=>{
                this.createCustomActionButtons(instance);
            }
        };
        const config = {
            ...this.config,
            ...datePickerConfig
        };
        this.flatpickr = (0, $9986d07d28cc86ca$export$2e2bcd8739ae039)(this, config);
    }
    renderButton(label, className, action) {
        const button = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            <button class="${className}">
                ${label}
            </button>
        `);
        this.pushListener({
            event: 'click',
            element: button,
            action: action
        });
        return button;
    }
    createCustomActionButtons(instance) {
        const { calendarContainer: calendarContainer } = instance;
        const wrapper = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="flatpickr-calendar__actions-area"></div>');
        const resetButton = this.renderButton(window.opacc.projectDatepickerTexts.reset, 'tk-button tk-button--secondary tk-button--size-s', this.resetDatePicker.bind(this));
        const todayButton = this.renderButton(window.opacc.projectDatepickerTexts.today, 'tk-button tk-button--secondary tk-button--size-s', this.jumpToToday.bind(this));
        wrapper.appendChild(todayButton);
        wrapper.appendChild(resetButton);
        calendarContainer.appendChild(wrapper);
    }
    jumpToToday() {
        const today = new Date();
        this.flatpickr?.setDate(today, true);
        this.flatpickr?.jumpToDate(today);
    }
    resetDatePicker() {
        this.flatpickr?.clear();
    }
    disableDateRanges() {
        const disableWeekend = (date)=>date.getDay() === 0 || date.getDay() === 6;
        this.disableDates = this.disableDates.map((element)=>element.replace('\n', '').trim());
        return [
            ...this.disableDatesRange ?? [],
            ...this.disableDates ?? [],
            ...this.disableWeekend ? [
                disableWeekend.bind(this)
            ] : []
        ];
    }
}



var $0b37eca09bdd445d$var$HoverState = /*#__PURE__*/ function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
    return HoverState;
}($0b37eca09bdd445d$var$HoverState || {});
class $0b37eca09bdd445d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input, select, textarea');
        this.labelElement = this.querySelector('label') || undefined;
        this.isMaterial = this.hasAttribute('data-tk-is-material');
        this.materialClass = this.getAttribute('data-tk-material-class') || 'tk-form-material';
        this.materialNumberInputClass = this.getAttribute('data-tk-material-number-input-class') || 'tk-form-material--number';
        this.materialLabelInsideClass = this.getAttribute('data-tk-material-label-inside-class') || 'tk-form-material--label-inside';
        this.materialSelectFocussedClass = this.getAttribute('data-tk-material-select-focussed-class') || 'tk-form-select--focussed';
        this.materialLoadedClass = this.getAttribute('data-tk-material-loaded-class') || 'tk-form-material--loaded';
        this.isPasswordInput = this.hasAttribute('data-tk-toggle-password');
        this.disableOnAddonClick = this.hasAttribute('data-tk-disable-on-addon-click');
        this.addonElement = this.querySelector('[data-tk-addon]') || undefined;
        this.waitForSurroundingContent = this.closest('[data-wait-for-surrounding-content]') || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute('data-tk-addon-default-padding') || '0', 10) || 4;
        this.onTransitionEnd = ()=>{};
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required')) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute('disabled');
        this.classList.toggle('tk-form-input--disabled', addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: 'click',
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: 'mouseenter',
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: 'mouseleave',
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        this.classList.toggle('tk-form--addon-hover', hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === 'number';
        if (isNumberInput) this.fieldElement.setAttribute('type', 'text');
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute('type', 'number');
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: 'mousedown',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'mouseup',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchstart',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchend',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error('Missing input element');
        if (event.type === 'mousedown' || event.type === 'touchstart') this.fieldElement.type = 'text';
        else this.fieldElement.type = 'password';
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error('No element found');
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error('Missing addon');
        const addonType = this.addonElement.getAttribute('data-tk-addon');
        if (addonType !== 'prefix' && addonType !== 'suffix') throw new Error('Wrong addon type');
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector('option:checked');
            const isPlaceholderOption = selectedOption?.hasAttribute('data-tk-empty-option');
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === '';
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            this.labelElement.removeAttribute('style');
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.paddingInline = '0';
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = '0';
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === 'suffix' ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === 'prefix') this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === 'suffix') this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === 'number';
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === 'focusin') this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error('Missing label element');
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener('transitionend', this.onTransitionEnd);
    }
}



class $de3d73f629613f16$export$2e2bcd8739ae039 extends (0, $0b37eca09bdd445d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.select = this.querySelector('select');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.range = this.querySelector('input[type="range"]');
        this.number = this.querySelector('input[type="number"]');
        this.noEnterInput = this.querySelector('input[type="email"]') || this.querySelector('input[type="text"]') || this.querySelector('input[type="number"]');
        this.evt = new Event('change');
    }
    connectedCallback() {
        super.connectedCallback();
        const onSelectChange = this.handleSelectChange.bind(this);
        const onCheckboxChange = this.handleCheckboxChange.bind(this);
        const onRangeChange = this.handleRangeChange.bind(this);
        const onNumberInputChange = this.handleNamberInputChange.bind(this);
        if (this.select) {
            this.pushListener({
                event: 'change',
                element: this.select,
                action: onSelectChange
            });
            this.handleSelectChange();
        }
        if (this.checkbox) this.pushListener({
            event: 'change',
            element: this.checkbox,
            action: onCheckboxChange
        });
        if (this.range) this.pushListener({
            event: 'change',
            element: this.range,
            action: onRangeChange
        });
        if (this.number) this.pushListener({
            event: 'change',
            element: this.number,
            action: onNumberInputChange
        });
        if (this.noEnterInput) this.pushListener({
            event: 'keydown',
            element: this.noEnterInput,
            action: this.handleKeydown.bind(this)
        });
    }
    /**
     * Handles changes to the select element.
     * Toggles the 'tk-form-select--filled' class based on the select element's value.
     */ handleSelectChange() {
        if (!this.select) return;
        this.classList.toggle('tk-form-select--filled', this.select.value !== '');
    }
    /**
     * Handles changes to the checkbox element.
     */ handleCheckboxChange() {
        if (!this.checkbox) return;
        // Checkboxen
        if (this.hasAttribute('data-form-switch-url')) location.href = this.dataset.formSwitchUrl;
        if (this.checkbox.hasAttribute('data-checkbox-toggle-master')) this.toggleAllCheckboxes(this.checkbox, this.checkbox.checked);
        if (this.checkbox.hasAttribute('data-checkbox-toggle')) this.toggleMasterCheckbox(this.checkbox);
    }
    /**
     * Handles changes to the range element.
     */ handleRangeChange() {
        if (!this.range) return;
        // Range Toggler
        if (this.range.hasAttribute('data-range-toggle-master')) this.toggleAllRanges(this.range, this.range.value);
        this.range.hasAttribute('data-range-toggle');
    }
    // Checkboxes
    toggleAllCheckboxes(toggler, status) {
        const allCheckboxes = document.querySelectorAll('input[data-checkbox-toggle]');
        Array.from(allCheckboxes).forEach((box)=>{
            if (box.checked !== status && !box.disabled) box.checked = status;
        });
    }
    toggleMasterCheckbox(box) {
        const masterCheckbox = document.querySelector('input[data-checkbox-toggle-master]');
        const isChecked = box.checked;
        if (!isChecked) masterCheckbox.checked = false;
    }
    // Range Toggler
    toggleAllRanges(toggler, val) {
        const allRanges = document.querySelectorAll('input[data-range-toggle]');
        Array.from(allRanges).forEach((range)=>{
            if (range.value !== val && !range.disabled) {
                range.value = val;
                range.click();
            // range.dispatchEvent(this.evt);
            }
        });
        if (toggler.closest('#approval-form') && val === '1') {
            const appForm = toggler.closest('#approval-form');
            appForm.querySelector('.tk-tabs-accordion').classList.add('tk-tabs-accordion--active');
            appForm.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]').classList.remove('tk-icon-add');
            appForm.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]').classList.add('tk-icon-remove');
        } else {
            const appForm = toggler.closest('#approval-form');
            appForm.querySelector('.tk-tabs-accordion').classList.remove('tk-tabs-accordion--active');
            appForm.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]').classList.remove('tk-icon-remove');
            appForm.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]').classList.add('tk-icon-add');
        }
        if (toggler.closest('.approval-form-header')) {
            const appFormHeader = toggler.closest('.approval-form-header');
            if (val === '0') {
                appFormHeader.querySelector('.tk-form-textarea').classList.remove('hidden');
                appFormHeader.querySelector('.tk-form-textarea textarea').setAttribute('required', 'required');
                appFormHeader.querySelector('kdmz-action').removeAttribute('hidden');
            } else {
                if (val === '2') appFormHeader.querySelector('kdmz-action').removeAttribute('hidden');
                else appFormHeader.querySelector('kdmz-action').setAttribute('hidden', '');
                appFormHeader.querySelector('.tk-form-textarea').classList.add('hidden');
                appFormHeader.querySelector('.tk-form-textarea textarea').removeAttribute('required');
            }
        }
    }
    toggleMasterRange(range) {
        const masterRange = document.querySelector('input[data-range-toggle-master]');
        const val = Number(range.value);
        if (val) masterRange.value = String(val);
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required') || this.fieldElement.closest('.o-toggle-info') || this.labelElement.textContent.includes('*') || this.fieldElement.hasAttribute('data-required-has-flag') && this.fieldElement.dataset.requiredHasFlag == 'false') return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    handleNamberInputChange() {
        if (!this.number) return;
        this.number.value = this.number.value.replace(/"/g, ()=>{
            let i = 0;
            return i++ % 2 === 0 ? "\u201C" : "\u201D";
        });
        const value = parseFloat(this.number.value.replace(/,/g, '.'));
        const stepAttr = this.number.getAttribute('step');
        const minAttr = this.number.getAttribute('min');
        const maxAttr = this.number.getAttribute('max');
        const step = stepAttr ? parseFloat(stepAttr) : 1;
        const min = minAttr ? parseFloat(minAttr) : step;
        const max = maxAttr ? parseFloat(maxAttr) : 0;
        if (!isNaN(value)) {
            const rounded = this.roundToStep(value, step, min, max);
            if (rounded > min) this.number.value = rounded.toString();
            else this.number.value = min.toString();
            if (max > 0 && rounded > max) this.number.value = max.toString();
        }
    }
    // Hilfsfunktion zum Runden auf das nächste Vielfache von "step" ab "min"
    roundToStep(value, step, min, max) {
        // return Math.round((value - min) / step) * step + min;
        const returnVal = Math.ceil((value - min) / step) * step + min;
        if (returnVal > max && max > 0) (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, 'Maximalmenge erreicht');
        return returnVal > max && max > 0 ? max : returnVal;
    }
    handleKeydown(event) {
        const form = this.closest('form');
        if (event.key === 'Enter' && form?.hasAttribute('do-not-send-on-enter')) {
            event.preventDefault();
            this.noEnterInput?.blur();
        }
    }
}


/* eslint-disable max-len */ 

class $763de6560a1ce432$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('button');
        this.action = this.getAttribute('data-tk-action') || window.location.href;
        this.selectbox = this.closest('.kdmz-selectbox') || undefined;
        this.selectboxhead = this.querySelector('[data-tk-select-box-head]') || undefined;
        this.selectboxbody = this.querySelector('[data-tk-select-box-body]') || undefined;
        this.selectboxHeadSelector = '[data-tk-select-box-head]';
        this.selectlistSelector = '.select-list';
        this.selectedClass = 'is-selected';
        this.openClass = 'is-open';
        this.doneTypingInterval = 750;
        this.currentSelector = undefined;
    }
    connectedCallback() {
        if (!this.selectbox || !this.selectboxhead || !this.selectboxbody) throw new Error('KDMZSelectBox: Selectbox is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const open = this.open.bind(this);
        const pickCheckboxValue = this.pickCheckboxValue.bind(this);
        this.setValuesToField(undefined, true);
        this.pushListener({
            event: 'click',
            element: this.selectboxhead,
            action: open
        });
        this.pushListener({
            event: 'click',
            element: this.selectboxbody,
            action: pickCheckboxValue
        });
        this.doneTyping(this.doneTypingInterval, this.querySelector('.selectbox-body-search input[type="text"]'));
    }
    open(event) {
        if (!event.target) return;
        this.classList.toggle('is-open');
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    close(event) {
        if (!this.selectboxhead || !this.selectboxbody) return;
        const buttonRect = this.selectboxhead.getBoundingClientRect();
        const dropdownRect = this.selectboxbody.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove('is-open');
            this.removeListener(window);
        }
    }
    pickCheckboxValue(event) {
        if (!event.target) return;
        const _target = event.target;
        if (_target !== null) this.setValuesToField(_target.closest(`${this.selectlistSelector} [type="checkbox"]`));
    }
    /* uebernommen aus kdmz2 */ setValuesToField(elem, onstart) {
        const delimiter = this.dataset.opDelimiter ? this.dataset.opDelimiter : ';';
        const selectBoxType = this.dataset.selectboxType ? this.dataset.selectboxType : 'multi';
        const textfield = this.querySelector(`${this.selectboxHeadSelector} input[data-type="values"]`);
        if (!textfield) return;
        textfield.value = '';
        const showSelected = this.querySelector(`${this.selectboxHeadSelector} input.show-selected`);
        if (!showSelected) return;
        showSelected.value = '';
        const checkboxes = this.querySelectorAll('[type="checkbox"]:checked');
        const checkboxesChecked = this.querySelectorAll('[type="checkbox"]:checked');
        const values = [];
        const valueNames = [];
        if (selectBoxType === 'single' && elem != null) {
            // einfache Selectbox
            const origElem = elem.cloneNode(true);
            checkboxes.forEach((checkbox)=>{
                checkbox.checked = false;
            });
            if (origElem.checked === true && elem != null) {
                elem.checked = true;
                values.push(elem.value);
                const labelText = elem.closest('li')?.querySelector('label')?.innerText;
                if (!labelText) return;
                valueNames.push(labelText);
            }
            this.classList.remove('is-open');
        } else // einfache Multi-Selectbox
        checkboxesChecked.forEach((checkbox)=>{
            values.push(checkbox.value);
            const labelText = checkbox.closest('li')?.querySelector('label')?.innerText;
            if (!labelText) return;
            valueNames.push(labelText);
        });
        if (values.length === 1) showSelected.value = valueNames.join();
        else if (values.length > 1) showSelected.value = `${valueNames.length} selected`;
        textfield.value = values.join(delimiter);
    // if (!onstart && this.closest(".form-switcher")){
    //     // console.log("fire change");
    //     const event = new Event("change");
    //     // Dispatch the event.
    //     this.closest<HTMLElement>(".form-switcher").dispatchEvent(event);
    // }
    }
    // eslint-disable-next-line class-methods-use-this
    searchBoxSearch(selector) {
        const input = selector;
        const filter = input.value.toUpperCase();
        const list = selector.closest('[data-tk-select-box-body]')?.querySelector('.select-list');
        const labels = list?.getElementsByTagName('label');
        if (labels) for(let i = 0; i < labels.length; i++){
            const txtValue = labels[i].textContent || labels[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) labels[i].closest('li')?.classList.remove('hidden');
            else labels[i].closest('li')?.classList.add('hidden');
        }
        if (list.querySelectorAll('li.hidden').length === list.querySelectorAll('li').length) {
            const xy = selector.closest('.selectbox-body-search')?.querySelector('.no-result');
            xy.style.display = '';
        } else {
            const xy = selector.closest('.selectbox-body-search')?.querySelector('.no-result');
            xy.style.display = 'none';
        }
    }
    doneTyping(interval, selector) {
        const typingTimer = 0;
        const doneTypingInterval = interval;
        const searchBoxKeyup = this.searchBoxKeyup.bind(this, selector, typingTimer, doneTypingInterval);
        const searchBoxReset = this.searchBoxReset.bind(this, selector);
        this.pushListener({
            event: 'keyup',
            element: selector,
            action: searchBoxKeyup
        });
        const selectorParent = selector.parentElement;
        if (selectorParent) {
            const resetBtn = selectorParent.querySelector('.reset-button');
            if (resetBtn) this.pushListener({
                event: 'click',
                element: resetBtn,
                action: searchBoxReset
            });
        }
    }
    searchBoxKeyup(selector, typingTimer, doneTypingInterval, event) {
        clearTimeout(typingTimer);
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
            this.currentSelector = selector;
            // eslint-disable-next-line no-param-reassign
            typingTimer = setTimeout(this.searchBoxSearch.bind(this, selector), doneTypingInterval);
        }
    }
    searchBoxReset(selector, event) {
        event.preventDefault();
        selector.value = '';
        this.searchBoxSearch(selector);
    }
}




class $e2ef3a30975e463c$export$2e2bcd8739ae039 extends (0, $2215c02a950e9fbf$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.web2print = this.hasAttribute('data-web2print-dialog');
        this.shouldFullTop = this.hasAttribute('data-tk-should-full-top');
        this.fullTopClassName = this.getAttribute('data-tk-full-top-class-name') || 'tk-dialog--full-top';
        this.breakpointClassName = this.getAttribute('data-tk-breakpoint-class-name') || '';
    }
    async openDialog(url) {
        if (this.hasAttribute('data-tk-validate-form')) {
            const validator = this.closest('tk-form-validator');
            if (!validator || !await validator.isFormValid()) return;
        }
        super.openDialog(url);
    }
    handleUrlAndDialogs(url) {
        if (this.forceReloadContent) this.dialogs = this.dialogs.filter(({ dialog: dialog })=>dialog.isConnected);
        super.handleUrlAndDialogs(url);
    }
    createDialog(url) {
        const dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''} ${this.shouldFullTop ? this.fullTopClassName : ''} ${this.breakpointClassName ? this.breakpointClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
        this.dialog = dialog;
        if (this.web2print) this.handleIframe();
    }
    handleIframe() {
        const iframe = this.dialog.querySelector('iframe');
        iframe.contentWindow.parent.parent.addEventListener('message', (e)=>{
            const json = JSON.parse(e.data.arr);
            const data = {
                postit_json: JSON.stringify(json.data),
                postit_pdf: json.pdf,
                postit_jpg: json.jpg,
                postit_name: json.name,
                postit_valid: json.valid,
                postit_quantity: json.quantity
            };
            const setDataURLElement = document.querySelector('#web2print-setdata-url');
            if (setDataURLElement) {
                const setDataURL = setDataURLElement.getAttribute('data-url');
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: setDataURL,
                    payload: data,
                    resolveHandler: this.iframeSave.bind(this)
                });
            }
        });
    }
    iframeSave() {
        const setDataURLElement = document.querySelector('#web2print-setdata-url');
        if (setDataURLElement) {
            const redirectURL = setDataURLElement.getAttribute('data-redirect-url');
            window.location = redirectURL;
        } else window.location.reload();
    }
    hookAfterShowModal(dialog) {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>(0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(dialog, this.forceReloadContent));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions(DialogActions.RESET_FORM, button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions(DialogActions.JUMP_FORWARD, button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions(DialogActions.JUMP_BACKWARD, button));
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions(DialogActions.JUMP_TO, button));
        if (this.web2print) {
            const detailBody = this.closest('.module-article__detail-body');
            if (detailBody) {
                this.web2printAmountField = detailBody.querySelector('#field1');
                this.web2printAmount = this.web2printAmountField.value;
                const iframe = dialog.querySelector('iframe');
                if (iframe) {
                    const iframeURL = new URL(iframe.src);
                    iframeURL.searchParams.set('quantity', this.web2printAmount);
                    iframe.src = iframeURL.toString();
                }
            }
        }
    }
}





class $c4a19a6c31c5e0c8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.quantityField = this.querySelector('[name="input_dim1"], [data-tk-input-quantity]') || undefined;
        this.submitButton = this.querySelector('[type="submit"]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.formular = this.querySelector('form') || undefined;
        this.url = this.getAttribute('data-url') || '';
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
        }
    }
    connectedCallback() {
        if (!this.formular) throw new Error('KDMZBasketButton: Formular is missing!');
        this.registerEventListener();
        this.registerCounter();
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        const onAmountChange = this.amountChange.bind(this);
        this.pushListener({
            event: 'change',
            element: this.counter,
            action: onAmountChange
        });
        const onDecrease = this.decrease.bind(this);
        this.pushListener({
            event: 'click',
            element: this.decreaser,
            action: onDecrease
        });
        const onIncrease = this.increase.bind(this);
        this.pushListener({
            event: 'click',
            element: this.increaser,
            action: onIncrease
        });
    }
    amountChange() {
        if (!this.counter) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) this.counter.value = String(max);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    registerEventListener() {
        this.pushListener({
            event: 'submit',
            element: this.formular,
            action: this.submitForm.bind(this)
        });
        this.quantityField?.addEventListener('focus', (event)=>{
            setTimeout(()=>{
                this.quantityField?.select();
            }, 0);
        });
    }
    submitForm(event) {
        const isQuickAdd = this.closest('.tk-quick-order') || undefined;
        if (isQuickAdd) {
            event.preventDefault();
            this.submitFormQuickAddAsync();
        }
        console.log('submit');
    }
    submitFormQuickAddAsync() {
        const payload = {
            input_dim1: this.quantityField.value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            payload: payload,
            resolveHandler: this.handleSuccessQuickAddResponse.bind(this)
        });
    }
    handleSuccessQuickAddResponse(response) {
        if (response && response.dataAsJson.success) (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, response.dataAsJson.message);
    }
    submitFormAsync() {
        const payload = {
            input_dim1: this.quantityField.value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            payload: payload,
            resolveHandler: this.handleSuccessResponse.bind(this)
        });
    }
    handleSuccessResponse(response) {
        if (response && response.success) {
            const html = response.dataAsHtml;
            this.innerHTML = html;
        }
    }
}




class $f3affdfd84b20bf3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    connectedCallback() {
        this.registerClickListener();
    }
    registerClickListener() {
        this.pushListener({
            event: 'click',
            element: this,
            action: this.switchLayout.bind(this)
        });
    }
    switchLayout(event) {
        if (event.target.closest('[data-tile-img-url]')) {
            const url = event.target.closest('[data-tile-img-url]').getAttribute('data-tile-img-url');
            const payload = {};
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: payload,
                resolveHandler: this.handleSuccessResponse.bind(this)
            });
        }
    }
    handleSuccessResponse(response) {
        if (response && response.success) {
            const html = response.dataAsHtml;
            if (html.trim() != '') this.innerHTML = html;
        }
    }
    handleErrorResponse(error) {
        console.error(error);
    }
}




class $e39997aa55c5a766$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.controls = [], /**
     * Submit-Buttons, die die Submit-Aktion setzen.
     */ this.submitButtons = [], /**
     * Kontofelder, deren zugehörige Kostenstellenfelder über
     * data-accounting-visibility definiert werden.
     */ this.accountingFields = [], /**
     * Aktive Async-Requests pro Visibility-Target.
     *
     * Wird verwendet, um bei einer erneuten Änderung eines Controls
     * den vorherigen Request als veraltet zu markieren.
     */ this.asyncRequests = new Map(), this.handleChange = (event)=>{
            this.update();
            if (event.type !== 'change' || !(event.currentTarget instanceof HTMLInputElement)) return;
            const control = event.currentTarget;
            if (control.type !== 'checkbox' || !control.checked) return;
            this.autofillFields(control);
        };
    }
    connectedCallback() {
        this.controls = Array.from(this.querySelectorAll('input[type="checkbox"][data-visibility-target], input[type="radio"][data-visibility-target], input[type="number"][data-visibility-target]'));
        this.controls.forEach((control)=>{
            control.addEventListener('change', this.handleChange);
            control.addEventListener('input', this.handleChange);
        });
        // Kontofelder anhand des Data-Attributs ermitteln.
        this.accountingFields = Array.from(document.querySelectorAll('input[data-accounting-visibility]'));
        // Änderungen der Kontonummern ebenfalls berücksichtigen.
        this.accountingFields.forEach((field)=>{
            field.addEventListener('change', this.handleChange);
            field.addEventListener('input', this.handleChange);
        });
        // Ursprünglichen Required-Zustand speichern.
        this.rememberRequiredFields();
        // Initialen Zustand setzen.
        this.update();
    }
    disconnectedCallback() {
        this.controls.forEach((control)=>{
            control.removeEventListener('change', this.handleChange);
            control.removeEventListener('input', this.handleChange);
        });
        this.accountingFields.forEach((field)=>{
            field.removeEventListener('change', this.handleChange);
            field.removeEventListener('input', this.handleChange);
        });
        this.submitButtons.forEach((button)=>{
            button.removeEventListener('click', this.handleSubmitButtonClick);
        });
        this.asyncRequests.clear();
        this.controls = [];
        this.accountingFields = [];
        this.submitButtons = [];
        this.submitActionField = undefined;
    }
    autofillFields(control) {
        const targetName = control.dataset.visibilityTarget;
        const form = this.closest('form');
        if (!targetName || !form) return;
        const target = form.querySelector(`[data-visibility-id="${CSS.escape(targetName)}"]`);
        if (!target) return;
        if (target.hasAttribute('data-visibility-restore-defaults')) target.querySelectorAll('input[type="text"]').forEach((field)=>{
            if (field.value.trim() !== '' || field.defaultValue === '') return;
            field.value = field.defaultValue;
            field.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        });
        target.querySelectorAll('[data-autofill-from]').forEach((targetField)=>{
            if (targetField.value.trim() !== '') return;
            const sourceIds = targetField.dataset.autofillFrom?.split(/\s+/).filter(Boolean) ?? [];
            const sourceValues = sourceIds.map((sourceId)=>form.querySelector(`#${CSS.escape(sourceId)}`)?.value.trim() ?? '').filter(Boolean);
            if (sourceValues.length === 0) return;
            targetField.value = sourceValues.join(' ');
            targetField.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        });
    }
    /**
     * Merkt sich für jedes Formularfeld innerhalb eines
     * Visibility-Targets, ob es ursprünglich required war.
     *
     * Der Zustand wird direkt am Feld gespeichert.
     * Dadurch kann required später zuverlässig wiederhergestellt werden,
     * auch nachdem das Attribut entfernt wurde.
     */ rememberRequiredFields() {
        const targets = document.querySelectorAll('[data-visibility-id]');
        targets.forEach((target)=>{
            const fields = target.querySelectorAll('input, select, textarea');
            fields.forEach((field)=>{
                if (field.hasAttribute('required')) field.dataset.originalRequired = 'true';
            });
        });
    }
    update() {
        const targetNames = new Set();
        // Alle verwendeten Targets ermitteln.
        this.controls.forEach((control)=>{
            const targetName = control.dataset.visibilityTarget;
            if (targetName) targetNames.add(targetName);
        });
        // Targets ein- oder ausblenden.
        targetNames.forEach((targetName)=>{
            const targets = document.querySelectorAll(`[data-visibility-id="${targetName}"]`);
            const controlsForTarget = this.controls.filter((control)=>control.dataset.visibilityTarget === targetName);
            const shouldShow = controlsForTarget.some((control)=>{
                // Bestehende Logik für Checkboxen und Radio-Buttons.
                if (control.type === 'checkbox' || control.type === 'radio') return control.checked;
                // Logik für numerische Inputfelder:
                // Nur Werte > 0 aktivieren das Target.
                if (control.type === 'number') {
                    const value = control.value.trim();
                    if (value === '') return false;
                    const numericValue = Number(value);
                    return Number.isFinite(numericValue) && numericValue > 0;
                }
                return false;
            });
            targets.forEach((target)=>{
                const wasHidden = target.hasAttribute('hidden');
                if (shouldShow) {
                    target.removeAttribute('hidden');
                    // Async-Inhalt laden bzw. aktualisieren.
                    this.updateAsyncTarget(target);
                } else {
                    // Nur beim Übergang von sichtbar zu versteckt leeren.
                    if (!wasHidden) this.resetFields(target);
                    target.setAttribute('hidden', '');
                    // Eventuell noch laufenden Async-Request verwerfen.
                    this.invalidateAsyncRequest(target);
                }
            });
        });
        // Required-Zustände aktualisieren.
        this.updateRequiredFields();
        // Spezielle Visibility-Regeln aktualisieren.
        this.updateSpecialVisibility();
        // CSS-Klassen für den Body aktualisieren.
        this.updateBodyClasses();
    }
    /**
     * Aktualisiert CSS-Klassen auf dem <body>-Element anhand
     * der überwachten Formularfelder.
     *
     * Ein Formularfeld kann über data-visibility-body-class definieren,
     * welcher Klassenname verwendet werden soll.
     *
     * Bei Checkboxen und Radio-Buttons wird die Klasse anhand des Wertes
     * erzeugt. Bei Number-Inputs wird der aktuelle Zahlenwert verwendet.
     */ updateBodyClasses() {
        const body = document.body;
        if (!body) return;
        this.controls.forEach((control)=>{
            const className = control.dataset.visibilityBodyClass;
            if (!className) return;
            // Checkboxen und Radio-Buttons.
            if (control.type === 'checkbox' || control.type === 'radio') {
                const valueClass = control.value ? `${className}-${control.value}` : className;
                if (control.checked) body.classList.add(valueClass);
                else body.classList.remove(valueClass);
                return;
            }
            // Number-Inputs.
            if (control.type === 'number') {
                const value = control.value.trim();
                // Alle vorhandenen Value-Klassen dieses Controls entfernen.
                const existingClasses = Array.from(body.classList).filter((bodyClass)=>bodyClass.startsWith(`${className}-`));
                existingClasses.forEach((bodyClass)=>{
                    body.classList.remove(bodyClass);
                });
                // Bei leerem Wert keine Klasse setzen.
                if (value === '') return;
                const numericValue = Number(value);
                // Nur gültige Werte als CSS-Klasse verwenden.
                if (!Number.isFinite(numericValue)) return;
                body.classList.add(`${className}-${value}`);
            }
        });
    }
    /**
     * Enthält spezielle Visibility-Regeln, die nicht über
     * data-visibility-target gesteuert werden.
     *
     * Weitere Sonderfälle können hier zentral ergänzt werden.
     */ updateSpecialVisibility() {
        this.updateFilialanschlussVisibility();
        this.updateAccountingVisibility();
        this.updateDisabledTargets();
        this.updateEnabledTargets();
    // Weitere Sonderfälle hier ergänzen:
    // this.updateAnotherSpecialVisibility();
    }
    /**
     * Steuert die spezielle Progress-Ansicht für den Filialanschluss.
     *
     * Wenn "filialanschluss-yes" ausgewählt ist:
     * - opc-progress-view-wrapper--short wird versteckt.
     * - opc-progress-view-wrapper--long wird angezeigt.
     *
     * Bei Abwahl wird der Zustand umgekehrt.
     */ updateFilialanschlussVisibility() {
        const filialanschlussYes = document.querySelector('input[type="radio"][name="filialanschluss"][value="yes"], input[type="radio"][id="filialanschluss-yes"]');
        const shortWrapper = document.querySelector('.opc-progress-view-wrapper--short');
        const longWrapper = document.querySelector('.opc-progress-view-wrapper--long');
        if (!filialanschlussYes || !shortWrapper || !longWrapper) return;
        const isSelected = filialanschlussYes.checked;
        shortWrapper.toggleAttribute('hidden', isSelected);
        longWrapper.toggleAttribute('hidden', !isSelected);
    }
    /**
     * Steuert die Sichtbarkeit der Kostenstellenfelder anhand
     * der ersten Ziffer des zugehörigen Kontos.
     *
     * Die Zuordnung erfolgt über data-accounting-visibility am Kontofeld.
     * Der Attributwert entspricht der ID des Kostenstellenfeldes.
     *
     * Die Kostenstelle wird nur angezeigt, wenn die Kontonummer
     * mit 3 oder 4 beginnt.
     */ updateAccountingVisibility() {
        this.accountingFields.forEach((accountField)=>{
            const costCenterFieldId = accountField.dataset.accountingVisibility;
            if (!costCenterFieldId) return;
            const costCenterField = document.getElementById(costCenterFieldId);
            const costCenterColumn = costCenterField?.closest('.opc-col');
            if (!costCenterColumn) return;
            const firstCharacter = accountField.value.charAt(0);
            costCenterColumn.toggleAttribute('hidden', firstCharacter !== '3' && firstCharacter !== '4');
        });
    }
    /**
     * Aktualisiert den asynchronen Inhalt eines Visibility-Targets.
     *
     * Ein Target kann beispielsweise so definiert werden:
     *
     * <div
     *     data-visibility-id="attachments-Terminal1"
     *     data-visibility-async-url="/attachments"
     *     hidden
     * >
     * </div>
     *
     * Die zugehörigen Controls liefern die Payload-Parameter:
     *
     * data-visibility-target-async-url-param="article"
     * data-visibility-target-async-url-param-value="1234"
     *
     * Mehrere gleiche Parameter werden zu einem String zusammengefasst.
     */ updateAsyncTarget(target) {
        const url = target.dataset.visibilityAsyncUrl;
        if (!url) return;
        const targetName = target.dataset.visibilityId;
        if (!targetName) return;
        const controlsForTarget = this.controls.filter((control)=>control.dataset.visibilityTarget === targetName);
        const delimiter = target.dataset.visibilityAsyncParamDelimiter ?? ',';
        const payload = this.collectAsyncPayload(controlsForTarget, delimiter);
        this.loadAsyncTarget(target, url, payload);
    }
    /**
     * Sammelt die Parameter für einen Async-Request.
     *
     * Gleiche Parameternamen werden zusammengefasst.
     *
     * Beispiel:
     * article=1234
     * article=3456
     * kategorie=terminal
     *
     * ergibt:
     * {
     *     article: '1234,3456',
     *     kategorie: 'terminal'
     * }
     */ collectAsyncPayload(controls, delimiter) {
        const valuesByParameter = new Map();
        controls.forEach((control)=>{
            const paramName = control.dataset.visibilityTargetAsyncUrlParam;
            const paramValue = control.dataset.visibilityTargetAsyncUrlParamValue;
            if (!paramName || !paramValue) return;
            // Bei Number-Inputs nur Werte > 0 berücksichtigen.
            if (control.type === 'number') {
                const quantity = Number(control.value);
                if (!Number.isFinite(quantity) || quantity <= 0) return;
            }
            const values = valuesByParameter.get(paramName) ?? [];
            values.push(paramValue);
            valuesByParameter.set(paramName, values);
        });
        return Object.fromEntries(Array.from(valuesByParameter.entries()).map(([name, values])=>[
                name,
                values.join(delimiter)
            ]));
    }
    /**
     * Führt den Async-Request für ein Target aus.
     *
     * Ein neuer Request macht den vorherigen Request für dasselbe
     * Target ungültig. Dadurch kann ein verspätetes Ergebnis eines
     * älteren Requests nicht mehr den aktuellen Inhalt überschreiben.
     */ loadAsyncTarget(target, url, payload) {
        const requestId = Symbol();
        this.asyncRequests.set(target, requestId);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            payload: payload,
            resolveHandler: (result)=>{
                if (this.asyncRequests.get(target) !== requestId) return;
                this.asyncRequests.delete(target);
                target.innerHTML = result.dataAsHtml;
                this.rememberRequiredFields();
                this.updateRequiredFields();
            }
        });
    }
    /**
     * Macht einen eventuell laufenden Request für ein Target ungültig.
     *
     * Da fetchRequest hier keinen AbortController entgegennimmt,
     * wird der Request nicht technisch abgebrochen.
     * Sein Ergebnis wird aber ignoriert, wenn inzwischen ein neuer
     * Request gestartet wurde oder das Target ausgeblendet wurde.
     */ invalidateAsyncRequest(target) {
        this.asyncRequests.delete(target);
    }
    /**
     * Leert alle Formularfelder innerhalb eines ausgeblendeten Bereichs.
     *
     * Hidden-Felder werden grundsätzlich nicht verändert.
     */ resetFields(target) {
        const fields = target.querySelectorAll('input, select, textarea');
        fields.forEach((field)=>{
            if (field instanceof HTMLInputElement) {
                // Hidden-Felder niemals zurücksetzen.
                if (field.type === 'hidden') return;
                if (field.type === 'checkbox' || field.type === 'radio') field.checked = false;
                else field.value = '';
            } else if (field instanceof HTMLSelectElement) {
                field.selectedIndex = -1;
                if (field.closest('.tk-form-select--filled')) field.closest('.tk-form-select--filled')?.classList.remove('tk-form-select--filled');
            } else if (field instanceof HTMLTextAreaElement) field.value = '';
        });
    }
    /**
     * Entfernt required aus versteckten Bereichen
     * und stellt es bei sichtbaren Bereichen wieder her.
     *
     * Es werden ausschließlich Felder berücksichtigt,
     * die beim Initialisieren ursprünglich required waren.
     */ updateRequiredFields() {
        const fields = document.querySelectorAll("[data-visibility-id] input, [data-visibility-id] select, [data-visibility-id] textarea");
        fields.forEach((field)=>{
            // Ursprünglich nicht required: nichts verändern.
            if (field.dataset.originalRequired !== 'true') return;
            const hiddenParent = field.closest('[hidden]');
            if (hiddenParent) field.removeAttribute('required');
            else field.setAttribute('required', '');
        });
    }
    /**
     * Aktiviert oder deaktiviert Elemente abhängig vom Zustand
     * eines Radio-Buttons oder einer Checkbox.
     *
     * Das auslösende Feld definiert über data-disabled-target,
     * welche Elemente gesteuert werden sollen.
     *
     * Die Ziele werden über data-disabled-id identifiziert.
     *
     * Der Zustand wird bereits bei der Initialisierung berücksichtigt.
     */ updateDisabledTargets() {
        const controls = this.querySelectorAll('input[type="checkbox"][data-disabled-target], input[type="radio"][data-disabled-target]');
        controls.forEach((control)=>{
            const targetName = control.dataset.disabledTarget;
            if (!targetName) return;
            const targets = document.querySelectorAll(`[data-disabled-id="${targetName}"]`);
            targets.forEach((target)=>{
                if (target instanceof HTMLButtonElement || target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement) target.disabled = control.checked;
            });
        });
    }
    /**
     * Aktiviert Elemente abhängig vom Zustand eines Radio-Buttons
     * oder einer Checkbox.
     *
     * Das auslösende Feld definiert über data-enabled-target,
     * welche Elemente gesteuert werden sollen.
     *
     * Die Ziele werden über data-enabled-id identifiziert.
     *
     * Ist das auslösende Feld aktiviert, werden die Ziele aktiviert.
     * Bei Deaktivierung des auslösenden Feldes werden die Ziele deaktiviert.
     *
     * Der Zustand wird bereits bei der Initialisierung berücksichtigt.
     */ updateEnabledTargets() {
        const controls = this.querySelectorAll('input[type="checkbox"][data-enabled-target], input[type="radio"][data-enabled-target]');
        controls.forEach((control)=>{
            const targetName = control.dataset.enabledTarget;
            if (!targetName) return;
            const targets = document.querySelectorAll(`[data-enabled-id="${targetName}"]`);
            targets.forEach((target)=>{
                if (target instanceof HTMLButtonElement || target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement) target.disabled = !control.checked;
            });
        });
    }
}










class $3e1dc1b971ea6577$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: 'tk-manager',
                constructor: (0, $aa35ef9547ba682e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-viewport',
                constructor: (0, $49fab39bf1404505$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracker',
                constructor: (0, $588d148f2c9ac202$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracking',
                constructor: (0, $0efda1b115753384$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-button-dropdown',
                constructor: (0, $29c96caf3d8dbc7c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-header',
                constructor: (0, $1352bbad447b1dc9$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-nav-sidebar',
                constructor: (0, $40898dd22403025f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-basket-button',
                constructor: (0, $bf823a090d476043$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-context-menu',
                constructor: (0, $259c506f0517ca0d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-flag',
                constructor: (0, $0d07f57cc5d15afe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-tile',
                constructor: (0, $21ae20c5af7baedb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-variants',
                constructor: (0, $21611c672b0d32ce$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tooltip',
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter',
                constructor: (0, $178b0b1cc6a532a3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-chip',
                constructor: (0, $c51b1a9a7c03f7bf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-result',
                constructor: (0, $4e5f7d9c5ffa7d20$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-dropdown',
                constructor: (0, $058daee80809af6c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-group-wrapper',
                constructor: (0, $6deb510fe3e19897$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-group',
                constructor: (0, $668e651a8805c9ff$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-search',
                constructor: (0, $c0415a55fc888360$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-select-reset',
                constructor: (0, $f21079be2cdb055f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-drilldown-button',
                constructor: (0, $b604e9d6535c82d7$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list',
                constructor: (0, $6406837936bc2cfc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-price',
                constructor: (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-stock',
                constructor: (0, $ad2181492f474118$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-tab',
                constructor: (0, $4bab5d27fa43c4fc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-button',
                constructor: (0, $2c226fea39ede692$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-info',
                constructor: (0, $1dbde1f973386300$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-element',
                constructor: (0, $de3d73f629613f16$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-validator',
                constructor: (0, $40812120dfc15f21$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-accordion',
                constructor: (0, $15716c1752b56a37$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-list-link',
                constructor: (0, $5163560edb86f711$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-button',
                constructor: (0, $69165974676831f6$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-carousel',
                constructor: (0, $2ef7b87a2ac1a70d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list-sort',
                constructor: (0, $d587f703cacf0ca0$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list-layout-switch',
                constructor: (0, $aae44772e434b2fe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-header-search',
                constructor: (0, $31cb0bc6f587a976$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-breadcrumb',
                constructor: (0, $4c4645f38df6caf9$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-select-box',
                constructor: (0, $763de6560a1ce432$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-dialog',
                constructor: (0, $e2ef3a30975e463c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-minibasket',
                constructor: (0, $83b244d711489b95$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-search',
                constructor: (0, $a9217f7f02c1b9b3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-table',
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-quick-order',
                constructor: (0, $7b256aa0b8661d27$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-basket-button',
                constructor: (0, $c4a19a6c31c5e0c8$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-freitext',
                constructor: (0, $f1b6481dbe8d89b9$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-product-tile',
                constructor: (0, $f3affdfd84b20bf3$export$2e2bcd8739ae039)
            },
            {
                name: 'kdmz-visibility-controller',
                constructor: (0, $e39997aa55c5a766$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-datepicker',
                constructor: (0, $e018ac17002873dc$export$2e2bcd8739ae039)
            }
        ]);
    }
}
new $3e1dc1b971ea6577$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=struct.js.map
